/* EDITOR LIBRE — varios elementos (imágenes y textos), movibles,
 * redimensionables y rotables dentro del recuadro de la zona. Sin mandarlo
 * al carrito todavía: es una pieza aparte.
 *
 * Copiado de Positivos, que a Xavi le gustó:
 *  - tiradores en las 4 esquinas del elemento SELECCIONADO (arriba-izq
 *    mueve, arriba-dcha gira, abajo-dcha redimensiona, abajo-izq borra);
 *  - cada tipo tiene su caja de opciones en el rail: la imagen (quitar
 *    fondo, voltear, duplicar, borrar) y el texto (fuente, color,
 *    negrita/cursiva/subrayado, duplicar, borrar);
 *  - las capas (ocultar/borrar/reordenar) son la pieza siguiente; el
 *    orden en `elementos` ya es el orden de apilado, de atrás a delante.
 */
(function () {
  'use strict';

  function limite(v, min, max) { return v < min ? min : v > max ? max : v; }

  // fuentes de Google para el texto, unas cuantas variadas como en Positivos
  /* Ordenadas para que las primeras que se ven ya sean variadas (Xavi:
     "faltaría más variedad"): una limpia, una de bloque, una caligráfica,
     una cómic… y no seis sans seguidas. 36 familias, todas de Google Fonts. */
  var FUENTES = [
    { n: 'Poppins', v: "'Poppins', sans-serif" },
    { n: 'Bloque', v: "'Anton', sans-serif" },
    { n: 'Boda', v: "'Great Vibes', cursive" },
    { n: 'Cómic', v: "'Bangers', cursive" },
    { n: 'Playfair', v: "'Playfair Display', serif" },
    { n: 'Rotulador', v: "'Permanent Marker', cursive" },
    { n: 'Impacto', v: "'Bebas Neue', sans-serif" },
    { n: 'Retro', v: "'Lobster', cursive" },
    { n: 'Gruesa', v: "'Alfa Slab One', serif" },
    { n: 'Manuscrita', v: "'Pacifico', cursive" },
    { n: 'Deportiva', v: "'Righteous', sans-serif" },
    { n: 'Casual', v: "'Caveat', cursive" },
    { n: 'Montserrat', v: "'Montserrat', sans-serif" },
    { n: 'Circo', v: "'Rye', serif" },
    { n: 'Caligrafía', v: "'Dancing Script', cursive" },
    { n: 'Futurista', v: "'Orbitron', sans-serif" },
    { n: 'Infantil', v: "'Fredoka', sans-serif" },
    { n: 'Terror', v: "'Creepster', cursive" },
    { n: 'Elegante', v: "'Cinzel', serif" },
    { n: 'Pincel', v: "'Kaushan Script', cursive" },
    { n: 'Condensada', v: "'Oswald', sans-serif" },
    { n: 'Rock', v: "'Metal Mania', cursive" },
    { n: 'Dibujada', v: "'Amatic SC', cursive" },
    { n: 'Militar', v: "'Black Ops One', cursive" },
    { n: 'Roboto', v: "'Roboto', sans-serif" },
    { n: 'Pixel', v: "'Press Start 2P', cursive" },
    { n: 'Redondeada', v: "'Baloo 2', cursive" },
    { n: 'Neón', v: "'Monoton', cursive" },
    { n: 'Merriweather', v: "'Merriweather', serif" },
    { n: 'Gorda', v: "'Titan One', cursive" },
    { n: 'Open Sans', v: "'Open Sans', sans-serif" },
    { n: 'Máquina', v: "'Special Elite', cursive" },
    { n: 'Lato', v: "'Lato', sans-serif" },
    { n: 'Firma', v: "'Yellowtail', cursive" },
    { n: 'Gótica', v: "'UnifrakturMaguntia', cursive" },
    { n: 'Década 70', v: "'Shrikhand', cursive" }
  ];

  /* Se cargan una sola vez para toda la página, y solo cuando hace falta
     (al poner el primer texto), no al abrir la ficha: son 22 familias de
     Google y pesan; la ficha carga más ligera y eso cuenta para el SEO. */
  function cargarFuentes() {
    if (document.getElementById('edl-fuentes')) return;
    var link = document.createElement('link');
    link.id = 'edl-fuentes';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&family=Roboto:ital,wght@0,400;0,700;1,700&family=Open+Sans:ital,wght@0,400;0,700;1,700&family=Lato:ital,wght@0,400;0,700;1,700&family=Montserrat:ital,wght@0,400;0,700;1,700&family=Merriweather:ital,wght@0,700;1,700&family=Playfair+Display:ital,wght@0,700;1,700&family=Oswald:wght@700&family=Bebas+Neue&family=Anton&family=Alfa+Slab+One&family=Lobster&family=Pacifico&family=Dancing+Script:wght@700&family=Great+Vibes&family=Caveat:wght@700&family=Permanent+Marker&family=Amatic+SC:wght@700&family=Baloo+2:wght@700&family=Fredoka:wght@600&family=Bangers&family=Righteous&family=Rye&family=Orbitron:wght@700&family=Creepster&family=Cinzel:wght@700&family=Kaushan+Script&family=Metal+Mania&family=Black+Ops+One&family=Press+Start+2P&family=Monoton&family=Titan+One&family=Special+Elite&family=Yellowtail&family=UnifrakturMaguntia&family=Shrikhand&display=swap';
    document.head.appendChild(link);
  }

  // un icono por tirador, para saber qué hace cada esquina sin adivinar
  var ICONOS = {
    mover: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 2v20M2 12h20M5 9l-3 3 3 3M19 9l3 3-3 3M9 5l3-3 3 3M9 19l3 3 3-3"/></svg>',
    girar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M3 12a9 9 0 1 1 3 6.7"/><path d="M3 18v-5h5"/></svg>',
    medir: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M16 4h4v4M4 20h4v-4M20 4l-7 7M4 20l7-7"/></svg>',
    borrar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>'
  };

  function rgbAHex(v) {
    if (!v) return null;
    var m = /rgb\((\d+),\s*(\d+),\s*(\d+)\)/.exec(v);
    if (!m) return v;
    return '#' + [m[1], m[2], m[3]].map(function (x) {
      return ('0' + parseInt(x, 10).toString(16)).slice(-2);
    }).join('');
  }

  function boton(clase, texto) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = clase;
    b.textContent = texto;
    return b;
  }

  function montar(host, opciones) {
    /* Vista previa de un tema sin publicar: la barra "Draft" de Shopify
       (un iframe pegado abajo) tapa la botonera. Se mide la barra REAL, no
       se da por hecha: en Chrome a veces no sale (Xavi, 29/09: "ha pasado
       algo raro"), y entonces la botonera va abajo del todo (editor-libre.css, --edl-previa). */
    try {
      var medirPrevia = function () {
        var f = document.getElementById('preview-bar-iframe');
        var alto = (f && f.offsetParent !== null) ? f.offsetHeight : 0;
        document.documentElement.style.setProperty('--edl-previa', (alto || 0) + 'px');
      };
      if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') {
        medirPrevia();
        var vecesPrevia = 0, tPrevia = setInterval(function () { medirPrevia(); if (++vecesPrevia > 12) clearInterval(tPrevia); }, 1000);
        window.addEventListener('resize', medirPrevia);
      }
    } catch (e) {}
    var o = opciones || {};
    var Col = window.Colocacion;
    if (!Col || !host || !o.prenda || !o.zona) return null;

    var ancho = o.ancho || 320;
    var color = o.colorHex || '#e9e9ee';

    /* Vistas: una por zona libre (izquierda, derecha, panorámica...). Cada
       vista tiene su propio fondo y sus propios elementos. La derecha de la
       taza es la foto de la izquierda en espejo (zona.espejo); la
       panorámica es otro dibujo (prenda_cara en colocacion.js), así que ahí
       no vale la foto y se usa el dibujo plano. */
    var vistas = (o.vistas && o.vistas.length ? o.vistas : [o.zona]);
    // registro URL blob: → Blob (para leerBlob). Se limpia al revocar la URL.
    var blobPorUrl = window.__blobPorUrl = window.__blobPorUrl || new Map();
    if (!URL.__registraBlobs) {
      URL.__registraBlobs = true;
      var crear0 = URL.createObjectURL, revocar0 = URL.revokeObjectURL;
      URL.createObjectURL = function (b) { var u = crear0.call(URL, b); try { blobPorUrl.set(u, b); } catch (e) { /* sin registro */ } return u; };
      URL.revokeObjectURL = function (u) { try { blobPorUrl.delete(u); } catch (e) { /* ya no está */ } return revocar0.call(URL, u); };
    }
    var zona, prendaId, p, usaFoto;
    /* La foto de cada vista: o.fotos[id] = { fondo, mascara, blanca, recuadro }
       (camiseta: pecho y espalda, cada una con la suya); si no hay, la foto
       general (taza: la misma foto para los dos lados, en espejo). */
    function fotoDe(z) {
      if (o.fotos && o.fotos[z.id]) {
        var f = o.fotos[z.id];
        /* objetos con una foto por color (el bolso): f.porColor[nombre del
           color] sustituye al fondo; si el color no tiene foto, la general */
        if (f.porColor && o.colorNombre && f.porColor[o.colorNombre]) {
          var g = {}; for (var k in f) g[k] = f[k];
          g.fondo = f.porColor[o.colorNombre];
          return g;
        }
        return f;
      }
      var pid = Col.prendaIdDe(o.prenda, z.cara || '');
      if (o.fotoFondo && pid === Col.prendaIdDe(o.prenda, '')) return { fondo: o.fotoFondo, mascara: o.fotoMascara, blanca: o.fotoBlanca, recuadro: o.fotoRecuadro };
      return null;
    }
    function fijarVista(z) {
      zona = z;
      prendaId = Col.prendaIdDe(o.prenda, z.cara || '');
      p = Col.prendaDe(prendaId);
      var f = fotoDe(z);
      usaFoto = !!(f && f.fondo);
      if (usaFoto) elegirFotos(f);
    }

    host.innerHTML = '';
    host.classList.add('edl__host');
    if (o.tintaFija) host.classList.add('edl__host--tinta');   // sello: una sola tinta, sin selectores de color

    // el lienzo (canvas + capa de elementos) y, debajo, la barra de vistas
    var edl = document.createElement('div');
    edl.className = 'edl';
    /* el visor: lo que recorta el lienzo cuando se hace zoom (Xavi, 29/09:
       "zoom+ y toda la zona personalizable ocupa el máximo posible; con
       zoom− vemos cómo queda"). Sin zoom no recorta nada. */
    var visor = document.createElement('div');
    visor.className = 'edl__visor';
    host.appendChild(visor);
    visor.appendChild(edl);

    var lienzo = document.createElement('canvas');
    edl.appendChild(lienzo);

    var capa = document.createElement('div');
    capa.className = 'edl__capa';
    edl.appendChild(capa);

    var tecnicas = (o.tecnicas && o.tecnicas.length) ? o.tecnicas : null;
    var tec = tecnicas ? tecnicas[0] : null;   // técnica de la vista que se está viendo; cada vista (zona) guarda la suya
    var tecPorVista = {}, tecElegida = {};   // tecElegida: zonas donde el cliente ya escogió técnica (no se cambia sola)
    var barraTec = null, infoTec = null;
    var barraVistas = null, botonesVista = {}, minis = {};
    if (vistas.length > 1) {
      barraVistas = document.createElement('div');
      barraVistas.className = 'edl__vistas';
      vistas.forEach(function (z) {
        var b = boton('edl__vistas__b', z.nombre || z.id);
        // miniatura con el fondo de esa vista (se pinta en pintarMinis)
        var mini = document.createElement('canvas');
        mini.className = 'edl__vistas__mini';
        b.insertBefore(mini, b.firstChild);
        minis[z.id] = mini;
        b.addEventListener('click', function () { cambiarVista(z); });
        botonesVista[z.id] = b;
        barraVistas.appendChild(b);
      });
      host.appendChild(barraVistas);
    }
    /* ---------- panel «Impresión» (productos con técnica de impresión) ----------
       Sustituye al botón «Nombres» de la barra: técnica, colores del logo (cambiar, quitar, reducir) y fondo blanco. */
    var panelImp = null, refrescarImpresion = null;
    // las imágenes de la zona que se está viendo (con `todas`, las de todas las zonas)
    function imagenesTec(todas) { return elementos.filter(function (e) { return e.tipo === 'imagen' && !e.fondo && (todas || vistaDe(e) === zona); }); }
    function reiniciarColores(el) { el.nCol = null; el.colQuita = null; el.colCambia = null; el.paleta = null; }
    function cerrarImpresion() { if (panelImp) { panelImp.remove(); panelImp = null; refrescarImpresion = null; historialCerrar('impresion'); } }
    function abrirImpresion() {
      if (!tecnicas) return;
      cerrarImpresion();
      var vel = document.createElement('div');
      // sin telón y sin bloquear la página: el diseño se sigue viendo (y tocando) mientras se cambian los colores
      vel.style.cssText = 'position:fixed;inset:0;background:transparent;pointer-events:none;z-index:100000;display:flex;align-items:flex-end;justify-content:center;';
      var hoja = document.createElement('div');
      hoja.style.cssText = 'pointer-events:auto;width:100%;max-width:560px;max-height:40vh;overflow:auto;overscroll-behavior:contain;background:#fff;color:#111;border-radius:1.6rem 1.6rem 0 0;padding:.7rem 1.4rem .9rem;font-size:1.5rem;line-height:1.35;box-shadow:0 -6px 24px rgba(0,0,0,.28);';
      /* En PC (pantalla ancha) la hoja va pegada a la izquierda, sobre el hueco de las herramientas, para no tapar la prenda ni
         la columna de la compra (Xavi, 06/10); en móvil sigue abajo, a todo lo ancho. */
      try {
        if (window.matchMedia && window.matchMedia('(min-width: 1000px)').matches) {
          vel.style.justifyContent = 'flex-start'; vel.style.padding = '0 0 10px 10px'; vel.style.boxSizing = 'border-box';
          hoja.style.maxWidth = '330px'; hoja.style.maxHeight = '62vh'; hoja.style.borderRadius = '1.6rem'; hoja.style.boxShadow = '0 6px 24px rgba(0,0,0,.28)';
        }
      } catch (e) { /* sin matchMedia: se queda abajo */ }
      vel.appendChild(hoja);
      function mk(tag, css, txt) { var n = document.createElement(tag); if (css) n.style.cssText = css; if (txt != null) n.textContent = txt; return n; }
      function pintar() {
        hoja.innerHTML = '';
        var cab = mk('div', 'display:flex;justify-content:space-between;align-items:center;margin-bottom:.4rem;');
        cab.appendChild(mk('b', 'font-size:1.5rem;', 'Impresión' + (vistas.length > 1 ? ' · ' + (zona.nombre || zona.id) : '')));
        var x = mk('button', 'border:0;background:transparent;font-size:2.4rem;line-height:1;cursor:pointer;color:inherit;padding:0 .4rem;', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar');
        x.addEventListener('click', cerrarImpresion); cab.appendChild(x); hoja.appendChild(cab);

        // las técnicas en una fila (una línea por técnica ocupaba media pantalla y tapaba los colores); debajo, la explicación de la elegida
        var filaTec = mk('div', 'display:flex;gap:.6rem;margin:0 0 .3rem;');
        tecnicas.forEach(function (t) {
          var on = t === tec;
          var b = mk('button', 'flex:1 1 0;min-width:0;padding:.4rem .4rem;border-radius:1rem;font:inherit;font-size:1.25rem;font-weight:700;line-height:1.2;cursor:pointer;color:inherit;text-align:center;border:2px solid ' + (on ? '#1f8f2e' : 'rgba(0,0,0,.25)') + ';background:' + (on ? 'rgba(31,143,46,.1)' : '#fff') + ';', t.nombre);
          b.type = 'button'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (t.minUds) b.appendChild(mk('span', 'display:block;font-size:1.1rem;font-weight:500;opacity:.7;margin-top:.15rem;', 'mínimo ' + t.minUds + ' uds'));
          if (t.maxUds) b.appendChild(mk('span', 'display:block;font-size:1.1rem;font-weight:500;opacity:.7;margin-top:.15rem;', 'hasta ' + t.maxUds + ' uds'));
          b.addEventListener('click', function () {
            if (tec === t) return;
            tec = t; tecPorVista[zona.id] = t; tecElegida[zona.id] = true; imagenesTec().forEach(function (e) { reiniciarColores(e); aplicarTec(e); });
            pintar(); avisarCambio();
          });
          filaTec.appendChild(b);
        });
        hoja.appendChild(filaTec);
        hoja.appendChild(mk('div', 'font-size:1.15rem;line-height:1.3;color:rgba(0,0,0,.7);margin:0 0 .2rem;', tec.desc || (tec.colores === 1 ? '1 solo color, en tono de grabado' : 'Hasta ' + tec.colores + ' colores planos, sin degradados')));

        var el = imagenSel() || imagenesTec()[0];
        if (tec.colores > 1) {
          hoja.appendChild(mk('div', 'font-weight:700;margin:1.2rem 0 .6rem;', 'Colores del logo'));
          if (!el) hoja.appendChild(mk('p', 'margin:0;color:rgba(0,0,0,.7);', 'Sube tu logo para ver y ajustar sus colores.'));
          else {
            var pal = el.paleta || [], usados = pal.filter(function (c) { return !c.quitado && !c.oculto; }).length;
            var fila = mk('div', 'display:flex;flex-wrap:wrap;gap:1rem;align-items:flex-start;');
            pal.forEach(function (c) {
              var celda = mk('div', 'display:grid;justify-items:center;gap:.3rem;');
              // un color quitado se queda, tachado y apagado, para poder volver a ponerlo
              var lab = mk('label', 'position:relative;display:block;width:4rem;height:4rem;border-radius:50%;border:2px solid rgba(0,0,0,.3);cursor:pointer;overflow:hidden;background:' + c.hexAct + ';' + (c.quitado ? 'opacity:.4;' : c.oculto ? 'opacity:.55;border-style:dashed;' : ''));
              lab.title = c.quitado ? 'Color quitado' : c.oculto ? 'Negro sobre prenda negra: no se imprime. Elige otro color si quieres imprimirlo' : 'Cambiar este color';
              if (c.quitado) lab.appendChild(mk('i', 'position:absolute;left:-10%;top:48%;width:120%;height:3px;background:#d00;transform:rotate(-45deg);'));
              else {
                var inp = mk('input', 'position:absolute;inset:0;opacity:0;width:100%;height:100%;cursor:pointer;'); inp.type = 'color'; inp.value = c.hexAct;
                inp.addEventListener('change', function () { el.colCambia = el.colCambia || {}; el.colCambia[c.i] = inp.value; tintar(el); avisarCambio(); });
                lab.appendChild(inp);
              }
              celda.appendChild(lab);
              if (c.oculto) celda.appendChild(mk('span', 'font-size:1.2rem;color:rgba(0,0,0,.7);', 'Oculto'));
              else if (c.quitado || usados > 1) {
                var q = mk('button', 'border:0;background:transparent;font:inherit;font-size:1.2rem;text-decoration:underline;cursor:pointer;color:rgba(0,0,0,.7);padding:0;', c.quitado ? 'Poner' : 'Quitar'); q.type = 'button';
                q.addEventListener('click', function () {
                  el.colQuita = el.colQuita || {};
                  if (c.quitado) delete el.colQuita[c.i]; else el.colQuita[c.i] = true;
                  tintar(el); avisarCambio();
                });
                celda.appendChild(q);
              }
              fila.appendChild(celda);
            });
            hoja.appendChild(fila);
            var n = Math.max(1, Math.min(tec.colores, usados || el.nCol || tec.colores));   // el contador sigue a los colores que de verdad lleva
            var ste = mk('div', 'display:flex;align-items:center;gap:1rem;margin-top:1.2rem;');
            ste.appendChild(mk('span', 'flex:1;', 'Número máximo de colores'));
            function paso(d, txt) {
              var b = mk('button', 'width:3.6rem;height:3.6rem;border-radius:50%;border:1px solid rgba(0,0,0,.4);background:#fff;font:inherit;font-size:1.9rem;line-height:1;cursor:pointer;', txt); b.type = 'button';
              b.addEventListener('click', function () {
                if (d < 0 && n <= 2) return; var nn = Math.max(2, Math.min(tec.colores, n + d)); if (nn === n) return;   // multicolor = al menos 2 colores; con 1 sería serigrafía de 1 color
                el.nCol = nn; el.colQuita = null; el.colCambia = null; tintar(el); avisarCambio();
              });
              return b;
            }
            ste.appendChild(paso(-1, '−')); ste.appendChild(mk('b', 'min-width:2rem;text-align:center;', String(n))); ste.appendChild(paso(1, '+'));
            hoja.appendChild(ste);
            var notaCol = mk('p', 'margin:.8rem 0 0;font-size:1.3rem;color:rgba(0,0,0,.7);', (el._reduciendo ? 'Calculando colores…' : 'Colores usados: ' + usados + ' de ' + tec.colores + '. Toca un color para cambiarlo; «Quitar» lo tacha y «Poner» lo recupera.'));
            notaCol.setAttribute('data-imp-estado', '1'); hoja.appendChild(notaCol);

            var lf = mk('label', 'display:flex;align-items:center;gap:.8rem;margin-top:1.2rem;cursor:pointer;');
            var ck = mk('input', 'width:2rem;height:2rem;'); ck.type = 'checkbox'; ck.checked = el.fondoBlanco !== false;
            ck.addEventListener('change', function () { el.fondoBlanco = ck.checked; tintar(el); avisarCambio(); });
            lf.appendChild(ck); lf.appendChild(mk('span', '', 'Quitar el fondo blanco del logo')); hoja.appendChild(lf);
          }
        } else if (tec.tintaLibre) {
          hoja.appendChild(mk('div', 'font-weight:700;margin:.5rem 0 .4rem;', 'Color de la tinta'));
          if (!el) hoja.appendChild(mk('p', 'margin:0;color:rgba(0,0,0,.7);', 'Sube tu logo para elegir el color de la tinta.'));
          else {
                        var rq1 = riquezaColor(el); if (rq1 && rq1.ricos >= 13 && /serigraf/i.test(tec.nombre || '')) hoja.appendChild(mk('p', 'margin:0 0 .8rem;padding:.8rem 1rem;border-radius:.8rem;background:#fff4e0;color:#7a4b00;font-size:1.3rem;', 'Esta imagen es una foto o tiene muchos tonos: en 1 color sale como una silueta. Prueba «Serigrafía multicolor» (la simplifica a 3-4 colores) o «Impresión digital» (se ve tal cual).'));
            var tintas = [['#ffffff', 'Blanco'], ['#111111', 'Negro'], ['#d71920', 'Rojo'], ['#1f57a1', 'Azul'], ['#f2c200', 'Amarillo'], ['#2a9d3f', 'Verde'], ['#f07f12', 'Naranja'], ['#e5589a', 'Rosa'], ['#7a3fa0', 'Morado'], ['#c0a068', 'Dorado'], ['#9aa0a6', 'Plata']];
            var filaT = mk('div', 'display:flex;flex-wrap:wrap;gap:.7rem;');
            function poner(hx) { el.tintaElegida = hx; el.mono = hx; el.monoTec = true; tintar(el); avisarCambio(); pintar(); }
            tintas.forEach(function (t) {
              var on = (el.mono || '').toLowerCase() === t[0];
              var b = mk('button', 'width:3.4rem;height:3.4rem;border-radius:50%;cursor:pointer;padding:0;background:' + t[0] + ';border:' + (on ? '3px solid #1f8f2e' : '2px solid rgba(0,0,0,.3)') + ';'); b.type = 'button'; b.title = t[1]; b.setAttribute('aria-label', t[1]);
              b.addEventListener('click', function () { poner(t[0]); }); filaT.appendChild(b);
            });
            var otro = mk('label', 'position:relative;display:flex;align-items:center;justify-content:center;width:3.4rem;height:3.4rem;border-radius:50%;border:2px dashed rgba(0,0,0,.4);cursor:pointer;font-size:1.8rem;', '+'); otro.title = 'Otro color';
            var ci = mk('input', 'position:absolute;inset:0;opacity:0;width:100%;height:100%;cursor:pointer;'); ci.type = 'color'; ci.value = el.mono && /^#[0-9a-f]{6}$/i.test(el.mono) ? el.mono : '#111111';
            ci.addEventListener('change', function () { poner(ci.value); }); otro.appendChild(ci); filaT.appendChild(otro);
            hoja.appendChild(filaT);
            var lsemi = mk('label', 'display:flex;align-items:flex-start;gap:.8rem;margin-top:1.1rem;cursor:pointer;');
            var cksemi = mk('input', 'width:2rem;height:2rem;flex:none;margin-top:.2rem;'); cksemi.type = 'checkbox'; cksemi.checked = !!el.semitono;
            cksemi.addEventListener('change', function () { el.semitono = cksemi.checked; tintar(el); avisarCambio(); });
            lsemi.appendChild(cksemi);
            lsemi.appendChild(mk('span', '', 'Semitono: los grises se hacen con puntos. Úsalo con fotos o degradados; con un logo plano déjalo apagado.'));
            // MidOcean (serigrafía): sin semitono por ahora (Xavi, 06/10); en DTF sí lo hace él en el taller
            if (!o.sinSemitono) hoja.appendChild(lsemi);
            else if (el.semitono) { el.semitono = false; tintar(el); }
            hoja.appendChild(mk('p', 'margin:.5rem 0 0;font-size:1.1rem;line-height:1.3;color:rgba(0,0,0,.65);', 'Te enviamos prueba para confirmar el color exacto (Pantone).'));
          }
        } else if (!tec.colores) {
        } else {
          hoja.appendChild(mk('p', 'margin:1.2rem 0 0;font-size:1.3rem;color:rgba(0,0,0,.7);', 'El logo se convierte a un solo tono, tal como saldrá grabado. Si tiene varios colores, se pasan a ese tono.'));
        }
        var ok = mk('button', 'position:sticky;bottom:0;z-index:2;box-shadow:0 0 0 .9rem #fff;display:block;width:100%;height:4.4rem;margin-top:1.2rem;border:0;border-radius:1rem;background:#1f8f2e;color:#fff;font:inherit;font-weight:700;font-size:1.6rem;cursor:pointer;', 'Listo'); ok.type = 'button';
        ok.addEventListener('click', cerrarImpresion); hoja.appendChild(ok);
      }
      refrescarImpresion = pintar;
      panelImp = vel; pintar();
      document.body.appendChild(vel);
      // el lienzo queda arriba, a la vista, justo bajo la cabecera de la tienda
      try { var rl = edl.getBoundingClientRect(); if (rl.top < 0 || rl.top > 120) window.scrollBy({ top: rl.top - 80, behavior: 'smooth' }); } catch (e) { /* sin scroll */ }
      historialAbrir('impresion', cerrarImpresion);   // «atrás» en el móvil cierra el panel, no pregunta si se sale
    }

    var caja = document.createElement('div');
    caja.className = 'edl__caja';
    capa.appendChild(caja);

    /* Área de seguridad: los objetos normales no pasan de aquí (margen
       desde los bordes de impresión); solo la imagen de fondo llega al
       borde. Se dibuja tenue dentro del recuadro. */
    /* Márgenes del área de seguridad (Xavi: un lateral tiene que llegar a
       8,5 cm de alto → 0,5 cm arriba y abajo; a los lados también 0,5). */
    var MARGEN_X_CM = o.margenXCm != null ? o.margenXCm : (o.margenCm != null ? o.margenCm : 0.5);
    var MARGEN_Y_CM = o.margenYCm != null ? o.margenYCm : (o.margenCm != null ? o.margenCm : 0.5);
    var seguro = document.createElement('div');
    seguro.className = 'edl__seguro';
    /* estilos en línea (además del CSS) para que el recuadro se vea aunque
       el CSS del tema venga cacheado de una versión anterior */
    seguro.style.cssText = 'position:absolute;z-index:6;pointer-events:none;box-sizing:border-box;' +
      'border:2px dashed rgba(0,0,0,0.6);outline:1px dashed rgba(255,255,255,0.85);outline-offset:-3px;';
    /* algo ajeno al tema (Qstomizer o una extensión) le ponía display:none
       en la web de Xavi: en línea y con !important no hay hoja que lo pise */
    seguro.style.setProperty('display', 'block', 'important');
    seguro.style.setProperty('visibility', 'visible', 'important');
    caja.appendChild(seguro);
    /* Sombra de cilindro sobre el diseño (solo en foto): oscurece los
       lados para que el diseño coja el volumen de la taza. */
    var sombra = document.createElement('div');
    sombra.className = 'edl__sombra';
    sombra.hidden = true;
    caja.appendChild(sombra);

    // en la taza el botón se llama como el de la barra («Tu foto»): misma palabra en todo el editor
    var rw0 = host.closest('.rop-libre-wrap'), esTaza = !!(rw0 && rw0.classList.contains('rop-libre-wrap--fondos-ventana'));
    var subir = boton('edl__subir', esTaza ? '+ Tu foto' : '+ Añadir imagen');
    /* fuera del recuadro (que recorta lo que sobresale): en una zona
       estrecha el texto salía cortado ("Añadir image", Xavi 29/09) */
    capa.appendChild(subir);

    var esMovil = function () { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; };
    var entrada = document.createElement('input');
    /* En Android, cerrar el selector de archivos con "atrás" le llega también
       a la página como un popstate, y saltaba la pregunta de salir (Xavi:
       "al salir de insertar imágenes siempre sale el popup"). Mientras el
       selector está abierto, y un momento después, ese popstate se ignora. */
    var selectorHasta = 0;
    // como mucho un minuto abierto (si no llega ni el cambio ni el foco), y solo se traga UN popstate
    function abrirSelector() { selectorHasta = Date.now() + 60000; entrada.click(); }
    function selectorCerrado() { if (selectorHasta > Date.now() + 1500) selectorHasta = Date.now() + 1500; }
    window.addEventListener('focus', selectorCerrado);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) selectorCerrado(); });
    entrada.type = 'file';
    entrada.accept = 'image/*';
    entrada.hidden = true;
    host.appendChild(entrada);

    /* Los elementos puestos, de atrás a delante (el orden del array es el
       orden de apilado y el orden en el DOM). Cada uno: { id, tipo, div,
       st, aplicar, ... } — ver crearElemento(). */
    var elementos = [];
    var seleccionado = null;
    var siguienteId = 1;

    /* ---------- cajas de opciones en el rail ----------
       Viven fuera del host (en el rail, hermano suyo). Se enseña la del
       tipo del elemento seleccionado, o ninguna. */
    var raizRail = host.closest('.rop-libre-wrap');
    raizRail = raizRail && raizRail.querySelector('.rop-libre-rail');

    /* LO HABITUAL A MANO, LO AVANZADO EN «Más opciones» (Xavi, 07/10: «poner todo a mano hace que alguien poco entendido se maree»):
       devuelve un desplegable cerrado con su contenedor, donde se meten los controles menos usados. */
    function crearAvanzado() {
      var d = document.createElement('details'); d.className = 'edl__opc__mas';
      var sm = document.createElement('summary'); sm.textContent = 'Más opciones'; d.appendChild(sm);
      var c = document.createElement('div'); c.className = 'edl__opc__mas__c'; d.appendChild(c);
      return { d: d, c: c };
    }
    // caja de IMAGEN
    var cajaImagen = document.createElement('div');
    cajaImagen.className = 'edl__opc edl__opc--imagen';
    cajaImagen.hidden = true;
    var btnFondo = boton('edl__opc__b', 'Quitar fondo a la imagen');
    /* Los arreglos del editor viejo, que sí funcionaban (Xavi: "aprovechar
       lo mejor de cada cosa"): quitar el fondo blanco, y fundir el negro
       con la prenda (+ semitono en taller). Con deshacer. */
    var btnBlanco = boton('edl__opc__b', 'Quitar fondo');
    var btnNegro = boton('edl__opc__b', 'Eliminar negro + semitono');
    var btnDeshacerArr = boton('edl__opc__b', 'Deshacer arreglo');
    /* Con foto-ia.js activo (productos con la etiqueta `foto-ia`), el único «Quitar fondo» es el de la IA (Xavi, 22/10/2026): el de siempre se esconde
       y sus avisos («tu imagen trae fondo blanco») abren la pestaña «Quitar fondo (IA)» de «Editar imagen». */
    function iaFondo() { return !!(window.FotoIA && window.FotoIA.activo); }
    function quitarFondoDe(el) { if (iaFondo() && window.__edl) window.FotoIA.editar(window.__edl, 'fondo'); else abrirQuitarFondo(el); }
    var btnFiltros = boton('edl__opc__b edl__opc__b--ia', '');
    btnFiltros.innerHTML = '<b>✨ Retocar</b><small>Dibujo, estilo, fondo</small>';   // foto-ia.js (solo en productos con la etiqueta foto-ia): filtros y recorte de fondo con IA
    btnFiltros.hidden = true;
    var btnVolverIA = boton('edl__opc__b', '↩ Volver a la foto original'); btnVolverIA.hidden = true;
    var notaArr = document.createElement('p'); notaArr.className = 'edl__opc__nota'; notaArr.hidden = true;
    /* FONDO BLANCO O NEGRO SOBRE PRENDA DE OTRO COLOR (Xavi, 28/09): al
       subir se mira si la imagen trae un margen liso blanco o negro; si la
       prenda no es de ese color, se avisa aquí y sobre la imagen, con el
       botón para quitarlo. No se quita solo: a veces el recuadro es parte
       del diseño. Lo que se deja va anotado al pedido. */
    var avisoFondo = document.createElement('div'); avisoFondo.className = 'edl__opc__aviso edl__opc__aviso--fondo'; avisoFondo.hidden = true;
    var avisoFondoT = document.createElement('span'); avisoFondo.appendChild(avisoFondoT);
    var btnAvisoFondo = boton('edl__opc__b edl__opc__b--aviso', 'Quitar'); avisoFondo.appendChild(btnAvisoFondo);
    function fondoDe(el, liso) {   // liso = true: también cuenta un margen liso de cualquier otro color (solo para el consejo «quita el fondo»)
      // 'blanco' | 'negro' | null: el color del margen si es liso y de uno de los dos
      if (!window.ImgArreglo || !ImgArreglo.colorBorde || !el.img.naturalWidth) return null;
      try {
        var c = document.createElement('canvas'), k = Math.min(1, 400 / Math.max(el.img.naturalWidth, el.img.naturalHeight));
        c.width = Math.max(1, Math.round(el.img.naturalWidth * k)); c.height = Math.max(1, Math.round(el.img.naturalHeight * k));
        var ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(el.img, 0, 0, c.width, c.height);
        // si el borde ya es transparente en buena parte, no hay fondo que quitar
        var d = ctx.getImageData(0, 0, c.width, c.height).data, transp = 0, n = 0;
        for (var x = 0; x < c.width; x += 2) { n += 2; if (d[x * 4 + 3] < 8) transp++; if (d[((c.height - 1) * c.width + x) * 4 + 3] < 8) transp++; }
        if (n && transp / n > 0.3) return null;
        var b = ImgArreglo.colorBorde(c);
        if (!b || b.parte < 0.6) return null;
        if (Math.min(b.r, b.g, b.b) >= 225) return 'blanco';
        if (Math.max(b.r, b.g, b.b) <= 40) return 'negro';
        if (liso && b.parte >= 0.85) return 'liso';
      } catch (e) { /* imagen de otro origen */ }
      return null;
    }
    function prendaEs(tipo) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color || '');
      if (!m) return false;
      var lum = (0.299 * parseInt(m[1], 16) + 0.587 * parseInt(m[2], 16) + 0.114 * parseInt(m[3], 16)) / 255;
      return tipo === 'blanco' ? esBlanco(color) : lum < 0.16;
    }
    // ¿le sobra el fondo a esta imagen sobre esta prenda?
    function fondoPendiente(el) {
      if (el && el.fondoDetectado === 'negro' && !esOscuro(color)) return false; // el negro solo se funde en producto negro
      return !!(el && el.tipo === 'imagen' && el.fondoDetectado && !(el.arreglos || []).length && !el.colorFondo && !prendaEs(el.fondoDetectado));
    }
    function comprobarFondos() {
      elementos.forEach(function (e) { if (e.tipo === 'imagen') e.div.classList.toggle('edl__el--fondo-aviso', !o.tintaFija && fondoPendiente(e)); });
    }
    btnAvisoFondo.addEventListener('click', function () { var el = imagenSel(); if (!el) return; if (el.fondoDetectado === 'negro') arreglar(el, 'negro'); else quitarFondoDe(el); });
    /* ASISTENTE (Xavi, 08/10): los primeros usos del editor, un consejo breve cuando se sube una imagen que lo pide
       (fondo negro sobre prenda negra, fondo blanco, imagen borrosa). Sale como máximo CONSEJOS_MAX veces por tipo y
       navegador, enciende en rojo el botón que lo arregla y se va solo; el cliente puede aplicarlo desde el propio aviso. */
    var CONSEJOS_CLAVE = 'imp_consejos_v1', CONSEJOS_MAX = 2;
    var consejoCaja = null, consejoTimer = null, consejoResalte = null, consejoResalteTimer = null;
    function consejosVistos() { try { return JSON.parse(localStorage.getItem(CONSEJOS_CLAVE) || '{}') || {}; } catch (e) { return {}; } }
    function consejoAnotar(k) { var v = consejosVistos(); v[k] = (v[k] || 0) + 1; try { localStorage.setItem(CONSEJOS_CLAVE, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
    function quitarConsejo() {
      clearTimeout(consejoTimer); clearTimeout(consejoResalteTimer);
      if (consejoCaja && consejoCaja.parentNode) consejoCaja.parentNode.removeChild(consejoCaja);
      consejoCaja = null;
      if (consejoResalte) { consejoResalte.classList.remove('edl__resalta'); consejoResalte = null; }
    }
    function mostrarConsejo(k, el, texto, textoBoton, accion, botonReal) {
      if ((consejosVistos()[k] || 0) >= CONSEJOS_MAX || !el.div.isConnected) return;
      if ((cajaFondo && !cajaFondo.hidden) || (cajaBorde && !cajaBorde.hidden)) return;   // el panel de quitar fondo / borde ya está abierto: el consejo taparía sus botones (clienta, 04/11/2026)
      consejoAnotar(k);
      quitarConsejo();
      consejoCaja = document.createElement('div'); consejoCaja.className = 'edl__consejo'; consejoCaja.setAttribute('role', 'status');
      var t = document.createElement('span'); t.className = 'edl__consejo__t'; t.textContent = texto; consejoCaja.appendChild(t);
      var b = boton('edl__consejo__b', textoBoton); b.addEventListener('click', function () { quitarConsejo(); accion(); }); consejoCaja.appendChild(b);
      var x = boton('edl__consejo__x', '✕'); x.setAttribute('aria-label', 'Cerrar consejo'); x.addEventListener('click', quitarConsejo); consejoCaja.appendChild(x);
      document.body.appendChild(consejoCaja);
      consejoTimer = setTimeout(quitarConsejo, 14000);
      // abre las opciones de la imagen para que el botón se vea encendido
      if (seleccionado !== el) seleccionar(el, true); else { host.classList.remove('is-sin-panel'); refrescarOpciones(); }
      var real = botonReal && botonReal();
      if (real && !real.hidden) { consejoResalte = real; real.classList.add('edl__resalta'); consejoResalteTimer = setTimeout(function () { real.classList.remove('edl__resalta'); }, 8000); }
    }
    function consejoImagen(el, intento) {
      if (el && el._asis) return;   // el asistente de «Añadir imagen» ya pregunta por el fondo: no se duplica el consejo
      if (!el || !el.div.isConnected || o.tintaFija || el.fondo || el.colorFondo || (el.arreglos || []).length) return;
      if (el._cargando) { if ((intento || 0) < 8) setTimeout(function () { consejoImagen(el, (intento || 0) + 1); }, 700); return; }
      var visible = function (b) { return avisoFondo.hidden ? b : btnAvisoFondo; };
      if (el.fondoDetectado === 'negro' && esOscuro(color)) {
        mostrarConsejo('negro', el, 'Tu imagen trae fondo negro y la prenda es oscura: puedes eliminar el negro para que se funda con la tela.', 'Eliminar negro', function () { arreglar(el, 'negro'); }, function () { return visible(btnNegro); });
      } else if (el.fondoDetectado === 'blanco') {
        mostrarConsejo('blanco', el, 'Tu imagen trae fondo blanco: quítalo para que solo se imprima el dibujo.', iaFondo() ? 'Quitar fondo (IA)' : 'Quitar fondo', function () { quitarFondoDe(el); }, function () { return iaFondo() ? btnFiltros : visible(btnBlanco); });
      } else if (el.fondoLiso) {
        mostrarConsejo('liso', el, 'Tu imagen trae un fondo de color liso: quítalo para que solo se imprima el dibujo.', iaFondo() ? 'Quitar fondo (IA)' : 'Quitar fondo', function () { quitarFondoDe(el); }, function () { return iaFondo() ? btnFiltros : visible(btnBlanco); });
      } else if (el.borrosa) {
        mostrarConsejo('borrosa', el, 'Con este tamaño la imagen saldrá borrosa. Hazla más pequeña o sube una más grande.', 'Ajustar a tamaño nítido', function () { btnNitido.click(); }, function () { return btnNitido; });
      }
    }
    var btnVoltear = boton('edl__opc__b edl__opc__b--sec', 'Voltear');
    // lo que viene de una plantilla está fijo; este botón lo suelta para moverlo o cambiarle el tamaño
    var btnLibreImg = boton('edl__opc__b', '🔓 Desbloquear: mover y cambiar tamaño'), btnLibreTxt = boton('edl__opc__b', '🔓 Desbloquear: mover y cambiar tamaño');
    btnLibreImg.hidden = true; btnLibreTxt.hidden = true;
    var btnBlancoTinta = boton('edl__opc__b edl__opc__b--blanco-tinta', 'El blanco del logo: sin tinta'); btnBlancoTinta.hidden = true;   // sellos
    var btnDupImg = boton('edl__opc__b edl__opc__b--sec', 'Duplicar');
    var btnBorrarImg = boton('edl__opc__b edl__opc__b--peligro edl__opc__b--sec', 'Borrar');
    btnFondo.hidden = true;
    /* Medidas en cm, editables (como Positivos): se escribe el ancho o el
       alto y el otro sigue la proporción; el centro no se mueve. */
    var filaMedida = document.createElement('div');
    filaMedida.className = 'edl__opc__fila edl__opc__medida';
    function campoCm(etiqueta) {
      var i = document.createElement('input');
      i.type = 'number'; i.step = '0.1'; i.min = '0.5'; i.inputMode = 'decimal';
      i.className = 'edl__opc__cm'; i.setAttribute('aria-label', etiqueta + ' en cm'); i.title = etiqueta + ' (cm)';
      return i;
    }
    var inpAnchoCm = campoCm('Ancho'), inpAltoCm = campoCm('Alto');
    var sepMedida = document.createElement('span'); sepMedida.className = 'edl__opc__medida__x'; sepMedida.textContent = '×';
    var unidadMedida = document.createElement('span'); unidadMedida.className = 'edl__opc__medida__u'; unidadMedida.textContent = 'cm';
    [inpAnchoCm, sepMedida, inpAltoCm, unidadMedida].forEach(function (n) { filaMedida.appendChild(n); });
    /* Aviso de imagen borrosa (Xavi, 28/09: "límite 100 ppp"): con los
       píxeles que trae la imagen y los cm a los que se ha puesto, si sale
       por debajo de 100 ppp se avisa aquí y el elemento lleva un borde
       rojo. Solo avisa: el cliente decide. */
    var PPP_MIN = o.pppMin || 70;
    var avisoRes = document.createElement('p');
    avisoRes.className = 'edl__opc__aviso'; avisoRes.hidden = true;
    function pppDe(el) {
      var esc = escalaPxCm();
      if (!el || el.tipo !== 'imagen' || el.colorFondo || !esc || !el.img.naturalWidth) return null;
      var wcm = el.st.w / esc;
      return wcm > 0 ? el.img.naturalWidth / wcm * 2.54 : null;
    }
    // el peor ppp de las imágenes visibles (null si no hay): ropa.js lo usa para la regla de urgente
    function pppMinimo() {
      var m = null;
      elementos.forEach(function (e) {
        if (!e.visible || e.ejemplo) return;
        var q = pppDe(e); if (q != null && (m == null || q < m)) m = q;
      });
      return m;
    }
    // cambia el umbral del aviso «Borrosa» (en entrega urgente se exige más) y repinta
    function setPppMin(n) {
      if (!n || n === PPP_MIN) return;
      PPP_MIN = n;
      elementos.forEach(function (e) { if (e.tipo === 'imagen') comprobarResolucion(e); });
    }
    /* Botón «Ajustar a tamaño nítido»: pone la imagen al ancho máximo al que sale con PPP_MIN (fotos del móvil, de WhatsApp...) */
    var btnNitido = document.createElement('button');
    btnNitido.type = 'button'; btnNitido.className = 'edl__opc__b edl__opc__b--nitido'; btnNitido.hidden = true;
    btnNitido.addEventListener('click', function () {
      var el = seleccionado; if (!el || el.tipo !== 'imagen') return;
      var cm = el.img.naturalWidth / PPP_MIN * 2.54;
      inpAnchoCm.value = (Math.floor(cm * 10) / 10).toString().replace('.', ',');
      medirDesde(inpAnchoCm);
    });
    /* Sellos: un texto con la letra por debajo de 1,8 mm de cuerpo (unos 5 pt) no se lee en un sello, aunque el diseño salga nítido. */
    var LETRA_MIN_MM = 1.8;
    function comprobarLegible(el) {
      var fs = parseFloat(el.t && el.t.style.fontSize), esc = escalaPxCm();
      if (!fs || !esc) return;
      var mm = fs / esc * 10, mal = mm < LETRA_MIN_MM * 0.97;   // 3 % de tolerancia: al medir la letra ya encajada hay redondeos
      el.div.classList.toggle('edl__el--pequeno', mal); el.pequeno = mal;
    }
    function comprobarResolucion(el) {
      var ppp = pppDe(el), mal = !el.ejemplo && ppp != null && ppp < PPP_MIN;   // un hueco de foto vacío (ejemplo) no es una foto: sin aviso «Borrosa»
      el.div.classList.toggle('edl__el--borrosa', mal);
      el.borrosa = mal;
      if (el === seleccionado) {
        avisoRes.hidden = !mal; btnNitido.hidden = !mal;
        if (mal) btnNitido.textContent = 'Ajustar a tamaño nítido (' + (Math.floor(el.img.naturalWidth / PPP_MIN * 2.54 * 10) / 10).toString().replace('.', ',') + ' cm)';
        if (mal) avisoRes.textContent = 'Saldrá borrosa (' + Math.round(ppp) + ' ppp, mínimo ' + PPP_MIN + (PPP_MIN > 100 ? ' para entrega urgente' : '') + '). Hazla más pequeña o sube una imagen más grande.';
      }
    }
    /* "Un solo color": la imagen entera pasa al color elegido, conservando
       la transparencia. Para logos que van a un color (vinilo, DTF de una
       tinta) o para igualar un dibujo al color del texto. */
    var filaMono = document.createElement('label');
    filaMono.className = 'edl__opc__fila edl__opc__mono';
    var chkMono = document.createElement('input'); chkMono.type = 'checkbox'; chkMono.className = 'edl__opc__mono__chk';
    var txtMono = document.createElement('span'); txtMono.textContent = 'Un solo color';
    var inpMono = document.createElement('input'); inpMono.type = 'color'; inpMono.value = '#17171a'; inpMono.className = 'edl__opc__color'; inpMono.title = 'Color de la imagen';
    [chkMono, txtMono, inpMono].forEach(function (n) { filaMono.appendChild(n); });
    /* Difuminar bordes (Xavi, 29/09): la foto se funde con el producto en vez
       de quedar como un rectángulo. SOLO en productos sublimados (taza,
       cojín, bidón: o.difuminarBordes): ahí lo transparente es el blanco del
       producto. En DTF las semitransparencias salen horribles. */
    var filaDifum = document.createElement('label');
    filaDifum.className = 'edl__opc__fila edl__opc__tol edl__opc__difum'; filaDifum.hidden = true;
    var txtDifum = document.createElement('span'); txtDifum.textContent = 'Difuminar bordes';
    var rngDifum = document.createElement('input'); rngDifum.type = 'range'; rngDifum.min = '0'; rngDifum.max = '100'; rngDifum.value = '0'; rngDifum.setAttribute('aria-label', 'Difuminar bordes');
    var valDifum = document.createElement('b'); valDifum.textContent = '0';
    [txtDifum, rngDifum, valDifum].forEach(function (n) { filaDifum.appendChild(n); });
    /* Estilo: suave (degradado) o rugoso (pincelada, máscara PNG de o.mascaraRugosa) */
    var selDifum = document.createElement('select'); selDifum.className = 'edl__opc__estilo'; selDifum.setAttribute('aria-label', 'Estilo del borde');
    [['', 'Sin bordes']].concat(Object.keys(o.mascarasBorde || {}).map(function (k) { return [k, o.mascarasBorde[k].nombre]; })).forEach(function (a) { var op = document.createElement('option'); op.value = a[0]; op.textContent = a[1]; selDifum.appendChild(op); });
    var imgsMascara = {};
    Object.keys(o.mascarasBorde || {}).forEach(function (k) { var im = new Image(); im.crossOrigin = 'anonymous'; im.src = o.mascarasBorde[k].url; imgsMascara[k] = im; });
    if (!Object.keys(imgsMascara).length) selDifum.hidden = true;
    filaDifum.insertBefore(selDifum, filaDifum.firstChild);
    [btnFiltros, filaMedida, avisoRes, btnNitido, avisoFondo, filaDifum, btnFondo, btnBlanco, btnVolverIA, btnNegro, btnDeshacerArr, notaArr, btnBlancoTinta, btnLibreImg, btnVoltear, btnDupImg, btnBorrarImg].forEach(function (n) { cajaImagen.appendChild(n); });
    /* Imagen: a mano, la medida, los avisos, «Quitar fondo», duplicar y borrar; en «Más opciones», voltear, el negro + semitono, deshacer arreglo,
       difuminado y borde. */
    var masImg = crearAvanzado();
    [filaDifum, btnFondo, btnNegro, btnDeshacerArr, notaArr, btnVoltear].forEach(function (n) { masImg.c.appendChild(n); });
    cajaImagen.appendChild(masImg.d);
    /* sellos: una sola tinta y el blanco se resuelve solo (botón «El blanco del logo»); las herramientas de quitar fondo, el negro,
       el semitono, los bordes y el difuminado no pintan nada aquí y confundían (Xavi, 04/10) */
    if (o.tintaFija) [avisoFondo, filaDifum, btnFondo, btnBlanco, btnNegro, btnDeshacerArr, notaArr, btnNitido].forEach(function (n) { n.classList.add('edl__x-tinta'); });

    // caja de TEXTO
    var cajaTexto = document.createElement('div');
    cajaTexto.className = 'edl__opc edl__opc--texto';
    cajaTexto.hidden = true;
    /* El texto se cambia desde AQUÍ, no escribiendo sobre el elemento: así
       pinchar en el texto del lienzo lo mueve, igual que una imagen (Xavi:
       "para que sean más cómodos de mover"). */
    /* textarea: con Intro el cliente decide dónde parte las líneas */
    var inpTexto = document.createElement('textarea');
    inpTexto.rows = 2;
    inpTexto.className = 'edl__opc__texto';
    inpTexto.placeholder = 'Cambiar texto (Intro = nueva línea)';
    inpTexto.setAttribute('aria-label', 'Cambiar texto');
    var selFuente = document.createElement('select');
    selFuente.className = 'edl__opc__fuente';
    FUENTES.forEach(function (f) {
      var op = document.createElement('option');
      op.value = f.v; op.textContent = f.n;
      selFuente.appendChild(op);
    });
    selFuente.hidden = true; // el estado; lo que se ve es el botón y la lista de abajo
    /* Fuente y color en la misma fila: el botón enseña la fuente actual en
       su propia letra y abre una lista con todas, cada una en la suya (un
       <select> no deja verlas); el color al lado, cuadrado, para que se vea
       como muestra y no como una raya (Xavi). */
    var filaFuente = document.createElement('div');
    filaFuente.className = 'edl__opc__fila edl__opc__fila--fuente';
    var btnFuente = boton('edl__opc__fuente-b', '');
    btnFuente.setAttribute('aria-haspopup', 'listbox');
    var listaFuentes = document.createElement('div');
    listaFuentes.className = 'edl__fuentes';
    listaFuentes.hidden = true;
    listaFuentes.setAttribute('role', 'listbox');
    function pintarBtnFuente() {
      var f = FUENTES[selFuente.selectedIndex] || FUENTES[0];
      btnFuente.textContent = f.n;
      btnFuente.style.fontFamily = f.v;
      btnFuente.setAttribute('aria-label', 'Fuente: ' + f.n);
      Array.prototype.forEach.call(listaFuentes.children, function (b, i) {
        b.classList.toggle('is-on', i === selFuente.selectedIndex);
      });
    }
    FUENTES.forEach(function (f, i) {
      var b = boton('edl__fuentes__b', f.n);
      b.style.fontFamily = f.v;
      b.setAttribute('role', 'option');
      b.addEventListener('click', function () {
        selFuente.selectedIndex = i;
        selFuente.dispatchEvent(new Event('change'));
        listaFuentes.hidden = true;
        btnFuente.setAttribute('aria-expanded', 'false');
      });
      listaFuentes.appendChild(b);
    });
    btnFuente.addEventListener('click', function () {
      listaFuentes.hidden = !listaFuentes.hidden;
      btnFuente.setAttribute('aria-expanded', listaFuentes.hidden ? 'false' : 'true');
    });
    var selColor = document.createElement('input');
    selColor.type = 'color'; selColor.value = '#17171a';
    selColor.className = 'edl__opc__color';
    selColor.title = 'Color del texto';
    filaFuente.appendChild(btnFuente); filaFuente.appendChild(selColor);
    /* Borde del texto de otro color (Xavi): sin / fino / grueso, en
       fracción del tamaño de letra para que escale con el texto. Se ve en
       pantalla con text-stroke y sale igual en el PNG (strokeText). */
    var ANCHOS_BORDE = [{ n: 'Sin borde', v: 0 }, { n: 'Borde fino', v: 0.05 }, { n: 'Borde grueso', v: 0.09 }];
    var filaBorde = document.createElement('div');
    filaBorde.className = 'edl__opc__fila edl__opc__fila--fuente';
    var selBorde = document.createElement('select');
    selBorde.className = 'edl__opc__borde';
    selBorde.setAttribute('aria-label', 'Borde del texto');
    ANCHOS_BORDE.forEach(function (a) {
      var op = document.createElement('option'); op.value = String(a.v); op.textContent = a.n; selBorde.appendChild(op);
    });
    var selColorBorde = document.createElement('input');
    selColorBorde.type = 'color'; selColorBorde.value = '#ffffff';
    selColorBorde.className = 'edl__opc__color';
    selColorBorde.title = 'Color del borde';
    filaBorde.appendChild(selBorde); filaBorde.appendChild(selColorBorde);
    /* Colores ya usados, como muestras debajo del selector: elegir el mismo
       verde para otro texto sin tener que volver a acertarlo en el picker. */
    var presets = document.createElement('div');
    presets.className = 'edl__opc__presets';
    var coloresUsados = [];
    function anotarColor(hex) {
      hex = String(hex || '').toLowerCase();
      if (!/^#[0-9a-f]{6}$/.test(hex)) return;
      /* sin repetidos: el mismo color, o uno que a la vista es el mismo
         (canales a menos de 10 puntos), se queda con una sola muestra */
      var rgb = function (h) { return [1, 3, 5].map(function (k) { return parseInt(h.substr(k, 2), 16); }); };
      var a = rgb(hex);
      for (var i = coloresUsados.length - 1; i >= 0; i--) {
        var b = rgb(coloresUsados[i]);
        if (Math.max(Math.abs(a[0] - b[0]), Math.abs(a[1] - b[1]), Math.abs(a[2] - b[2])) <= 10) coloresUsados.splice(i, 1);
      }
      coloresUsados.unshift(hex);
      if (coloresUsados.length > 8) coloresUsados.length = 8;
      presets.innerHTML = '';
      coloresUsados.forEach(function (c) {
        var b = boton('edl__opc__preset', '');
        b.style.background = c;
        b.title = c;
        b.setAttribute('aria-label', 'Color ' + c);
        b.addEventListener('click', function () {
          var el = textoSel();
          if (!el) return;
          el.t.style.color = c;
          selColor.value = c;
          anotarColor(c);
        });
        presets.appendChild(b);
      });
      presets.hidden = coloresUsados.length === 0;
    }
    presets.hidden = true;
    /* Muestras con todo lo que ya hay en el diseño: el color de cada texto,
       de sus bordes y el color de fondo. Así un texto nuevo puede ir del
       mismo color que otro sin volver a acertarlo (Xavi). */
    function recogerColores() {
      elementos.forEach(function (e) {
        if (e.tipo === 'texto') {
          if (e.borde && e.borde.ancho) anotarColor(e.borde.color);
          anotarColor(rgbAHex(e.t.style.color));
        } else if (e.colorFondo) anotarColor(e.colorFondo);
      });
    }
    var filaEstilo = document.createElement('div');
    filaEstilo.className = 'edl__opc__fila';
    var btnNegrita = boton('edl__opc__b edl__opc__b--corto edl__opc__b--negrita', 'N');
    var btnCursiva = boton('edl__opc__b edl__opc__b--corto edl__opc__b--cursiva', 'K');
    var btnSubrayado = boton('edl__opc__b edl__opc__b--corto edl__opc__b--subrayado', 'S');
    [btnNegrita, btnCursiva, btnSubrayado].forEach(function (n) { filaEstilo.appendChild(n); });
    var btnDupTxt = boton('edl__opc__b', 'Duplicar');
    var btnBorrarTxt = boton('edl__opc__b edl__opc__b--peligro', 'Borrar');
    /* Móvil (Xavi, 29/09): al lado de la caja, mientras se escribe, un botón
       "Insertar" que cierra el teclado y aparta el panel para ver el texto
       puesto. El texto ya está en la prenda (se pinta al escribir): el
       botón solo remata. En PC no hace falta y el CSS lo esconde. */
    var filaTexto = document.createElement('div');
    filaTexto.className = 'edl__opc__texto-fila';
    var btnInsertar = boton('edl__opc__b edl__opc__b--insertar', 'Insertar');
    btnInsertar.addEventListener('click', function () {
      var escribiendo = document.documentElement.classList.contains('edl-escribiendo');   // taza: el primer «Listo» solo cierra el teclado y deja ver tamaño y 🎲
      inpTexto.blur();
      if (esMovil() && !escribiendo) host.classList.add('is-sin-panel');
    });
    filaTexto.appendChild(inpTexto); filaTexto.appendChild(btnInsertar);
    /* Un dorsal (nombre o número) no se escribe ni se viste aquí: el texto sale de la lista de
       personas y la letra y el color son los del dorsal (ropa.js). Aquí solo se mueve, se
       cambia de tamaño y se oculta o se borra. */
    var notaDorsal = document.createElement('p');
    notaDorsal.className = 'edl__opc__nota edl__opc__nota-dorsal'; notaDorsal.hidden = true;
    notaDorsal.textContent = 'Lo que pone sale de la lista de nombres y números. Mueve y cambia el tamaño; con el ojo de Capas lo ocultas sin borrarlo.';
    [notaDorsal, filaTexto, selFuente, filaFuente, listaFuentes, filaEstilo].forEach(function (n) { cajaTexto.appendChild(n); });
    // texto: a mano, el texto, la letra y el color, negrita/cursiva/subrayado, duplicar y borrar; en «Más opciones», el borde y los colores rápidos
    var masTxt = crearAvanzado();
    [filaBorde, presets].forEach(function (n) { masTxt.c.appendChild(n); });
    cajaTexto.appendChild(masTxt.d);
    /* taza: «Nombres» ya no es pestaña; se añade desde el panel de Texto (Xavi, 21/10) */
    var btnNombreTxt = null;
    if ((host.closest('.rop-libre-wrap') || document).classList.contains('rop-libre-wrap--fondos-ventana')) {
      btnNombreTxt = document.createElement('button'); btnNombreTxt.type = 'button'; btnNombreTxt.className = 'edl__opc__b edl__opc__b--nombre';
      btnNombreTxt.textContent = '# Nombre o número';
      btnNombreTxt.addEventListener('click', function () { ctrl.añadirDorsal(); });
      cajaTexto.appendChild(btnNombreTxt);
    }
    [btnLibreTxt, btnDupTxt, btnBorrarTxt].forEach(function (n) { cajaTexto.appendChild(n); });

    /* Editar lo que ya hay, lo primero (Xavi, 25/10/2026): en la taza, tocar un texto o una foto de un montaje abre un panel mínimo
       (la caja del texto, o «Cambiar foto») y lo demás queda en «Más ajustes». El CSS está en taza-comp.css. */
    var esTaza = (host.closest('.rop-libre-wrap') || document).classList.contains('rop-libre-wrap--fondos-ventana');
    var btnCambiarFoto = null, btnMasT = null, btnMasI = null, rngTam = null, valTam = null;
    if (esTaza) {
      /* «Tamaño» justo bajo la caja del texto (Xavi, 25/10/2026): un deslizador de 40 % a 220 % del tamaño que tenía al elegirlo */
      var filaTam = document.createElement('label'); filaTam.className = 'edl__opc__tam';
      var txtTam = document.createElement('span'); txtTam.textContent = 'Tamaño';
      rngTam = document.createElement('input'); rngTam.type = 'range'; rngTam.min = '40'; rngTam.max = '220'; rngTam.step = '5'; rngTam.value = '100'; rngTam.setAttribute('aria-label', 'Tamaño del texto');
      valTam = document.createElement('b'); valTam.textContent = '100 %';
      var btnDado = boton('edl__opc__b edl__opc__b--dado', '🎲'); btnDado.title = 'Sorpresa: otra letra y otro color para este texto'; btnDado.setAttribute('aria-label', 'Sorpresa: otra letra y otro color para este texto');
      btnDado.addEventListener('click', function () {
        var el = textoSel(); if (!el) return;
        var cols = ['#ffffff', '#f4d35e', '#ee6c4d', '#e63946', '#2a9d8f', '#1d3557', '#17171a', '#c77dff', '#ff7aa2', '#06d6a0'];
        selFuente.selectedIndex = Math.floor(Math.random() * FUENTES.length); selFuente.dispatchEvent(new Event('change'));
        selColor.value = cols[Math.floor(Math.random() * cols.length)]; selColor.dispatchEvent(new Event('input')); selColor.dispatchEvent(new Event('change'));
      });
      [txtTam, rngTam, valTam].forEach(function (n) { filaTam.appendChild(n); });
      cajaTexto.insertBefore(filaTam, filaTexto.nextSibling);
      /* Texto de un montaje (Xavi, 25/10/2026): al tocarlo sale, como en una imagen, «Cambiar texto», el tamaño y el color; escribir es un paso aparte */
      var btnCambiarTxt = boton('edl__opc__b edl__opc__b--cambiartxt', '✏️ Cambiar texto');
      btnCambiarTxt.addEventListener('click', function () { try { inpTexto.focus(); inpTexto.select(); } catch (e) { /* sin foco */ } });
      filaTexto.insertBefore(btnCambiarTxt, btnInsertar);
      var filaCol = document.createElement('div'); filaCol.className = 'edl__opc__cols';
      ['#ffffff', '#17171a', '#f4d35e', '#e63946', '#2a9d8f', '#1d3557', '#c77dff', '#ff7aa2'].forEach(function (hex) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'edl__opc__col'; b.style.background = hex; b.title = hex; b.setAttribute('aria-label', 'Color ' + hex);
        b.addEventListener('click', function () { if (!textoSel()) return; selColor.value = hex; selColor.dispatchEvent(new Event('input')); selColor.dispatchEvent(new Event('change')); });
        filaCol.appendChild(b);
      });
      filaCol.appendChild(btnDado);
      cajaTexto.insertBefore(filaCol, filaTam.nextSibling);
      /* Al escribir en el móvil el teclado tapaba la taza (Xavi, 25/10/2026): mientras la caja tiene el foco, el panel del texto sube justo bajo la
         barra de herramientas y la taza queda a la vista entre el panel y el teclado (CSS en taza-comp.css). */
      inpTexto.addEventListener('focus', function () { if (esMovil()) document.documentElement.classList.add('edl-escribiendo'); });
      inpTexto.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== inpTexto) document.documentElement.classList.remove('edl-escribiendo'); }, 120); });
      inpTexto.addEventListener('keydown', function (ev) {   // «Intro» del teclado = Listo (en un texto del montaje, de una sola línea)
        if (ev.key === 'Enter' && !ev.shiftKey && esMovil() && seleccionado && seleccionado.bloqueado) { ev.preventDefault(); btnInsertar.click(); }
      });
      btnInsertar.addEventListener('mousedown', function (ev) { ev.preventDefault(); });   // «Listo» no quita el foco antes de tiempo: si no, el panel bajaba y el toque se perdía
      rngTam.addEventListener('input', function () {
        var el = seleccionado; if (!el || el.tipo !== 'texto') return;
        if (!el._tamBase) el._tamBase = { w: el.st.w, h: el.st.h };
        var k = parseInt(rngTam.value, 10) / 100, rs = rectSeguro(), w = el._tamBase.w * k, h = el._tamBase.h * k;
        var kMax = Math.min((rs.x1 - rs.x0) / w, (rs.y1 - rs.y0) / h, 1); w *= kMax; h *= kMax;   // sin salirse de la zona segura
        cxRef = el.st.left + el.st.w / 2;
        var cx = el.st.left + el.st.w / 2, cy = el.st.top + el.st.h / 2;
        el.st.left = cx - w / 2; el.st.top = cy - h / 2;
        el.aplicarTamaño(w, h); acotar(el.st); el.aplicar();
        valTam.textContent = Math.round(w / el._tamBase.w * 100) + ' %';
      });
      btnCambiarFoto = boton('edl__opc__b edl__opc__b--cambiar', '📷 Cambiar foto'); btnCambiarFoto.hidden = true;
      btnCambiarFoto.addEventListener('click', function () { if (seleccionado) { huecoPendiente = seleccionado; modoFondo = false; pedirImagen(); } });
      cajaImagen.appendChild(btnCambiarFoto);
      [['t', cajaTexto], ['i', cajaImagen]].forEach(function (par) {
        var b = boton('edl__opc__b edl__opc__b--masaj', 'Más ajustes'); b.hidden = true;
        b.addEventListener('click', function () { if (seleccionado) { seleccionado._masAj = true; refrescarOpciones(); } });
        par[1].appendChild(b); if (par[0] === 't') btnMasT = b; else btnMasI = b;
      });
    }

    /* caja QUITAR FONDO (Xavi, 29/09: "al quitar fondo estaría bien su propia
       ventana de propiedades, así podemos poner más o menos tolerancia y si
       extraemos color contiguo o todo el color"). Sustituye a la de imagen
       mientras está abierta; la previa se ve en la prenda según se mueve el
       deslizador, y Aplicar lo deja como un arreglo normal (deshacible). */
    var cajaFondo = document.createElement('div');
    cajaFondo.className = 'edl__opc edl__opc--fondo';
    cajaFondo.hidden = true;
    var tituloFondo = document.createElement('p'); tituloFondo.className = 'edl__opc__t'; tituloFondo.textContent = 'Quitar el fondo';
    var filaTol = document.createElement('label'); filaTol.className = 'edl__opc__fila edl__opc__tol';
    var tolTexto = document.createElement('span'); tolTexto.textContent = 'Tolerancia';
    var rangoTol = document.createElement('input'); rangoTol.type = 'range'; rangoTol.min = '0'; rangoTol.max = '100'; rangoTol.value = '1'; rangoTol.setAttribute('aria-label', 'Tolerancia');
    var tolValor = document.createElement('b'); tolValor.textContent = '1';
    filaTol.appendChild(tolTexto); filaTol.appendChild(rangoTol); filaTol.appendChild(tolValor);
    var filaModo = document.createElement('div'); filaModo.className = 'edl__opc__fila edl__opc__modo';
    function radioModo(valor, texto, marcado) {
      var l = document.createElement('label'); l.className = 'edl__opc__radio';
      var r = document.createElement('input'); r.type = 'radio'; r.name = 'edl-modo-fondo-' + Math.random().toString(36).slice(2, 7); r.value = valor; r.checked = !!marcado;
      l.appendChild(r); l.appendChild(document.createTextNode(' ' + texto));
      return { l: l, r: r };
    }
    var modoContiguo = radioModo('contiguo', 'Solo el fondo (lo que toca el borde)', true);
    var modoTodo = radioModo('todo', 'Todo ese color, también por dentro', false);
    modoTodo.r.name = modoContiguo.r.name;
    filaModo.appendChild(modoContiguo.l); filaModo.appendChild(modoTodo.l);
    /* Varita (Xavi, 29/09): "poder añadir con una varita colores del diseño
       que queramos añadir a la resta". Se activa, se toca el diseño y ese
       color entra en la lista (chips, cada uno con su ×). Con "solo el fondo"
       se quita lo contiguo al punto tocado; con "todo ese color", en todo el
       diseño. */
    var btnVarita = boton('edl__opc__b edl__opc__b--varita', '🪄 Varita: quitar otro color');
    var chipsFondo = document.createElement('div'); chipsFondo.className = 'edl__opc__chips'; chipsFondo.hidden = true;
    var notaFondo = document.createElement('p'); notaFondo.className = 'edl__opc__nota'; notaFondo.textContent = '';
    var btnFondoOk = boton('edl__opc__b edl__opc__b--aviso', 'Aplicar');
    var btnFondoNo = boton('edl__opc__b', 'Cancelar');
    [tituloFondo, filaTol, filaModo, btnVarita, chipsFondo, notaFondo, btnFondoOk, btnFondoNo].forEach(function (n) { cajaFondo.appendChild(n); });
    /* BORDE en el móvil (Xavi, 29/09): igual que "Quitar fondo": botón en las opciones de
       la imagen, pantalla con el diseño de cerca y, anclado abajo, el panel con las formas. */
    var btnBorde = boton('edl__opc__b', '🖼️ Borde');
    btnBorde.hidden = true;
    var cajaBorde = document.createElement('div');
    cajaBorde.className = 'edl__opc edl__opc--fondo edl__opc--borde';
    cajaBorde.hidden = true;
    var tituloBorde = document.createElement('p'); tituloBorde.className = 'edl__opc__t'; tituloBorde.textContent = 'Borde de la imagen';
    var listaBorde = document.createElement('div'); listaBorde.className = 'edl__opc__estilos';
    var btnBordeOk = boton('edl__opc__b edl__opc__b--aviso', 'Listo');
    var btnBordeNo = boton('edl__opc__b', 'Cancelar');
    [tituloBorde, listaBorde, btnBordeOk, btnBordeNo].forEach(function (n) { cajaBorde.appendChild(n); });
    masImg.c.appendChild(btnBorde);
    if (o.tintaFija) { btnBorde.classList.add('edl__x-tinta'); masImg.d.classList.add('edl__x-tinta'); }
    if (raizRail) { raizRail.appendChild(cajaImagen); raizRail.appendChild(cajaFondo); raizRail.appendChild(cajaBorde); raizRail.appendChild(cajaTexto); }

    /* ---------- panel de capas ----------
       Una fila por elemento, de delante a atrás (la primera fila es la que
       está encima, como en Positivos), con ocultar, borrar y subir/bajar. */
    var cajaCapas = document.createElement('div');
    cajaCapas.className = 'edl__capas';
    cajaCapas.hidden = true;
    var tituloCapas = document.createElement('div');
    tituloCapas.className = 'edl__capas__t';
    tituloCapas.textContent = 'Capas';
    var listaCapas = document.createElement('div');
    listaCapas.className = 'edl__capas__l';
    cajaCapas.appendChild(tituloCapas);
    cajaCapas.appendChild(listaCapas);
    if (raizRail) raizRail.appendChild(cajaCapas);

    function etiquetaDe(el) {
      if (el.dorsal) return el.dorsal === 'nombre' ? 'Nombre (dorsal)' : 'Número (dorsal)';
      if (el.tipo === 'texto') {
        var s = (el.t.textContent || '').trim();
        return s ? s.slice(0, 14) : 'Texto';
      }
      return el.fondo ? (el.colorFondo ? 'Color de fondo' : 'Fondo') : 'Imagen';
    }

    function refrescarCapas() {
      if (typeof actualizarSombra === 'function') actualizarSombra();
      var bDor2 = document.querySelector('[data-libre-dorsal]');
      if (bDor2) bDor2.hidden = !(typeof hayDorsal === 'function' && hayDorsal());
      if (typeof o.onCambio === 'function') setTimeout(o.onCambio, 0);
      cajaCapas.hidden = elementos.length === 0;
      if (elementos.length) ponerGuardia();
      listaCapas.innerHTML = '';
      elementos.slice().reverse().forEach(function (el, i, arr) {
        var fila = document.createElement('div');
        // "fila", no "capa": edl__capa ya es la capa transparente sobre el lienzo
        fila.className = 'edl__fila' + (el === seleccionado ? ' is-sel' : '') + (el.visible ? '' : ' is-oculta');
        var mini = document.createElement('span');
        mini.className = 'edl__fila__mini';
        if (el.tipo === 'imagen') {
          var im = document.createElement('img');
          im.src = el.img.src; im.alt = '';
          mini.appendChild(im);
        } else {
          mini.textContent = 'T';
        }
        var nombre = document.createElement('span');
        nombre.className = 'edl__fila__n';
        nombre.textContent = etiquetaDe(el);
        var bSubir = boton('edl__fila__b', '▲'); bSubir.title = 'Traer delante'; bSubir.disabled = i === 0 || !!el.fondo;
        var bBajar = boton('edl__fila__b', '▼'); bBajar.title = 'Mandar detrás'; bBajar.disabled = i === arr.length - 1 || !!(arr[i + 1] && arr[i + 1].fondo);
        var bOjo = boton('edl__fila__b', el.visible ? '👁' : '◌'); bOjo.title = el.visible ? 'Ocultar' : 'Mostrar';
        var bBorrar = boton('edl__fila__b edl__fila__b--peligro', '✕'); bBorrar.title = 'Borrar';
        fila.addEventListener('click', function () {
          if (!el.visible) return;
          seleccionar(el);
          // móvil: elegir una capa cierra el panel y enseña las opciones de ese elemento
          if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
            ctrl.cerrarCapas();
            refrescarOpciones();
          }
        });
        bSubir.addEventListener('click', function (ev) { ev.stopPropagation(); reordenar(el, +1); });
        bBajar.addEventListener('click', function (ev) { ev.stopPropagation(); reordenar(el, -1); });
        bOjo.addEventListener('click', function (ev) { ev.stopPropagation(); ocultar(el, el.visible); });
        bBorrar.addEventListener('click', function (ev) { ev.stopPropagation(); borrar(el); });
        [mini, nombre, bSubir, bBajar, bOjo, bBorrar].forEach(function (n) { fila.appendChild(n); });
        listaCapas.appendChild(fila);
      });
    }

    // +1 = un puesto más adelante (más arriba en la lista), -1 = más atrás
    function reordenar(el, paso) {
      var i = elementos.indexOf(el), j = i + paso;
      if (i < 0 || j < 0 || j >= elementos.length) return;
      // el fondo siempre es el primero (el de más atrás)
      if (el.fondo || (j === 0 && elementos[0].fondo)) return;
      elementos.splice(i, 1);
      elementos.splice(j, 0, el);
      // el orden del DOM es el orden de apilado: se recolocan todos
      elementos.forEach(function (e) { caja.appendChild(e.div); });
      refrescarCapas();
    }

    function ocultar(el, si) {
      el.visible = !si;
      el.div.classList.toggle('is-oculto', !el.visible);
      if (!el.visible && seleccionado === el) seleccionar(null);
      refrescarCapas();
    }

    /* Botón «✓ Listo» al principio de los paneles de opciones (solo se ve en el móvil): el panel tapa media pantalla y fuera de él casi no queda
       lienzo donde tocar para cerrarlo (Xavi, 07/10: «lo tapa todo y no puedo cerrarla»). */
    [cajaImagen, cajaTexto].forEach(function (cj) {
      var cerrar = boton('edl__opc__cerrar', '✓ Listo');
      cerrar.addEventListener('click', function () { host.classList.add('is-sin-panel'); });
      cj.insertBefore(cerrar, cj.firstChild);
    });
    // «Editar» alterna: si el panel ya está abierto, lo cierra
    function abrirOpciones() {
      if (esMovil() && !host.classList.contains('is-sin-panel') && seleccionado) { host.classList.add('is-sin-panel'); return; }
      host.classList.remove('is-sin-panel'); ctrl.cerrarCapas(); refrescarOpciones();
    }
    function refrescarOpciones() {
      var sel = seleccionado;
      // móvil: el botón "Editar imagen / Editar texto" de la barra de arriba, solo con algo seleccionado
      var bEditar = document.querySelector('[data-libre-opciones]');
      if (bEditar) { bEditar.hidden = !sel; if (sel) bEditar.textContent = sel.tipo === 'texto' ? 'Editar texto' : 'Editar imagen'; }
      // móvil: al seleccionar algo, el panel de capas deja paso al de opciones
      if (sel && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ctrl.cerrarCapas();
      if (qf.el && qf.el !== sel) cerrarQuitarFondo(false);
      cajaImagen.hidden = !(sel && sel.tipo === 'imagen') || !cajaFondo.hidden || !cajaBorde.hidden;
      btnDupImg.hidden = !!(sel && sel.fondo);
      filaMedida.hidden = filaMono.hidden = !!(sel && sel.fondo); // el fondo ya ocupa toda la superficie
      avisoRes.hidden = true; btnNitido.hidden = true;
      if (sel && sel.tipo === 'imagen') {
        comprobarResolucion(sel);
        var escM = escalaPxCm();
        if (escM && document.activeElement !== inpAnchoCm && document.activeElement !== inpAltoCm) {
          inpAnchoCm.value = (sel.st.w / escM).toFixed(1);
          inpAltoCm.value = (sel.st.h / escM).toFixed(1);
        }
        chkMono.checked = !!sel.mono;
        if (sel.mono) inpMono.value = sel.mono;
        var hayBordes = !!(Object.keys(o.mascarasBorde || {}).length && !sel.fondo && !sel.colorFondo);
        filaDifum.hidden = !hayBordes || esMovil();     // móvil: botón "Borde" con su pantalla
        btnBorde.hidden = !hayBordes || !esMovil();
        selDifum.value = sel.difumEstilo || '';
        rngDifum.hidden = valDifum.hidden = txtDifum.hidden = sel.difumEstilo !== 'suave';
        rngDifum.value = sel.difuminado || 0; valDifum.textContent = sel.difuminado || 0;
      }
      // a un color liso no hay que quitarle el fondo ni voltearlo
      btnVoltear.hidden = !!(sel && sel.colorFondo);
      btnBlancoTinta.hidden = !(o.tintaFija && sel && sel.tipo === 'imagen' && !sel.fondo);
      btnLibreImg.hidden = !(sel && sel.bloqueado && sel.tipo === 'imagen'); btnLibreTxt.hidden = !(sel && sel.bloqueado && sel.tipo === 'texto');
      if (!btnBlancoTinta.hidden) btnBlancoTinta.textContent = (sel.tintaModo || sel.tintaAuto) === 'alfa' ? 'El blanco del logo: con tinta (toca para quitarla)' : 'El blanco del logo: sin tinta (toca para ponerla)';
      /* "Quitar fondo" está apagado (Xavi, 28/09: "no funciona bien, ya
         veremos cómo lo implementamos"); el código se queda para cuando
         se rehaga con algo mejor que el umbral por color. */
      btnFondo.hidden = true;
      var conArr = sel && sel.tipo === 'imagen' && !sel.colorFondo;
      avisoFondo.hidden = !fondoPendiente(sel);
      if (!avisoFondo.hidden) {
        avisoFondoT.textContent = sel.fondoDetectado === 'blanco' ? 'Tu imagen trae fondo blanco. ¿Lo quitamos?' : 'Tu imagen trae fondo negro. ¿Lo fundimos con la prenda?';
        btnAvisoFondo.textContent = sel.fondoDetectado === 'blanco' ? 'Quitar fondo' : 'Eliminar negro + semitono';
      }
      comprobarFondos();
      // con el aviso a la vista, los dos botones generales sobran
      if (!avisoFondo.hidden) { btnBlanco.hidden = true; btnNegro.hidden = true; }
      // con el aviso a la vista (que ya trae su botón), el "Quitar fondo" general sobra
      btnBlanco.hidden = !(conArr && !(sel.arreglos || []).length) || !avisoFondo.hidden || iaFondo();
      btnNegro.hidden = !(conArr && !(sel.arreglos || []).length && esOscuro(color));
      btnDeshacerArr.hidden = !(conArr && (sel.arreglos || []).length);
      var conIA = !!(sel && sel.tipo === 'imagen' && ((sel.arreglos || []).indexOf('filtro') !== -1 || (sel.arreglos || []).indexOf('fondoia') !== -1));
      btnFiltros.hidden = !(window.FotoIA && window.FotoIA.activo && sel && sel.tipo === 'imagen' && !sel.colorFondo);
      btnVolverIA.hidden = !conIA;
      if (conIA) btnDeshacerArr.hidden = true;   // para volver atrás ya está el botón «Volver a la foto original»
      notaArr.hidden = !(conArr && (sel.arreglos || []).length);
      if (conArr && (sel.arreglos || []).length) {
        notaArr.innerHTML = sel.arreglos[sel.arreglos.length - 1] === 'negro'
          ? '<b>Listo, con semitono.</b> Más ligero, más suave y transpira mejor: lo negro pasa a ser la tela.'
          : /^(filtro|fondoia)$/.test(sel.arreglos[sel.arreglos.length - 1]) ? '<b>Listo.</b> Hecho con IA.' : '<b>Listo.</b> Sin el fondo blanco.';
      }
      cajaTexto.hidden = !(sel && sel.tipo === 'texto');
      if (esTaza) {
        if (sel && sel.tipo === 'texto') {
          if (!sel._tamBase && sel.st.w > 20) sel._tamBase = { w: sel.st.w, h: sel.st.h };   // el tamaño de partida, ya medido (al crearse mide 10 × 10)
          var pc = sel._tamBase ? Math.max(40, Math.min(220, Math.round(sel.st.w / sel._tamBase.w * 100))) : 100;
          if (document.activeElement !== rngTam) rngTam.value = String(pc);
          valTam.textContent = pc + ' %';
        }
        var senT = !!(sel && sel.tipo === 'texto' && sel.bloqueado && !sel.dorsal && !sel._masAj);
        var senI = !!(sel && sel.tipo === 'imagen' && (sel.hueco || sel.deHueco) && !sel.fondo && !sel._masAj);
        cajaTexto.classList.toggle('is-simple', senT); btnMasT.hidden = !senT;
        cajaImagen.classList.toggle('is-simple', senI); btnMasI.hidden = !senI; btnCambiarFoto.hidden = !senI;
      }
      cajaTexto.classList.toggle('is-dorsal', !!(sel && sel.dorsal));
      notaDorsal.hidden = !(sel && sel.dorsal);
      btnDupTxt.hidden = !!(sel && sel.dorsal);
      if (btnNombreTxt) btnNombreTxt.hidden = !!(sel && sel.dorsal);
      if (sel && sel.tipo === 'texto') {
        var t = sel.t;
        if (document.activeElement !== inpTexto) inpTexto.value = t.textContent;
        /* el navegador devuelve style.fontFamily sin las comillas ('Poppins',
           sans-serif → Poppins, sans-serif), así que se compara sin ellas */
        var sinComillas = function (v) { return String(v || '').replace(/['"]/g, ''); };
        var actual = sinComillas(t.style.fontFamily || FUENTES[0].v);
        for (var i = 0; i < FUENTES.length; i++) {
          if (sinComillas(FUENTES[i].v) === actual) { selFuente.selectedIndex = i; break; }
        }
        pintarBtnFuente();
        listaFuentes.hidden = true;
        selColor.value = rgbAHex(t.style.color) || '#17171a';
        var bd = sel.borde || { ancho: 0, color: "#ffffff" };
        selBorde.value = String(bd.ancho || 0);
        selColorBorde.value = bd.color || '#ffffff';
        recogerColores();
        btnNegrita.classList.toggle('is-activo', t.style.fontWeight === 'bold' || t.style.fontWeight === '700');
        btnCursiva.classList.toggle('is-activo', t.style.fontStyle === 'italic');
        btnSubrayado.classList.toggle('is-activo', t.style.textDecoration.indexOf('underline') !== -1);
      }
    }

    /* En el móvil, tocar un elemento lo selecciona (tiradores) pero NO abre
       el panel de opciones, que tapa la prenda (Xavi). El panel se abre con
       "Editar" en la barra de arriba o tocando otra vez el elemento ya
       seleccionado sin moverlo; al poner un texto nuevo se abre solo, que
       hay que escribir. */
    function seleccionar(el, conPanel) {
      if (seleccionado === el) return;
      host.classList.toggle('is-sin-panel', !!(el && esMovil() && !conPanel));
      if (seleccionado) seleccionado.div.classList.remove('is-sel');
      // un texto de ejemplo que se deja sin escribir se va solo
      if (seleccionado && seleccionado.ejemplo && !seleccionado.hueco) { var ej = seleccionado; seleccionado = null; borrar(ej); }
      seleccionado = el || null;
      if (seleccionado) seleccionado.div.classList.add('is-sel');
      refrescarOpciones();
      refrescarCapas();
      // en el móvil el panel de opciones es una ventana: "atrás" la cierra (deselecciona)
      if (seleccionado) historialAbrir('opciones', function () { seleccionar(null); });
      else historialCerrar('opciones');
      zoomAlEditar(el);
    }
    /* ZOOM AL EDITAR (Xavi, 04/10, estándar en todos los editores, como en banderas): al tocar un elemento para editarlo el lienzo se acerca
       a la zona para verlo bien y, al terminar (se toca fuera o se deselecciona), vuelve solo. Solo si la zona se ve pequeña en el lienzo
       (menos del 62 % del ancho): una panorámica que ya ocupa todo no se mueve. Si el cliente ha hecho zoom a mano, no se toca. */
    var zoomAuto = false, zoomInicialAlargada = false;
    function zoomAlEditar(el) {
      if (typeof zoom !== 'object' || !zoom || o.zoomAuto === false) return;
      if (el) {
        var vw = visor.clientWidth || host.clientWidth, cw = parseFloat(caja.style.width) || 0;
        if (!zoom.activo && cw && vw && cw / vw < 0.62) { zoomAuto = true; zoomMas(); }
      } else if (zoomAuto && zoom.activo && !zoom.foco) {
        zoomAuto = false; zoomMenos();
      }
    }

    // pinchar en el hueco (fuera de cualquier elemento) deselecciona
    capa.addEventListener('pointerdown', function (ev) {
      if (ev.target === capa || ev.target === caja) seleccionar(null);
    });

    // tocar en un hueco de la página (fuera del lienzo, panel y botones) también termina la edición y aleja el zoom
    document.addEventListener('pointerdown', function (ev) {
      if (!zoomAuto || !zoom.activo || zoom.foco) return;
      if (ev.target.closest && ev.target.closest('.edl__visor, .edl__opc, .edl__zoom, button, a, input, select, textarea, label, [role=dialog], dialog')) return;
      seleccionar(null); if (zoom.activo && zoomAuto) zoomMenos();
    });

    function textoSel() { return seleccionado && seleccionado.tipo === 'texto' ? seleccionado : null; }
    /* Suprimir (o Retroceso) con algo elegido lo borra, salvo que se esté
       escribiendo en un campo: ahí la tecla es para el texto (Xavi). */
    /* Y los cursores lo mueven: 1 px por pulsación, 10 con Mayúsculas,
       sin salirse de los límites, igual que al arrastrar (Xavi). */
    var FLECHAS = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
    window.addEventListener('keydown', function (ev) {
      if (!host.isConnected) return;
      var a = document.activeElement, tag = a && a.tagName;
      var enCampo = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable);
      // deshacer / rehacer (en un campo de texto manda el del navegador)
      if ((ev.ctrlKey || ev.metaKey) && !enCampo) {
        var k = String(ev.key || '').toLowerCase();
        if (k === 'z' && !ev.shiftKey) { ev.preventDefault(); deshacer(); return; }
        if (k === 'y' || (k === 'z' && ev.shiftKey)) { ev.preventDefault(); rehacer(); return; }
      }
      var esBorrar = ev.key === 'Delete' || ev.key === 'Backspace', paso = FLECHAS[ev.key];
      if (!esBorrar && !paso) return;
      if (!seleccionado) return;
      if (enCampo) return;
      ev.preventDefault();
      if (esBorrar) { borrar(seleccionado); return; }
      var el = seleccionado, k = ev.shiftKey ? 10 : 1;
      el.st.left += paso[0] * k; el.st.top += paso[1] * k;
      if (!el.fondo) acotar(el.st);
      el.aplicar();
    }, true); // en captura: que la página no haga scroll con las flechas mientras se mueve algo
    function imagenSel() { return seleccionado && seleccionado.tipo === 'imagen' ? seleccionado : null; }

    /* Cambiar de fuente o de negrita/cursiva cambia el ANCHO del texto, así
       que hay que volver a encajarlo en la caja. Dos veces: ahora (con la
       fuente de repuesto si la de Google aún no ha llegado) y cuando las
       fuentes terminen de cargar, que es cuando la medida es la buena. */
    function reajustarTexto(el) {
      if (!el) return;
      el.aplicar();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { if (el.div.isConnected) el.aplicar(); });
      }
    }
    selFuente.addEventListener('change', function () {
      var el = textoSel(); if (!el) return;
      el.t.style.fontFamily = selFuente.value;
      pintarBtnFuente();
      reajustarTexto(el);
    });
    selColor.addEventListener('input', function () { var el = textoSel(); if (el) el.t.style.color = selColor.value; });
    // al cerrar el picker (change), el color elegido pasa a las muestras
    selColor.addEventListener('change', function () { if (textoSel()) anotarColor(selColor.value); });
    function aplicarBorde() {
      var el = textoSel(); if (!el) return;
      el.borde = { ancho: parseFloat(selBorde.value) || 0, color: selColorBorde.value };
      el.aplicar();
      if (el.borde.ancho) anotarColor(el.borde.color);
    }
    selBorde.addEventListener('change', aplicarBorde);
    selColorBorde.addEventListener('input', aplicarBorde);
    inpTexto.addEventListener('input', function () {
      var el = textoSel(); if (!el) return;
      if (el.ejemplo && inpTexto.value.trim()) { el.ejemplo = false; el.div.classList.remove('edl__el--ejemplo'); }
      el.t.textContent = inpTexto.value;
      el.aplicar();      // más letras pueden dejar de caber a lo ancho
      refrescarCapas();  // la fila de capas enseña el texto
    });
    btnNegrita.addEventListener('click', function () {
      var el = textoSel(); if (!el) return;
      var t = el.t;
      t.style.fontWeight = t.style.fontWeight === 'bold' || t.style.fontWeight === '700' ? 'normal' : 'bold';
      refrescarOpciones(); reajustarTexto(el);
    });
    btnCursiva.addEventListener('click', function () {
      var el = textoSel(); if (!el) return;
      var t = el.t;
      t.style.fontStyle = t.style.fontStyle === 'italic' ? 'normal' : 'italic';
      refrescarOpciones(); reajustarTexto(el);
    });
    btnSubrayado.addEventListener('click', function () {
      var el = textoSel(); if (!el) return;
      var t = el.t;
      t.style.textDecoration = t.style.textDecoration.indexOf('underline') !== -1 ? 'none' : 'underline';
      refrescarOpciones();
    });
    btnDupTxt.addEventListener('click', function () { var el = textoSel(); if (el) duplicar(el); });
    btnBorrarTxt.addEventListener('click', function () { var el = textoSel(); if (el) borrar(el); });
    function medirDesde(campo) {
      var el = imagenSel(); if (!el || el.fondo) return;
      var esc = escalaPxCm(), v = parseFloat(String(campo.value).replace(',', '.'));
      if (!esc || !(v > 0)) return;
      cxRef = el.st.left + el.st.w / 2;
      var ratio = el.st.h / el.st.w, rs = rectSeguro();
      var w = campo === inpAnchoCm ? v * esc : v * esc / ratio, h = w * ratio;
      // no más grande que el área de seguridad
      var kMax = Math.min((rs.x1 - rs.x0) / w, (rs.y1 - rs.y0) / h, 1);
      w *= kMax; h *= kMax;
      var cx = el.st.left + el.st.w / 2, cy = el.st.top + el.st.h / 2;
      el.st.left = cx - w / 2; el.st.top = cy - h / 2;
      el.aplicarTamaño(w, h);
      acotar(el.st); el.aplicar();
      refrescarOpciones();
    }
    inpAnchoCm.addEventListener('change', function () { medirDesde(inpAnchoCm); });
    inpAltoCm.addEventListener('change', function () { medirDesde(inpAltoCm); });
    [inpAnchoCm, inpAltoCm].forEach(function (i) { i.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); i.blur(); } }); });
    /* ---------- técnica de impresión (productos que imprime el proveedor) ----------
       La técnica fija cuántos colores admite el logo: láser = 1 (tono de grabado), tampografía = hasta 4 planos.
       El logo se ajusta solo, como saldrá, y la técnica viaja en el pedido. */
    /* Cada zona (vista) tiene SU técnica: la de un elemento es la de la zona donde cae su centro. Sin elemento (o si aún no
       está en la lista, porque se está creando), la de la zona que se está viendo. */
    function vistaDe(el) {
      var i = elementos.indexOf(el);
      if (i < 0 || vistas.length < 2) return zona;
      var q = posicionesCm()[i];
      if (!q) return zona;
      for (var k = 0; k < vistas.length; k++) {
        var v = vistas[k].ventana || [0, 0], a = Col.area(vistas[k]);
        if (q.cx >= v[0] && q.cx < v[0] + a[0]) return vistas[k];
      }
      return zona;
    }
    function tecDe(el) {
      if (!tecnicas) return null;
      if (!el) return tec;
      var v = vistaDe(el);
      return v === zona ? tec : (tecPorVista[v.id] || tecnicas[0]);
    }
    function tecActiva(el) { var T = tecDe(el); return T && T.colores ? T : null; }
    function unaTinta(el) { var T = tecDe(el); return !!o.tintaFija || !!(T && T.colores === 1); }
    function aplicarTec(el) {
      if (!el || el.tipo !== 'imagen' || el.fondo || el._cargando) return;
      var T = tecActiva(el);
      if (T && T.colores === 1) {
        /* Serigrafía de 1 color: la tinta la elige el cliente (T.tintaLibre); mientras no elija, la que se lee sobre la prenda:
           blanca sobre prenda oscura, negra sobre clara. El grabado láser lleva su tono fijo (T.tinta). */
        var tinta = T.tinta || (T.tintaLibre ? (el.tintaElegida || (esOscuro(color) ? '#ffffff' : '#111111')) : '#8a949a');
        if (!el.mono || el.monoTec) { el.mono = tinta; el.monoTec = true; }
      } else if (el.monoTec) { el.mono = null; el.monoTec = false; }
      tintar(el);
    }
    /* COLORES COMPARTIDOS DE LA ZONA: todo lo que va en una zona se imprime a la vez, con las mismas pantallas (Xavi, 07/10).
       Dos logos de 4 colores NO son 4 pantallas, son hasta 8; y lo que se ponga después comparte los colores que ya hay. */
    function rgbHex(h) { var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(h || ''); return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null; }
    function d2rgb(a, b) { var x = a[0] - b[0], y = a[1] - b[1], z = a[2] - b[2]; return x * x + y * y + z * z; }
    /* colores (rgb) que ya llevan las imágenes MÁS SIMPLES de la zona de `el` (menos colores propios; a igualdad, la que se subió antes):
       primero el simple se queda con sus colores exactos y el de muchos matices usa los huecos que sobran y se une a los que ya hay.
       Así no depende del orden en que se suban (Xavi, 07/10). */
    function coloresRef(el) {
      var z = vistaDe(el), out = [], io = elementos.indexOf(el);
      elementos.forEach(function (e) {
        if (e === el || e.tipo !== 'imagen' || e.fondo || e.ejemplo || !e.visible || vistaDe(e) !== z || !e.paleta || e.mono) return;
        if (!(e.nPropios < el.nPropios || (e.nPropios === el.nPropios && elementos.indexOf(e) < io))) return;
        e.paleta.forEach(function (q) { if (!q.quitado && !q.oculto) { var r = rgbHex(q.hexAct); if (r && !out.some(function (o) { return d2rgb(o, r) < 3600; })) out.push(r); } });
      });
      return out;
    }
    function firmaRef(el) { return coloresRef(el).map(function (r) { return r.map(Math.round).join(','); }).join('|'); }
    // tras cambiar la paleta de una imagen (o borrar una), las más ricas de la zona se ajustan otra vez si lo que comparten ha cambiado
    function resincZona(z) {
      elementos.forEach(function (e) {
        if (e.tipo !== 'imagen' || e.fondo || e.ejemplo || e.mono || !e.paleta || e._reduciendo || vistaDe(e) !== z) return;
        var T = tecActiva(e); if (!T || !(T.colores > 1)) return;
        if (firmaRef(e) !== e._refSig) tintar(e);
      });
    }
    // máximo de colores de la zona: lo que haya fijado el cliente o, si no, los 4 recomendados
    function topeZona(el, nMax) {
      var z = vistaDe(el), fijo = 0;
      elementos.forEach(function (e) { if (e.tipo === 'imagen' && !e.fondo && !e.ejemplo && vistaDe(e) === z && e.nCol > fijo) fijo = e.nCol; });
      return Math.max(1, Math.min(nMax, fijo || 4));
    }
    // cuántos colores distintos lleva una zona entre todas sus imágenes (los tonos casi iguales cuentan una vez)
    function coloresUnion(z, T) {
      var out = [], sinPaleta = 0;
      elementos.forEach(function (e) {
        if (!e.visible || e.ejemplo || e.dorsal || e.fondo || e.tipo !== 'imagen' || vistaDe(e) !== z) return;
        if (!e.paleta) { sinPaleta = Math.max(sinPaleta, Math.min(T.colores, e.nCol || 2)); return; }   // la reducción es asíncrona: un valor bajo hasta que esté
        e.paleta.forEach(function (q) { if (!q.quitado && !q.oculto) { var r = rgbHex(q.hexAct); if (r && !out.some(function (o) { return d2rgb(o, r) < 3600; })) out.push(r); } });
      });
      return Math.max(out.length, sinPaleta);
    }
    function reducirColores(el, nMax) {
      // sin número fijado por el cliente, se propone como mucho 4 colores (RECOMENDADOS: más colores, más pantallas, más caro); el cliente puede subir hasta nMax
      var auto = !el.nCol, n = Math.max(1, Math.min(nMax, el.nCol || Math.min(nMax, 4)));
      var base = new Image(), ficha = (el._redTok = (el._redTok || 0) + 1);
      el._reduciendo = true;
      base.onload = async function () {
        if (ficha !== el._redTok) return;   // ya hay un cambio más reciente en marcha: este resultado ya no vale
        var f = Math.min(1, 1600 / Math.max(base.naturalWidth, base.naturalHeight));
        var w = Math.max(1, Math.round(base.naturalWidth * f)), h = Math.max(1, Math.round(base.naturalHeight * f));
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.drawImage(base, 0, 0, w, h);
        try {
          var id = ctx.getImageData(0, 0, w, h), d = id.data, i, k, it;
          function dist(a, b) { var x = a[0] - b[0], y = a[1] - b[1], z = a[2] - b[2]; return x * x + y * y + z * z; }
          // fondo blanco de un JPG (color de las esquinas): no es tinta ni gasta uno de los colores permitidos
          var bgCol = null;
          if (el.fondoBlanco !== false) {
            [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]].some(function (pt) {
              var qi = (pt[1] * w + pt[0]) * 4;
              if (d[qi + 3] < 128) return false;
              if ((0.299 * d[qi] + 0.587 * d[qi + 1] + 0.114 * d[qi + 2]) / 255 > 0.9) { bgCol = [d[qi], d[qi + 1], d[qi + 2]]; return true; }
              return false;
            });
          }
          /* El reparto en colores (muestra + k-means) solo depende de la imagen y del número de colores: se guarda y, si el cliente
             solo cambia o quita un color, se reutiliza (antes se recalculaba entero y el móvil iba a trompicones). */
          var clave = (auto ? 'a' : '') + n + '|' + (el.fondoBlanco !== false) + '|' + w + 'x' + h;
          var km = el._km && el._km.clave === clave ? el._km : null, C, todos, fondoIdx, cuenta;
          function d2(a, b0, b1, b2) { var x = a[0] - b0, y = a[1] - b1, z = a[2] - b2; return x * x + y * y + z * z; }
          function cerca(r0, g0, b0, lista) { var bi = lista[0], bd = Infinity; for (var q = 0; q < lista.length; q++) { var dd = d2(C[lista[q]], r0, g0, b0); if (dd < bd) { bd = dd; bi = lista[q]; } } return bi; }
          if (km) { C = km.C; todos = km.todos; fondoIdx = km.fondoIdx; cuenta = km.cuenta; bgCol = km.bgCol; }
          else {
            var paso = Math.max(1, Math.floor(w * h / 40000)), S = [];
            for (i = 0; i < w * h; i += paso) if (d[i * 4 + 3] >= 128) { var qs = [d[i * 4], d[i * 4 + 1], d[i * 4 + 2]]; if (!bgCol || dist(qs, bgCol) > 2400) S.push(qs); }
            if (!S.length) return;
            C = [S[0]];
            while (C.length < n) {
              var mejor = null, md = -1;
              S.forEach(function (q) { var dm = Infinity; C.forEach(function (cc) { dm = Math.min(dm, dist(q, cc)); }); if (dm > md) { md = dm; mejor = q; } });
              if (md < (auto ? 4900 : 300)) break;   // automático: solo colores bien distintos (≈70 de distancia); si el cliente fija el número, se respeta
              C.push(mejor);
            }
            todos = C.map(function (_, ix) { return ix; });
            var lloyd = function (vueltas, SS) {
              SS = SS || S;
              for (var it2 = 0; it2 < vueltas; it2++) {
                var acc = C.map(function () { return [0, 0, 0, 0]; });
                SS.forEach(function (q) { var bi = cerca(q[0], q[1], q[2], todos); acc[bi][0] += q[0]; acc[bi][1] += q[1]; acc[bi][2] += q[2]; acc[bi][3]++; });
                acc.forEach(function (a, ai) { if (a[3]) C[ai] = [a[0] / a[3], a[1] / a[3], a[2] / a[3]]; });
              }
            };
            lloyd(8);
            /* Sin número fijado por el cliente, se agrupan los tonos: un color que casi no aparece (menos del 4 % de la tinta, el
               ruido del antialiasing o de una trama) se une al más parecido, y dos colores muy cercanos se funden. Antes salían
               siempre tantos colores como el máximo (Xavi, 06/10: «me pone 8 y serían 2 o 3»). */
            if (auto && C.length > 1) {
              // con una muestra pequeña (≈ 4000 puntos): agrupar tonos no necesita más y en el móvil con toda la muestra tardaba decenas de segundos
              var Ss = S.length > 4000 ? S.filter(function (_, ix) { return ix % Math.ceil(S.length / 4000) === 0; }) : S;
              for (var gd = 0; gd < 12 && C.length > 1; gd++) {
                todos = C.map(function (_, ix) { return ix; });
                var cn = C.map(function () { return 0; });
                Ss.forEach(function (q) { cn[cerca(q[0], q[1], q[2], todos)]++; });
                var mn = 0; cn.forEach(function (v, ix) { if (v < cn[mn]) mn = ix; });
                if (cn[mn] < Ss.length * 0.04) { C.splice(mn, 1); todos = C.map(function (_, ix) { return ix; }); lloyd(1, Ss); continue; }
                var pi = -1, pj = -1, pd = 3600;
                for (var xa = 0; xa < C.length; xa++) for (var xb = xa + 1; xb < C.length; xb++) { var dd2 = dist(C[xa], C[xb]); if (dd2 < pd) { pd = dd2; pi = xa; pj = xb; } }
                if (pi >= 0) { var tt = (cn[pi] + cn[pj]) || 1, cp = C[pi], cq = C[pj]; C[pi] = [0, 1, 2].map(function (k) { return (cp[k] * cn[pi] + cq[k] * cn[pj]) / tt; }); C.splice(pj, 1); todos = C.map(function (_, ix) { return ix; }); lloyd(1, Ss); continue; }
                break;
              }
              todos = C.map(function (_, ix) { return ix; });
            }
            fondoIdx = -1;
            if (bgCol) { C.push(bgCol); fondoIdx = C.length - 1; todos = C.map(function (_, ix) { return ix; }); }
            // cuántos píxeles tiene cada color (para ordenar la paleta)
            cuenta = C.map(function () { return 0; });
            S.forEach(function (q) { cuenta[cerca(q[0], q[1], q[2], todos)]++; });
            el._km = { clave: clave, C: C, todos: todos, fondoIdx: fondoIdx, cuenta: cuenta, bgCol: bgCol };
          }
          /* Prenda negra: el negro del diseño no se imprime (se aprovecha el color de la prenda), ni cuenta como tinta ni como pantalla
             (Xavi, 07/10). Sus píxeles quedan transparentes. Si el diseño es solo negro, se deja como está. */
          var negros = {}, nNegros = 0;   // si el cliente le da otro color al negro (p. ej. blanco), ya se imprime
          if (prendaNegra() && !el.imprimirNegro) {
            todos.forEach(function (ix) { if (ix !== fondoIdx && esNegro(C[ix]) && !(el.colCambia || {})[ix]) { negros[ix] = true; nNegros++; } });
            if (!todos.some(function (ix) { return ix !== fondoIdx && !negros[ix]; })) { negros = {}; nNegros = 0; }
          }
          el.negroOculto = nNegros > 0;
          // colores que el cliente ha quitado: sus píxeles pasan al más parecido de los que quedan
          var quita = el.colQuita || {};
          var cambia = el.colCambia || {};
          /* Colores compartidos con lo que ya hay en la zona: cada color de este diseño se une al más parecido de la zona; solo añade
             colores nuevos si caben por debajo del tope de la zona (los más presentes, primero). Lo que no cabe va al más cercano. */
          el.nPropios = todos.filter(function (ix) { return ix !== fondoIdx; }).length;   // colores propios de este diseño, antes de compartir
          var snap = {}, fusion = {}, refs = coloresRef(el);
          el._refSig = firmaRef(el);
          if (refs.length) {
            var tope = topeZona(el, nMax), acept = refs.slice(), repDe = {};
            todos.filter(function (ix) { return ix !== fondoIdx && !negros[ix] && !quita[ix] && !cambia[ix]; })
              .sort(function (a, b) { return cuenta[b] - cuenta[a]; })
              .forEach(function (ix) {
                var bi = 0, bd = Infinity, cx = [C[ix][0], C[ix][1], C[ix][2]];
                acept.forEach(function (r, k) { var dd = d2rgb(cx, r); if (dd < bd) { bd = dd; bi = k; } });
                if (!(bd < 3600) && acept.length < tope) { acept.push(cx); bi = acept.length - 1; }   // color nuevo con hueco: se queda como es
                if (repDe[bi] === undefined) { repDe[bi] = ix; if (bi < refs.length) snap[ix] = '#' + refs[bi].map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }
                else fusion[ix] = repDe[bi];   // dos colores de este diseño que caen en el mismo de la zona: uno solo
              });
          }
          el.colCompartidos = Object.keys(snap).length + Object.keys(fusion).length > 0;
          var vivos = todos.filter(function (ix) { return ix !== fondoIdx && !negros[ix] && !fusion[ix] && !quita[ix]; });
          if (!vivos.length) vivos = todos.filter(function (ix) { return ix !== fondoIdx && !negros[ix]; });
          if (!vivos.length) vivos = todos;
          var dest = todos.map(function (ix) { return fusion[ix] !== undefined ? fusion[ix] : vivos.indexOf(ix) >= 0 ? ix : cerca(C[ix][0], C[ix][1], C[ix][2], vivos); });
          function rgbDe(ix) {
            var hx = cambia[ix] || snap[ix];
            if (hx) { var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hx); if (m) return [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)]; }
            return [Math.round(C[ix][0]), Math.round(C[ix][1]), Math.round(C[ix][2])];
          }
          function hex(rgb) { return '#' + rgb.map(function (v) { return ('0' + Math.max(0, Math.min(255, Math.round(v))).toString(16)).slice(-2); }).join(''); }
          // la paleta lleva TAMBIÉN los colores quitados (tachados en el panel) para poder volver a ponerlos
          el.paleta = todos.filter(function (ix) { return ix !== fondoIdx && !fusion[ix]; }).sort(function (a, b) { return cuenta[b] - cuenta[a]; })
            .map(function (ix) { return { i: ix, hexOrig: hex(C[ix]), hexAct: hex(rgbDe(ix)), quitado: !negros[ix] && vivos.indexOf(ix) < 0, oculto: !!negros[ix] }; });   // oculto: negro sobre prenda negra, sale en la selección pero no se imprime ni cuenta
          setTimeout(function () { resincZona(vistaDe(el)); }, 0);
          // cada píxel al color más cercano; con una tabla por colores de 5 bits (32 768 entradas) en vez de buscar píxel a píxel
          var salida = todos.map(function (ix) { return rgbDe(dest[ix]); });
          var lut = new Int16Array(32768).fill(-1), tot = w * h;
          for (i = 0; i < tot; i++) {
            /* cada ~250 000 píxeles se cede el hilo: con una foto de 2000 px el móvil se quedaba 4-5 s sin pintar ni responder (el panel de compra
               se veía a medias y el desplazamiento iba a trompicones) */
            if (i && (i & 262143) === 0) { await new Promise(function (ok) { setTimeout(ok, 0); }); if (ficha !== el._redTok) return; }
            var j = i * 4;
            if (d[j + 3] < 128) { d[j + 3] = 0; continue; }
            var kq = ((d[j] >> 3) << 10) | ((d[j + 1] >> 3) << 5) | (d[j + 2] >> 3), b2 = lut[kq];
            if (b2 < 0) { b2 = cerca(d[j], d[j + 1], d[j + 2], todos); lut[kq] = b2; }
            if (b2 === fondoIdx || negros[b2]) { d[j + 3] = 0; continue; }
            var rgb = salida[b2];
            d[j] = rgb[0]; d[j + 1] = rgb[1]; d[j + 2] = rgb[2]; d[j + 3] = 255;
          }
          ctx.putImageData(id, 0, 0);
          if (!el.mono && tecActiva(el) && tecActiva(el).colores === nMax) {
            var acabar = function (url) {
              if (ficha !== el._redTok) return;
              if (el._urlRed) { try { URL.revokeObjectURL(el._urlRed); } catch (e2) { /* ya liberada */ } }
              el._urlRed = url.indexOf('blob:') === 0 ? url : null;
              el.img.src = url;
              el._reduciendo = false;
              if (fondoIdx >= 0) { el.fondoDetectado = null; comprobarFondos(); }   // el fondo blanco ya se ha quitado: se acaba el aviso «Fondo»
              if (refrescarImpresion) refrescarImpresion();
              avisarCambio();   // la paleta ya está al día: el precio depende de los colores usados
            };
            if (c.toBlob && window.URL && URL.createObjectURL) c.toBlob(function (bl) { acabar(bl ? URL.createObjectURL(bl) : c.toDataURL('image/png')); }, 'image/png');
            else acabar(c.toDataURL('image/png'));
          } else el._reduciendo = false;
        } catch (e) { el._reduciendo = false; /* imagen de otro origen: se deja como está */ }
      };
      base.src = el.srcBase;
      var nota = panelImp && panelImp.querySelector('[data-imp-estado]'); if (nota) nota.textContent = 'Calculando colores…';   // sin reconstruir el panel (así no se cierra el selector de color)
    }
    /* teñir a un color: se parte siempre de la imagen sin teñir (srcBase),
       así cambiar de color o desmarcar no degrada nada */
    function tintar(el) {
      if (!el.srcBase) el.srcBase = el.img.src;
      var TEC = tecActiva(el), tok = (el._tintaTok = (el._tintaTok || 0) + 1);   // tok: si llega otro tintar antes de acabar, este resultado ya no vale
      if (!el.mono && TEC && TEC.colores > 1 && !el.fondo) { reducirColores(el, TEC.colores); return; }
      if (!el.mono) { el.img.src = el.srcBase; return; }
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(el.mono);
      if (!m) return;
      var r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
      var base = new Image();
      base.onload = async function () {
        if (tok !== el._tintaTok) return;
        el._baseImg = base;
        /* A 1600 px como mucho (la foto se sube a 2000) y cediendo el hilo entre fases: en el móvil el teñido de una foto grande dejaba la
           página 4-5 s sin pintar. */
        var kT = Math.min(1, 1600 / Math.max(base.naturalWidth, base.naturalHeight, 1));
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(base.naturalWidth * kT)); c.height = Math.max(1, Math.round(base.naturalHeight * kT));
        var ctx = c.getContext('2d'); ctx.drawImage(base, 0, 0, c.width, c.height);
        var cede = function () { return new Promise(function (ok) { setTimeout(ok, 0); }); };
        await cede(); if (tok !== el._tintaTok) return;
        try {
          var id = ctx.getImageData(0, 0, c.width, c.height), d = id.data;
          await cede(); if (tok !== el._tintaTok) return;
          if (unaTinta(el)) {
            /* sello (una sola tinta): lo oscuro queda macizo y lo claro transparente, como saldrá en el papel */
            /* PNG con transparencia (un logo hecho para fondo oscuro, con letras blancas): todo lo que no es transparente
               pasa a tinta; si no, lo blanco desaparecería. Un JPG con fondo blanco (sin transparencia) se resuelve por luminosidad. */
            var transp = 0, opacos = 0, claros = 0, expuestos = 0, cw = c.width, ch = c.height;
            function clara(i) { return d[i + 3] >= 128 && (0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]) / 255 > 0.8; }
            function hueco(x, y) { return x < 0 || y < 0 || x >= cw || y >= ch || d[(y * cw + x) * 4 + 3] < 128; }
            for (var y = 0; y < ch; y++) {
              if (y && y % 300 === 0) { await cede(); if (tok !== el._tintaTok) return; }
              for (var x = 0; x < cw; x++) {
                var qi = (y * cw + x) * 4;
                if (d[qi + 3] < 128) { transp++; continue; }
                opacos++;
                if (!clara(qi)) continue;
                claros++;
                if (hueco(x - 2, y) || hueco(x + 2, y) || hueco(x, y - 2) || hueco(x, y + 2)) expuestos++;
              }
            }
            /* Blanco = ¿tinta o papel? Un logo hecho para fondo oscuro (letras blancas sueltas sobre transparente) tiene su blanco
               pegado al vacío: todo pasa a tinta. Un escudo o un logo en color tiene el blanco rodeado de color (franjas, letras
               dentro de una forma): ahí el blanco es papel. Un JPG con fondo blanco (sin transparencia) también va por luminosidad.
               El cliente puede cambiarlo con el botón del panel. */
            el.tintaAuto = (transp > cw * ch * 0.02 && claros > opacos * 0.1 && expuestos > claros * 0.6) ? 'alfa' : 'lum';
            /* Un JPG con el fondo NEGRO metido en la imagen (arte hecho para camiseta oscura): lo negro es el fondo, no tinta; la tinta
               es lo claro. Se nota en las esquinas. Sin esto, el fondo negro se imprimía macizo y el dibujo desaparecía. */
            var esqOscuras = [0, cw - 1, (ch - 1) * cw, ch * cw - 1].filter(function (q) { var k = q * 4; return d[k + 3] >= 128 && (0.299 * d[k] + 0.587 * d[k + 1] + 0.114 * d[k + 2]) / 255 < 0.18; }).length;
            if (esqOscuras >= 3 && transp < cw * ch * 0.02) el.tintaAuto = 'inv';
            else if (transp > cw * ch * 0.02 && opacos) {
              /* Arte pensado para camiseta oscura al que ya se le ha quitado el fondo negro (queda transparente): lo CLARO es la tinta
                 y lo oscuro del interior es detalle, no tinta. Se nota en que lo que queda es, en media, claro. */
              var sumaL = 0, nL = 0;
              for (var jl = 0; jl < d.length; jl += 16) { if (d[jl + 3] >= 128) { sumaL += (0.299 * d[jl] + 0.587 * d[jl + 1] + 0.114 * d[jl + 2]) / 255; nL++; } }
              if (nL && sumaL / nL > 0.4) el.tintaAuto = 'inv';
            }
            var modoT = el.tintaModo || el.tintaAuto, conAlfa = modoT === 'alfa';
            var binarioSer = !!(TEC && /serigraf/i.test(TEC.nombre || ''));
            var semi = !!el.semitono && !o.sinSemitono, celda = 8, papel = 1;
            if (semi) {
              var escS = escalaPxCm(), cmAncho = escS && !isNaN(escS) ? el.st.w / escS : 20;
              celda = Math.max(4, cw / (Math.max(2, cmAncho) * 12));   // unos 12 puntos por cm (≈30 lpi, lo normal en textil)
              conAlfa = false;
              // el papel de la imagen (beige, gris claro…) no lleva puntos: el tono se mide respecto a la luminosidad de las esquinas
              var lq = [0, cw - 1, (ch - 1) * cw, ch * cw - 1].map(function (q) { var k = q * 4; return d[k + 3] >= 128 ? (0.299 * d[k] + 0.587 * d[k + 1] + 0.114 * d[k + 2]) / 255 : 1; });
              papel = Math.max(0.8, Math.min(1, lq.reduce(function (a2, b2) { return a2 + b2; }, 0) / 4));
            }
            if (el.tintaAutoVisto !== el.tintaAuto) { el.tintaAutoVisto = el.tintaAuto; if (typeof refrescarOpciones === 'function' && imagenSel() === el) setTimeout(refrescarOpciones, 0); }
            for (var j = 0; j < d.length; j += 4) {
              if (j && (j & 1048575) === 0) { await cede(); if (tok !== el._tintaTok) return; }
              var lum = (0.299 * d[j] + 0.587 * d[j + 1] + 0.114 * d[j + 2]) / 255;
              var corte = o.tintaFija ? 0.72 : 0.9;   // grabado láser: el gris claro también se graba; solo el casi blanco es papel
              var v = conAlfa ? 1 : modoT === 'inv' ? Math.max(0, Math.min(1, (lum - 0.15) / 0.35)) : Math.max(0, Math.min(1, (corte - lum) / 0.2));
              if (semi) {
                /* SEMITONO: la tinta no puede ser gris, así que los tonos se hacen con puntos más grandes o más pequeños (trama a 45°).
                   Tono = lo oscuro (o lo claro en arte para prenda oscura); la medida de la trama sale de los cm reales de la imagen. */
                var tono = modoT === 'inv' ? Math.max(0, Math.min(1, (lum - 0.08) / 0.8)) : Math.max(0, Math.min(1, (papel - 0.02 - lum) / (papel * 0.9)));
                var px = (j / 4) % cw, py = Math.floor(j / 4 / cw);
                var uu = (px * 0.7071 + py * 0.7071) / celda, vv = (-px * 0.7071 + py * 0.7071) / celda;
                var fx = uu - Math.floor(uu) - 0.5, fy = vv - Math.floor(vv) - 0.5, dc = Math.sqrt(fx * fx + fy * fy);
                var rad = Math.sqrt(tono / Math.PI) * 1.02, borde = 1 / celda;
                v = tono < 0.06 ? 0 : Math.max(0, Math.min(1, (rad - dc) / borde + 0.5));
              }
              d[j] = r; d[j + 1] = g; d[j + 2] = b;
              /* SERIGRAFÍA (una pantalla, una tinta): la tinta o está o no está, sin grises (los grises, o van con semitono, o no se pueden imprimir ni vectorizar).
                 Se corta a tinta/nada para que el cliente vea ya lo que saldrá y MidOcean reciba un dibujo limpio (Xavi, 06/10). */
              if (binarioSer && o.sinSemitono && !semi) d[j + 3] = (d[j + 3] * v) >= 128 ? 255 : 0;
              else d[j + 3] = Math.round(d[j + 3] * v);
            }
          } else {
            for (var i = 0; i < d.length; i += 4) { if (d[i + 3]) { d[i] = r; d[i + 1] = g; d[i + 2] = b; } }
          }
          ctx.putImageData(id, 0, 0);
          /* A un blob (toBlob, que codifica fuera del hilo) y no a un data: de varios MB (toDataURL bloqueaba el móvil y luego había que
             decodificar la cadena para subirla). */
          if (c.toBlob && window.URL && URL.createObjectURL) {
            c.toBlob(function (bl) {
              if (tok !== el._tintaTok) return;   // ya hay otro teñido más reciente
              var u = bl ? URL.createObjectURL(bl) : c.toDataURL('image/png');
              if (el._urlTinta) { try { URL.revokeObjectURL(el._urlTinta); } catch (e2) { /* ya liberada */ } }
              el._urlTinta = bl ? u : null;
              el.img.src = u;
            }, 'image/png');
          } else el.img.src = c.toDataURL('image/png');
        } catch (e) { /* imagen de otro origen: se deja como está */ }
      };
      base.src = el.srcBase;
    }
    /* Un arreglo sobre la imagen base (sin teñir): cambia srcBase, guarda
       la de antes para deshacer, y vuelve a teñir si estaba a un color. */
    function lienzoDe(src, fn) {
      var im = new Image();
      im.onload = function () {
        var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
        c.getContext('2d').drawImage(im, 0, 0);
        fn(c);
      };
      im.src = src;
    }
    function arreglar(el, tipo) {
      if (!el || el.tipo !== 'imagen' || !window.ImgArreglo) return;
      if (!el.srcBase) el.srcBase = el.img.src;
      lienzoDe(el.srcBase, function (c) {
        var res;
        try {
          if (tipo === 'negro') res = ImgArreglo.fundirNegro(c);
          else {
            /* Solo el fondo que toca el borde (relleno desde el marco), no
               todo el blanco: las rayas blancas de un escudo se quedan (Xavi:
               "ha quitado todo el blanco"). Si no encuentra fondo liso, el
               umbral de siempre. */
            /* La imagen ya viene recortada al dibujo (recortarAlfa), y a
               quitarFondo un dibujo que llena el marco le parece "mezclado":
               se le da un margen del color del borde para que el relleno
               tenga por dónde entrar. El aire que queda lo ciñe recortarAlfa. */
            var cm = c;
            if (ImgArreglo.quitarFondo) {
              var b = ImgArreglo.colorBorde ? ImgArreglo.colorBorde(c) : null, mg = Math.round(Math.max(c.width, c.height) * 0.12) + 4;
              cm = document.createElement('canvas'); cm.width = c.width + 2 * mg; cm.height = c.height + 2 * mg;
              var cx = cm.getContext('2d');
              cx.fillStyle = b ? 'rgb(' + Math.round(b.r) + ',' + Math.round(b.g) + ',' + Math.round(b.b) + ')' : '#fff';
              cx.fillRect(0, 0, cm.width, cm.height); cx.drawImage(c, mg, mg);
              res = ImgArreglo.quitarFondo(cm);
            } else res = null;
            if (!res || !res.ok) { quitarBlanco(c, 236); res = { ok: true, lienzo: c }; }
          }
        } catch (e) { res = { ok: false }; }
        if (!res || !res.ok) {
          alert(tipo === 'negro' ? 'No hemos encontrado negro que fundir en esta imagen.' : 'No hemos podido quitar el fondo.');
          return;
        }
        if (!el.srcOriginal) el.srcOriginal = el.srcBase;
        el.arreglos = (el.arreglos || []).concat(tipo);
        el.srcBase = res.lienzo.toDataURL('image/png');
        // sin fondo queda aire alrededor: la caja se ciñe al dibujo
        var rec = recortarAlfa(res.lienzo);
        if (rec && (rec.w < res.lienzo.width - 4 || rec.h < res.lienzo.height - 4)) { ceñirCaja(el, rec); el.srcBase = el.img.src; }
        else el.img.src = el.srcBase;
        if (el.mono || tecActiva(el)) tintar(el);
        refrescarOpciones(); refrescarCapas();
      });
    }
    /* ---------- quitar fondo con tolerancia y modo ----------
       El deslizador va de 0 a 100: t1 (se borra del todo) de 12 a 140 y t2
       (borde difuminado) 60 más. "Contiguo" = relleno desde el marco
       (ImgArreglo.quitarFondo, con margen del color del borde como en
       arreglar); "todo" = cada píxel parecido al color del fondo, esté donde
       esté. El color del fondo es el del borde de la imagen (colorBorde). */
    var qf = { el: null, base: null, timer: null, ultimo: null, lienzoBase: null, colores: [], varita: false };
    function abrirQuitarFondo(el) {
      if (!el || el.tipo !== 'imagen' || !window.ImgArreglo) return;
      if (!el.srcBase) el.srcBase = el.img.src;
      qf.el = el; qf.base = el.srcBase; qf.ultimo = null; qf.lienzoBase = null; qf.colores = [];
      varitaActiva(false); pintarChips();
      quitarConsejo();
      host.classList.remove('is-sin-panel');   // en móvil esa clase esconde TODAS las opciones (display:none !important): sin quitarla, «Quitar fondo» abría un panel invisible
      cajaFondo.hidden = false; cajaImagen.hidden = true;
      modoQfMovil(true, el);
      notaFondo.textContent = '';
      lienzoDe(qf.base, function (c) { qf.lienzoBase = c; previsualizarFondo(); });
    }
    /* Móvil (Xavi, 29/09): al quitar el fondo se cierra todo lo demás: el diseño
       se ve de cerca y las opciones quedan en una columna al lado, sin tapar
       nada (CSS: .is-qfondo). Al cerrar, el zoom vuelve a como estaba. */
    var qfZoomAuto = false;
    function modoQfMovil(si, el) {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      host.classList.toggle('is-qfondo', !!si);
      if (si) {
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (!host.classList.contains('is-qfondo') || !el || !el.div) return;
          if (zoom.activo) return;
          zoom.foco = el.div; qfZoomAuto = true; zoomMas(); setTimeout(centrarZoom, 300); setTimeout(centrarZoom, 900);
        }); });
      } else {
        if (qfZoomAuto) { zoomMenos(); }
        qfZoomAuto = false; zoom.foco = null;
      }
    }
    function varitaActiva(si) {
      qf.varita = !!si;
      host.classList.toggle('is-varita', qf.varita);
      btnVarita.classList.toggle('is-on', qf.varita);
      btnVarita.textContent = qf.varita ? '🪄 Toca en el diseño el color a quitar' : '🪄 Varita: quitar otro color';
    }
    function pintarChips() {
      chipsFondo.hidden = !qf.colores.length;
      chipsFondo.innerHTML = qf.colores.map(function (c, i) {
        return '<span class="edl__opc__chip"><i style="background:rgb(' + c.r + ',' + c.g + ',' + c.b + ')"></i>' +
          '<button type="button" data-chip="' + i + '" aria-label="Quitar este color de la lista">×</button></span>';
      }).join('');
    }
    // "varita" en modo contiguo: relleno desde el punto tocado, con la misma tolerancia
    function quitarDesde(c, x0, y0, col, t1, t2) {
      var ctx = c.getContext('2d'), d = ctx.getImageData(0, 0, c.width, c.height), p = d.data, w = d.width, h = d.height, n = w * h;
      var visto = new Uint8Array(n), pila = new Int32Array(n), tope = 0, borrados = 0;
      function dist(i) { var dr = p[i * 4] - col.r, dg = p[i * 4 + 1] - col.g, db = p[i * 4 + 2] - col.b; return Math.sqrt(dr * dr + dg * dg + db * db); }
      function empuja(i) { if (visto[i] || p[i * 4 + 3] < 8 || dist(i) > t2) return; visto[i] = 1; pila[tope++] = i; }
      empuja(y0 * w + x0);
      while (tope > 0) {
        var i = pila[--tope], dd = dist(i), a = p[i * 4 + 3];
        if (dd <= t1) { p[i * 4 + 3] = 0; borrados++; }
        else { p[i * 4 + 3] = Math.round(a * Math.min(1, (dd - t1) / (t2 - t1))); continue; }
        var xi = i % w, yi = (i - xi) / w;
        if (xi > 0) empuja(i - 1); if (xi < w - 1) empuja(i + 1); if (yi > 0) empuja(i - w); if (yi < h - 1) empuja(i + w);
      }
      ctx.putImageData(d, 0, 0);
      return borrados;
    }
    // el lienzo con margen (conMargen) vuelve a su tamaño: la previa y la varita van sobre las medidas de la base
    function sinMargen(cm, w, h) {
      var mg = Math.round((cm.width - w) / 2);
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      c.getContext('2d').drawImage(cm, -mg, -mg);
      return c;
    }
    function conMargen(c, b) {
      var mg = Math.round(Math.max(c.width, c.height) * 0.12) + 4;
      var cm = document.createElement('canvas'); cm.width = c.width + 2 * mg; cm.height = c.height + 2 * mg;
      var cx = cm.getContext('2d');
      cx.fillStyle = b ? 'rgb(' + Math.round(b.r) + ',' + Math.round(b.g) + ',' + Math.round(b.b) + ')' : '#fff';
      cx.fillRect(0, 0, cm.width, cm.height); cx.drawImage(c, mg, mg);
      return cm;
    }
    // "todo el color": transparente lo que se parece al fondo, con borde suave entre t1 y t2
    function quitarColorGlobal(c, b, t1, t2) {
      var ctx = c.getContext('2d'), d = ctx.getImageData(0, 0, c.width, c.height), p = d.data, n = 0;
      for (var i = 0; i < p.length; i += 4) {
        if (p[i + 3] < 8) continue;
        var dr = p[i] - b.r, dg = p[i + 1] - b.g, db = p[i + 2] - b.b, dd = Math.sqrt(dr * dr + dg * dg + db * db);
        if (dd <= t1) { p[i + 3] = 0; n++; }
        else if (dd < t2) p[i + 3] = Math.round(p[i + 3] * (dd - t1) / (t2 - t1));
      }
      ctx.putImageData(d, 0, 0);
      return { ok: n > 0, lienzo: c };
    }
    function calcularFondo(cb) {
      var t = parseInt(rangoTol.value, 10) || 0, t1 = 12 + t * 1.28, t2 = t1 + 60, todo = modoTodo.r.checked;
      lienzoDe(qf.base, function (c) {
        var res = null;
        try {
          var b = ImgArreglo.colorBorde ? ImgArreglo.colorBorde(c) : { r: 255, g: 255, b: 255 };
          if (todo) res = quitarColorGlobal(c, b, t1, t2);
          else if (ImgArreglo.quitarFondo) {
            res = ImgArreglo.quitarFondo(conMargen(c, b), { t1: t1, t2: t2, minParte: 0.2 });
            if (res && res.ok) res = { ok: true, lienzo: sinMargen(res.lienzo, c.width, c.height) };
            else res = { ok: false, motivo: res && res.motivo };
          }
          // los colores de la varita, encima del resultado (o de la base si el fondo no se pudo quitar)
          if (qf.colores.length) {
            var lz = (res && res.ok) ? res.lienzo : c, n = 0;
            qf.colores.forEach(function (col) {
              n += todo ? (quitarColorGlobal(lz, col, t1, t2).ok ? 1 : 0) : quitarDesde(lz, col.x, col.y, col, t1, t2);
            });
            if (n) res = { ok: true, lienzo: lz };
          }
        } catch (e) { res = { ok: false }; }
        cb(res);
      });
    }
    function previsualizarFondo() {
      if (!qf.el) return;
      clearTimeout(qf.timer);
      qf.timer = setTimeout(function () {
        if (!qf.el) return;
        calcularFondo(function (res) {
          if (!qf.el) return;
          if (res && res.ok) { qf.ultimo = res.lienzo; qf.el.img.src = res.lienzo.toDataURL('image/png'); notaFondo.textContent = ''; }
          else { qf.ultimo = null; qf.el.img.src = qf.base; notaFondo.textContent = res && res.motivo === 'agujereado' ? 'Con esta tolerancia se agujerea el dibujo: prueba con menos, o con "todo ese color".' : 'No encontramos un fondo liso que quitar. Prueba con "todo ese color".'; }
        });
      }, 120);
    }
    function cerrarQuitarFondo(aplicar) {
      var el = qf.el;
      if (!el) { cajaFondo.hidden = true; return; }
      clearTimeout(qf.timer);
      if (aplicar && qf.ultimo) {
        soltarFuente(el);
        if (!el.srcOriginal) el.srcOriginal = el.srcBase;
        el.arreglos = (el.arreglos || []).concat('blanco');
        el.srcBase = qf.ultimo.toDataURL('image/png');
        var rec = recortarAlfa(qf.ultimo);
        if (rec && (rec.w < qf.ultimo.width - 4 || rec.h < qf.ultimo.height - 4)) { ceñirCaja(el, rec); el.srcBase = el.img.src; }
        else el.img.src = el.srcBase;
        if (el.mono || tecActiva(el)) tintar(el);
      } else {
        el.img.src = qf.base;
        if (el.mono || tecActiva(el)) tintar(el);
      }
      qf.el = null; qf.base = null; qf.ultimo = null; qf.lienzoBase = null; qf.colores = [];
      varitaActiva(false);
      cajaFondo.hidden = true;
      modoQfMovil(false);
      refrescarOpciones(); refrescarCapas();
      if (esMovil()) host.classList.add('is-sin-panel');   // móvil: al volver, todo cerrado (Xavi, 29/09)
    }
    /* Cambia la imagen de la pieza por otra ya preparada (el dibujo de foto-ia.js), con el mismo mecanismo que «Quitar fondo»:
       guarda la de antes (srcOriginal) para volver, anota el arreglo y ciñe la caja al dibujo. */
    /* Una foto de un hueco de plantilla se recorta siempre desde su foto entera (el.fuente). Si la imagen se EDITA (quitar fondo, arreglos, la IA),
       esa foto entera ya no vale: al tocarla se volvía a pintar la de antes (Xavi, 26/10/2026, «el gorro con IA + quitar fondo»). Se suelta. */
    function soltarFuente(el) { if (el && el.fuente) { el.fuente = null; el.pan = null; } }
    function sustituirImagen(el, url, tipo) {
      if (!el || el.tipo !== 'imagen') return;
      if (!el.srcBase) el.srcBase = el.img.src;
      lienzoDe(url, function (c) {
        soltarFuente(el);
        if (!el.srcOriginal) el.srcOriginal = el.srcBase;
        el.arreglos = (el.arreglos || []).concat(tipo || 'filtro');
        var cx = el.st.left + el.st.w / 2, cy = el.st.top + el.st.h / 2, w = el.st.w, h = w * c.height / c.width;
        el.srcBase = url; el.img.src = url;
        el.st.left = cx - w / 2; el.st.top = cy - h / 2; el.aplicarTamaño(w, h);
        var rec = recortarAlfa(c);
        if (rec && (rec.w < c.width - 4 || rec.h < c.height - 4)) { ceñirCaja(el, rec); el.srcBase = el.img.src; }
        if (el.mono || tecActiva(el)) tintar(el);
        refrescarOpciones(); refrescarCapas();
      });
    }
    function deshacerArreglo(el) {
      if (!el || !el.srcOriginal) return;
      el.srcBase = el.srcOriginal; el.srcOriginal = null; el.arreglos = [];
      // la caja vuelve a la proporción de la imagen original (si se ciñó al quitar el fondo)
      lienzoDe(el.srcBase, function (c) {
        var cx = el.st.left + el.st.w / 2, cy = el.st.top + el.st.h / 2, w = el.st.w, h = w * c.height / c.width;
        el.img.src = el.srcBase;
        el.st.left = cx - w / 2; el.st.top = cy - h / 2;
        el.aplicarTamaño(w, h);
        if (el.mono || tecActiva(el)) tintar(el);
        refrescarOpciones(); refrescarCapas();
      });
    }
    btnBlanco.addEventListener('click', function () { var el = imagenSel(); if (el) quitarFondoDe(el); });
    rangoTol.addEventListener('input', function () { tolValor.textContent = rangoTol.value; previsualizarFondo(); });
    modoContiguo.r.addEventListener('change', previsualizarFondo);
    modoTodo.r.addEventListener('change', previsualizarFondo);
    btnFondoNo.addEventListener('click', function () { cerrarQuitarFondo(false); });
    btnFondoOk.addEventListener('click', function () { cerrarQuitarFondo(true); });
    btnVarita.addEventListener('click', function () { varitaActiva(!qf.varita); });
    chipsFondo.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-chip]');
      if (!b) return;
      qf.colores.splice(parseInt(b.dataset.chip, 10), 1);
      pintarChips(); previsualizarFondo();
    });
    // la varita coge el color ANTES de que el elemento empiece a moverse (captura sobre la capa)
    capa.addEventListener('pointerdown', function (ev) {
      if (!qf.varita || !qf.el || !qf.lienzoBase) return;
      var img = qf.el.img;
      // el toque cae en el div del elemento (la imagen no recibe punteros), no en la imagen
      if (!qf.el.div.contains(ev.target)) return;
      if (ev.target.classList && ev.target.classList.contains('edl__ti')) return; // un tirador, no el diseño
      ev.preventDefault(); ev.stopPropagation();
      var rc = img.getBoundingClientRect();
      // coordenadas locales de la imagen (sin la rotación: se deshace con el ángulo del elemento)
      var cx = rc.left + rc.width / 2, cy = rc.top + rc.height / 2;
      var ang = -(qf.el.st.rot || 0) * Math.PI / 180;
      var dx = ev.clientX - cx, dy = ev.clientY - cy;
      var lx = dx * Math.cos(ang) - dy * Math.sin(ang), ly = dx * Math.sin(ang) + dy * Math.cos(ang);
      var w = qf.el.st.w, h = qf.el.st.h;
      var fx = lx / w + 0.5, fy = ly / h + 0.5;
      if (qf.el.st.volteado) fx = 1 - fx;
      if (fx < 0 || fx > 1 || fy < 0 || fy > 1) return;
      var lb = qf.lienzoBase, px = Math.min(lb.width - 1, Math.max(0, Math.floor(fx * lb.width))), py = Math.min(lb.height - 1, Math.max(0, Math.floor(fy * lb.height)));
      var d = lb.getContext('2d').getImageData(px, py, 1, 1).data;
      if (d[3] < 8) return; // aire: nada que coger
      qf.colores.push({ r: d[0], g: d[1], b: d[2], x: px, y: py });
      varitaActiva(false);
      pintarChips(); previsualizarFondo();
    }, true);
    btnNegro.addEventListener('click', function () { arreglar(imagenSel(), 'negro'); });
    btnDeshacerArr.addEventListener('click', function () { deshacerArreglo(imagenSel()); });
    btnFiltros.addEventListener('click', function () { if (imagenSel() && window.FotoIA && window.__edl) window.FotoIA.editar(window.__edl); });
    btnVolverIA.addEventListener('click', function () { deshacerArreglo(imagenSel()); });
    function aplicarMono() {
      var el = imagenSel(); if (!el || el.fondo) return;
      el.mono = chkMono.checked ? inpMono.value : null;
      tintar(el);
      if (el.mono) anotarColor(el.mono);
    }
    /* La máscara del desvanecido: un cuadrado de lado `tam` con alfa 1 en el
       centro que baja a 0 en el borde, con forma de cuadrado redondeado
       (desvanecido rectangular, esquinas cuadradas). `pct` (0-100) es el
       ancho del desvanecido como fracción del radio. La misma máscara vale
       para la pantalla (CSS mask) y para el archivo (destination-in). */
    function mascaraDifuminado(pct, tam) {
      var c = document.createElement('canvas'); c.width = c.height = tam;
      var ctx = c.getContext('2d'), id = ctx.createImageData(tam, tam), d = id.data;
      var f = Math.max(0.02, Math.min(1, pct / 100)), lim = 1 - f;
      for (var y = 0; y < tam; y++) {
        var ny = Math.abs((y + 0.5) / tam * 2 - 1);
        for (var x = 0; x < tam; x++) {
          var nx = Math.abs((x + 0.5) / tam * 2 - 1), r = Math.max(nx, ny);
          var t = r <= lim ? 1 : (r >= 1 ? 0 : 1 - (r - lim) / (1 - lim));
          t = t * t * (3 - 2 * t);
          d[(y * tam + x) * 4 + 3] = Math.round(t * 255);
        }
      }
      ctx.putImageData(id, 0, 0);
      return c;
    }
    /* Foto DENTRO de una letra (Xavi, 25/10/2026: «PAPÁ con las fotos dentro de las letras»): el estilo de borde «letra:P:Anton:410x790» es la silueta de esa
       letra, estirada a un recuadro de 4,10 × 7,90 cm (ancho × alto en centésimas de cm). Se dibuja aquí con la fuente de la página, así vale igual para la pantalla
       (máscara CSS), para el archivo de impresión (destination-in) y al recuperar un borrador guardado. Si la fuente aún no ha llegado, se rehace al cargar. */
    var fuenteLetraLista = {};
    function construirMascaraLetra(key) {
      if (/^forma:/.test(key)) {   // «forma:circulo:WxH»: un círculo (o elipse) que llena el recuadro; sirve para la foto redonda dentro de una corona
        var pf = key.split(':'), whf = (pf[2] || '600x600').split('x'), Wf = Math.max(40, Math.min(1400, parseInt(whf[0], 10) || 600)), Hf = Math.max(40, Math.min(1400, parseInt(whf[1], 10) || 600));
        var cf = document.createElement('canvas'); cf.width = Wf; cf.height = Hf; var gf = cf.getContext('2d');
        gf.fillStyle = '#000'; gf.beginPath(); gf.ellipse(Wf / 2, Hf / 2, Wf / 2 - 1, Hf / 2 - 1, 0, 0, Math.PI * 2); gf.fill();
        var imf = new Image(); imf.src = cf.toDataURL('image/png'); imgsMascara[key] = imf; return;
      }
      var p = key.split(':'), ch = p[1] || 'A', fam = p[2] || 'Anton', wh = (p[3] || '410x790').split('x');
      var W = Math.max(40, Math.min(1200, parseInt(wh[0], 10) || 410)), H = Math.max(40, Math.min(1600, parseInt(wh[1], 10) || 790));
      var spec = '400 200px "' + fam + '"', c = document.createElement('canvas'); c.width = W; c.height = H;
      var g = c.getContext('2d'); g.font = spec; g.textBaseline = 'alphabetic';
      var m = g.measureText(ch), l = m.actualBoundingBoxLeft || 0, r = m.actualBoundingBoxRight || m.width || 100, a = m.actualBoundingBoxAscent || 150, d = m.actualBoundingBoxDescent || 0;
      var bw = Math.max(1, l + r), bh = Math.max(1, a + d), marg = 0.02;
      g.save(); g.scale(W * (1 - 2 * marg) / bw, H * (1 - 2 * marg) / bh);
      g.translate(l + marg * bw / (1 - 2 * marg), a + marg * bh / (1 - 2 * marg));
      g.fillStyle = '#000'; g.fillText(ch, 0, 0); g.restore();
      var im = new Image(); im.src = c.toDataURL('image/png'); imgsMascara[key] = im;
      if (!fuenteLetraLista[fam]) {
        cargarFuentes();
        if (document.fonts && document.fonts.load) document.fonts.load(spec, ch).then(function () {
          if (fuenteLetraLista[fam]) return; fuenteLetraLista[fam] = 1;
          elementos.forEach(function (e) { if (/^letra:/.test(e.difumEstilo || '')) { delete imgsMascara[e.difumEstilo]; aplicarDifuminado(e); } });
        }, function () {});
      }
    }
    function aplicarDifuminado(el) {
      var im = el.img.style, p = el.difuminado || 0;
      if (!p || !el.difumEstilo) { im.webkitMaskImage = ''; im.maskImage = ''; return; }
      if (/^(letra|forma):/.test(el.difumEstilo) && !imgsMascara[el.difumEstilo]) construirMascaraLetra(el.difumEstilo);
      var url = 'url(' + (imgsMascara[el.difumEstilo] ? imgsMascara[el.difumEstilo].src : mascaraDifuminado(p, 128).toDataURL('image/png')) + ')';
      im.webkitMaskImage = url; im.maskImage = url;
      im.webkitMaskSize = '100% 100%'; im.maskSize = '100% 100%';
    }
    var qb = { el: null, previo: null };
    function abrirBorde(el) {
      if (!el || el.tipo !== 'imagen') return;
      qb.el = el; qb.previo = { e: el.difumEstilo || '', d: el.difuminado || 0 };
      listaBorde.innerHTML = '';
      [['', 'Sin borde']].concat(Object.keys(o.mascarasBorde || {}).map(function (k) { return [k, o.mascarasBorde[k].nombre]; })).forEach(function (a) {
        var b = boton('edl__opc__b edl__opc__b--estilo' + ((el.difumEstilo || '') === a[0] ? ' is-on' : ''), a[1]);
        b.dataset.estilo = a[0];
        b.addEventListener('click', function () {
          el.difumEstilo = a[0]; el.difuminado = a[0] ? 100 : 0;
          aplicarDifuminado(el);
          Array.prototype.forEach.call(listaBorde.children, function (x) { x.classList.toggle('is-on', x === b); });
        });
        listaBorde.appendChild(b);
      });
      host.classList.remove('is-sin-panel');
      cajaBorde.hidden = false; cajaImagen.hidden = true;
      modoQfMovil(true, el);
    }
    function cerrarBorde(aplicar) {
      var el = qb.el;
      if (el && !aplicar && qb.previo) { el.difumEstilo = qb.previo.e; el.difuminado = qb.previo.d; aplicarDifuminado(el); }
      qb.el = null; qb.previo = null;
      cajaBorde.hidden = true;
      modoQfMovil(false);
      refrescarOpciones();
      if (esMovil()) host.classList.add('is-sin-panel');
    }
    btnBorde.addEventListener('click', function () { abrirBorde(imagenSel()); });
    btnBordeOk.addEventListener('click', function () { cerrarBorde(true); });
    btnBordeNo.addEventListener('click', function () { cerrarBorde(false); });
    selDifum.addEventListener('change', function () {
      var el = imagenSel(); if (!el || el.fondo) return;
      el.difumEstilo = selDifum.value;
      el.difuminado = !el.difumEstilo ? 0 : el.difumEstilo === 'suave' ? 40 : 100;
      rngDifum.hidden = valDifum.hidden = txtDifum.hidden = el.difumEstilo !== 'suave';
      rngDifum.value = el.difuminado; valDifum.textContent = el.difuminado;
      aplicarDifuminado(el);
    });
    rngDifum.addEventListener('input', function () {
      var el = imagenSel(); if (!el || el.fondo) return;
      el.difuminado = parseInt(rngDifum.value, 10) || 0;
      valDifum.textContent = el.difuminado;
      aplicarDifuminado(el);
    });
    chkMono.addEventListener('change', aplicarMono);
    inpMono.addEventListener('input', function () { if (!chkMono.checked) chkMono.checked = true; aplicarMono(); });

    btnFondo.addEventListener('click', function () {
      var res = quitarFondo();
      if (!res.ok) {
        alert(res.motivo === 'mezclado'
          ? 'El fondo se mete entre el dibujo: no se puede quitar sin agujerear el diseño.'
          : 'No se ve un fondo claro que quitar en esta imagen.');
      }
    });
    function desbloquearSel() {
      var el = seleccionado; if (!el || !el.bloqueado) return;
      el.bloqueado = false; el.div.classList.remove('edl__el--bloq'); refrescarOpciones(); avisarCambio();
    }
    btnLibreImg.addEventListener('click', desbloquearSel); btnLibreTxt.addEventListener('click', desbloquearSel);
    btnBlancoTinta.addEventListener('click', function () {
      var el = imagenSel(); if (!el) return;
      el.tintaModo = ((el.tintaModo || el.tintaAuto) === 'alfa') ? 'lum' : 'alfa';
      tintar(el); refrescarOpciones();
    });
    btnVoltear.addEventListener('click', function () {
      var el = imagenSel(); if (!el) return;
      el.st.volteado = !el.st.volteado;
      el.aplicar();
    });
    btnDupImg.addEventListener('click', function () { var el = imagenSel(); if (el) duplicar(el); });
    btnBorrarImg.addEventListener('click', function () { var el = imagenSel(); if (el) borrar(el); });

    /* ---------- el recuadro de la zona sobre el fondo ---------- */

    // dónde cae el recuadro de la zona, en px de pantalla sobre el lienzo
    function colocarCaja() {
      var e = Col.encuadre(prendaId, null);
      var esc = ancho / e.w;
      var kcm = Col.unidadesPorCm(p);
      var centro = Col.punto(p, zona, 0);
      var areaCm = Col.area(zona);
      var wSvg = areaCm[0] * kcm, hSvg = areaCm[1] * kcm;
      var left = (centro[0] - wSvg / 2 - e.x) * esc;
      var top = (centro[1] - hSvg / 2 - e.y) * esc;
      caja.style.left = left + 'px';
      caja.style.top = top + 'px';
      caja.style.width = (wSvg * esc) + 'px';
      caja.style.height = (hSvg * esc) + 'px';
      caja.style.clipPath = '';
      conCurvas = false;
      visiblePx = null;
      /* Taza: la panorámica baja su límite de arriba lo mismo que los lados (cm), para que
         un diseño que llena el lado y la panorámica lleguen a la misma línea (Xavi, 02/10) */
      caidaPx = [0, 0];
      var cl = caidaLadoCm();
      if (cl > 0) caidaPx[0] = cl * escalaPxCm();
      actualizarSombra();
      colocarSeguro();
    }
    /* cuánto baja (cm) el límite de arriba en los lados de la taza respecto a la lámina.
       Se anota al colocar un lado; mientras no se haya visto ninguno vale el medido (~0,6 cm) */
    var caidaLado = { b: 0.62, c: 0.62 };
    function caidaLadoCm() {
      if (prendaId !== 'taza_panoramica' || vistas.length < 2) return 0;
      return caidaLado[usaBlanca() ? 'b' : 'c'];
    }

    /* La sombra de cilindro solo cuando hay un fondo (imagen o color) que
       tape la foto: sobre la taza vacía la foto ya trae su propia sombra y
       la nuestra la oscurecía dos veces. */
    var conCurvas = false;
    function actualizarSombra() {
      sombra.hidden = !(conCurvas && fondoActual());
    }

    /* Modo foto: cuando aún no hay foto recta de estudio para teñir (como
       las de las camisetas), Xavi prefirió una foto real en ángulo antes que
       el dibujo de línea, sabiendo que el recuadro no va a caer pixel a
       pixel sobre la taza real — no hay silueta vectorial de esta foto con
       la que calcularlo solo, así que el recuadro se ajusta a ojo una vez
       por foto (RECUADRO_FOTO, en % del ancho/alto de la imagen). */
    /* centro (x, en % del ancho de la foto), top y alto (en % del alto). El
       ancho sale de la proporción real de la zona (8 × 9,5 cm), así la
       escala px/cm es la misma en los dos ejes y lo que se pone aquí se
       recoloca sin deformarse en la panorámica. */
    /* Medido sobre la serie de fotos de Xavi (1080 × 1080, recortadas a
       900 × 815: x 130–1030, y 145–960). En esta serie el cuerpo es
       siempre blanco y solo cambian interior y asa. Cuerpo del 6 % al
       68 % del ancho, eje del cuerpo al 37,3 %; boca (labio delantero)
       al 17,4 % de alto en el eje y base al 96,7 %. */
    var RECUADRO_COLOR = o.fotoRecuadro || {
      centro: 0.373, top: 0.174, height: 0.793,
      /* Curvas de la boca y la base, medidas sobre la foto y ajustadas
         como parábolas y = a + k·(x − xc)² (x, y en fracción del ancho y
         alto de la foto). Con ellas el recuadro se recorta con la forma
         real de la taza y el diseño parece pintado encima. */
      curvas: { arriba: [0.1738, -0.511], abajo: [0.967, -0.754] },
      /* borde exterior e interior (junto al asa) del cuerpo, en fracción
         del ancho: el diseño se pega al exterior y se corta en el interior
         (lo que no cabe de frente sigue hacia el asa; Xavi: ahí queda un
         poco de blanco y es lo real) */
      cuerpo: [0.07, 0.682]
    };
    /* La taza blanca va con su foto real (Xavi: "la blanca se nota"),
       girada y escalada al mismo encuadre que la serie de color. Está
       tomada un poco más de frente, así que la boca cae más alta: misma
       base y mismo cuerpo, otra curva de arriba. */
    var RECUADRO_BLANCO = o.fotoBlancaRecuadro || {
      centro: RECUADRO_COLOR.centro, top: 0.148, height: 0.816,
      curvas: { arriba: [0.148, -0.2901], abajo: [0.9639, -0.6051] },
      cuerpo: RECUADRO_COLOR.cuerpo
    };
    var RECUADRO_FOTO = RECUADRO_COLOR;
    var RECUADRO_DEFECTO_COLOR = RECUADRO_COLOR, RECUADRO_DEFECTO_BLANCO = RECUADRO_BLANCO;
    var fotoImg = null;
    var mascImg = null; // máscara de tinte (la carga elegirFotos(), por vista)
    var blancaImg = null; // foto de la prenda blanca, si la hay
    function esBlanco(hex) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
      if (!m) return false;
      var r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
      return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.92 && Math.max(r, g, b) - Math.min(r, g, b) < 24;
    }
    function usaBlanca() { return !!(blancaImg && blancaImg.naturalWidth && esBlanco(color)); }
    // producto oscuro (negro, marino…): solo ahí tiene sentido "Eliminar negro + semitono" (Xavi, 29/09)
    // prenda negra (o casi): ahí el negro de un diseño no se ve ni se imprime
    function prendaNegra() {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color || '');
      return !!m && (0.299 * parseInt(m[1], 16) + 0.587 * parseInt(m[2], 16) + 0.114 * parseInt(m[3], 16)) / 255 < 0.12;
    }
    function esNegro(rgb) { return Math.max(rgb[0], rgb[1], rgb[2]) < 50 && (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255 < 0.16; }
    function esOscuro(hex) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
      if (!m) return false;
      return (0.299 * parseInt(m[1], 16) + 0.587 * parseInt(m[2], 16) + 0.114 * parseInt(m[3], 16)) / 255 < 0.3;
    }
    // carga una foto del CDN con CORS (para poder sacar el mockup) y, si el origen no lo permite, sin él
    function cargarFoto(src, onload) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = onload;
      img.onerror = function () { if (!img.crossOrigin) return; img.crossOrigin = null; img.src = src; };
      img.src = src;
      return img;
    }
    /* Cambia las fotos "actuales" por las de la vista. Cada src se carga
       una sola vez (caché); al cargar se repinta si sigue siendo la vista. */
    var cacheFotos = {};
    function fotoCache(src, alCargar) {
      if (!src) return null;
      if (!cacheFotos[src]) cacheFotos[src] = cargarFoto(src, function () { alCargar(); });
      return cacheFotos[src];
    }
    function elegirFotos(f) {
      fotoImg = fotoCache(f.fondo, function () { if (fotoImg === cacheFotos[f.fondo]) { pintarFoto(); pintarMinis(); if (posPendiente) { recolocar(posPendiente); posPendiente = null; } } });
      mascImg = fotoCache(f.mascara, function () { dibujarFondo(); });
      blancaImg = fotoCache(f.blanca, function () { if (esBlanco(color)) dibujarFondo(); });
      if (f.recuadro) {
        // recuadro propio de la foto (camiseta: rectángulo, sin curvas); la blanca usa el mismo salvo que traiga otro
        RECUADRO_COLOR = f.recuadro;
        RECUADRO_BLANCO = f.recuadroBlanco || f.recuadro;
      } else { RECUADRO_COLOR = RECUADRO_DEFECTO_COLOR; RECUADRO_BLANCO = RECUADRO_DEFECTO_BLANCO; }
    }
    fijarVista(o.zona);
    // las fotos de las demás vistas se cargan ya, para sus miniaturas y para cambiar de vista sin espera
    vistas.forEach(function (z) {
      var f = fotoDe(z);
      if (!f || !f.fondo) return;
      [f.fondo, f.mascara, f.blanca].forEach(function (src) { fotoCache(src, function () { pintarMinis(); }); });
    });
    var posPendiente = null; // elementos a recolocar cuando cargue la foto

    /* Teñido por color: la foto base lleva las partes de color (asa e
       interior) en gris con su sombra (s), y la máscara lleva en el alfa
       dónde están y en el RGB el brillo del esmalte (w). La fórmula, sacada
       por mínimos cuadrados de cuatro fotos reales de la serie (azul claro,
       rojo, amarillo y naranja): píxel = C·s + w·(255 − C·s), que en canvas
       es multiply del color sobre la base y screen del brillo encima. Una
       foto por producto y todos los colores por software (Xavi: "hay mucho
       catálogo y de muchos colores"). */
    // un 5 % de blanco en el tinte, para que no sature (la base ya va con las luces altas)
    function suavizar(hex) {
      var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || '');
      if (!m) return hex;
      var c = [m[1], m[2], m[3]].map(function (h) { var v = parseInt(h, 16); return Math.round(v + (255 - v) * 0.05); });
      return 'rgb(' + c.join(',') + ')';
    }
    // pinta la taza (foto + tinte) en un contexto, a w × h px, con espejo si toca
    function pintarTaza(ctx, w, h, espejo) { pintarPrenda(ctx, w, h, espejo, fotoImg, mascImg, blancaImg); }
    function pintarPrenda(ctx, w, h, espejo, fotoImg, mascImg, blancaImg) {
      ctx.save();
      if (espejo) { ctx.translate(w, 0); ctx.scale(-1, 1); }
      if (blancaImg && blancaImg.naturalWidth && esBlanco(color)) { ctx.drawImage(blancaImg, 0, 0, w, h); ctx.restore(); return; }
      ctx.drawImage(fotoImg, 0, 0, w, h);
      if (mascImg && mascImg.naturalWidth && color) {
        var off = document.createElement('canvas'); off.width = w; off.height = h;
        var oc = off.getContext('2d');
        oc.drawImage(fotoImg, 0, 0, w, h);
        oc.globalCompositeOperation = 'multiply';
        oc.fillStyle = suavizar(color); oc.fillRect(0, 0, w, h);
        oc.globalCompositeOperation = 'screen'; // brillos del esmalte (RGB de la máscara)
        oc.drawImage(mascImg, 0, 0, w, h);
        oc.globalCompositeOperation = 'destination-in'; // solo donde hay color (alfa de la máscara)
        oc.drawImage(mascImg, 0, 0, w, h);
        ctx.drawImage(off, 0, 0);
      }
      ctx.restore();
    }

    function colocarCajaFoto() {
      RECUADRO_FOTO = usaBlanca() ? RECUADRO_BLANCO : RECUADRO_COLOR;
      var w = parseFloat(lienzo.style.width) || lienzo.width;
      var h = parseFloat(lienzo.style.height) || lienzo.height;
      var area = Col.area(zona);
      // en espejo (lado derecho) el recuadro cae al otro lado del asa
      var centro = zona.espejo ? 1 - RECUADRO_FOTO.centro : RECUADRO_FOTO.centro;
      var cv = RECUADRO_FOTO.curvas;
      var top = RECUADRO_FOTO.top, hpx = RECUADRO_FOTO.height * h, wpx = hpx * area[0] / area[1];
      if (cv) {
        /* El recuadro es la caja envolvente de la zona curva: arriba, el
           punto más alto de la boca (en los extremos); abajo, el más bajo
           de la base (en el centro). El ancho depende del alto (8:9,5) y
           el alto de dónde caen los extremos: un par de vueltas lo fijan. */
        var xc = RECUADRO_FOTO.centro; // eje de las parábolas, en la foto sin espejo
        var yArr = function (dx) { return cv.arriba[0] + cv.arriba[1] * dx * dx; };
        var yAb = function (dx) { return cv.abajo[0] + cv.abajo[1] * dx * dx; };
        var cuerpo = RECUADRO_FOTO.cuerpo || [centro - 0.27, centro + 0.27];
        // el recuadro arranca en el borde exterior del cuerpo (en la foto sin espejo)
        var izq = cuerpo[0], ancho = 2 * 0.27;
        for (var it = 0; it < 4; it++) {
          // arriba: el punto más alto de la boca dentro del recuadro (el extremo más lejos del eje)
          var dxMax = Math.max(Math.abs(izq - xc), Math.abs(izq + ancho - xc));
          top = yArr(dxMax);
          hpx = (yAb(0) - top) * h;
          wpx = hpx * area[0] / area[1];
          ancho = wpx / w;
        }
        // en espejo, el recuadro va del otro lado: su borde exterior es 1 − izq
        var boxLeft = zona.espejo ? 1 - izq - ancho : izq;
        // parte visible del recuadro: hasta el borde interior del cuerpo (junto al asa)
        var visIzq = zona.espejo ? Math.max(boxLeft, 1 - cuerpo[1]) : boxLeft;
        var visDer = zona.espejo ? boxLeft + ancho : Math.min(boxLeft + ancho, cuerpo[1]);
        /* Por el lado del asa lo que se ve se corta en el límite (medio cm
           antes del asa), no en el cuerpo: el fondo tampoco debe llegar al
           asa (Xavi, 28/09). En la lámina real esa franja queda en blanco. */
        var mAsa = MARGEN_X_CM * (wpx / area[0]) / w;
        if (zona.espejo) visIzq += mAsa; else visDer -= mAsa;
        var xa = (visIzq - boxLeft) * w, xb = (visDer - boxLeft) * w;
        var puntos = [], N = 24, topPx = top * h;
        var dxDe = function (xLocal) { var X = boxLeft + xLocal / w; return (zona.espejo ? 1 - X : X) - xc; };
        for (var i = 0; i <= N; i++) {
          var x = xa + (xb - xa) * i / N;
          puntos.push(x.toFixed(1) + 'px ' + (yArr(dxDe(x)) * h - topPx).toFixed(1) + 'px');
        }
        for (var j = N; j >= 0; j--) {
          var x2 = xa + (xb - xa) * j / N;
          puntos.push(x2.toFixed(1) + 'px ' + (yAb(dxDe(x2)) * h - topPx).toFixed(1) + 'px');
        }
        caja.style.clipPath = 'polygon(' + puntos.join(', ') + ')';
        ultimosPuntos = puntos.map(function (p) { return p.split('px ').map(parseFloat); });
        conCurvas = true;
        centro = boxLeft + ancho / 2;
        visiblePx = [xa, xb]; // el límite de los objetos es lo que se ve
        /* el recuadro va del punto más alto de la boca al más bajo de la
           base; en el centro la boca cae y en los extremos la base sube:
           el margen vertical de los objetos empieza donde de verdad se ve */
        var dxMin = (izq <= xc && xc <= izq + ancho) ? 0 : Math.min(Math.abs(izq - xc), Math.abs(izq + ancho - xc));
        /* abajo, la subida de la base se mide en los extremos del propio
           límite (más estrecho que el recuadro), no del recuadro entero:
           si no, el objeto se quedaba demasiado alto */
        var escL = wpx / area[0], mL = MARGEN_X_CM * escL;
        var xLimIzq = visIzq + mL / w, xLimDer = visDer - mL / w;
        var dxLim = Math.max(Math.abs((zona.espejo ? 1 - xLimIzq : xLimIzq) - xc), Math.abs((zona.espejo ? 1 - xLimDer : xLimDer) - xc));
        /* abajo no se compensa la curva de la base (Xavi: menos margen
           abajo); una esquina puede asomar un pelín por la curva */
        caidaPx = [(yArr(dxMin) - top) * h, 0];
        caidaLado[usaBlanca() ? 'b' : 'c'] = caidaPx[0] / escL;
      } else {
        caja.style.clipPath = '';
        conCurvas = false;
        visiblePx = null;
        caidaPx = [0, 0];
      }
      actualizarSombra();
      caja.style.left = (centro * w - wpx / 2) + 'px';
      caja.style.top = (top * h) + 'px';
      caja.style.width = wpx + 'px';
      caja.style.height = hpx + 'px';
      colocarSeguro();
      pintarRejilla();
    }

    /* REJILLA DE CALIBRADO (Xavi, 30/09: "una foto con el producto y unas reglas, y yo te digo H4 y V2").
       Solo con `&rejilla=1` en la dirección: celdas de 2 cm (4 cm en fotos muy grandes como el delantal) sobre la foto, columnas H1, H2… de izquierda a
       derecha y filas V1, V2… de arriba abajo, más un rótulo con la posición y el tamaño del recuadro de
       impresión (celdas y cm desde el borde de la foto). Los clientes no lo ven nunca. */
    var rejillaOn = /[?&]rejilla=(1|si|true)/i.test(location.search);
    var rejillaEl = null;
    function pintarRejilla() {
      if (!rejillaOn || !usaFoto) return;
      var esc = escalaPxCm(), W = lienzo.offsetWidth, H = lienzo.offsetHeight;
      if (!esc || !W || !H) return;
      if (!rejillaEl) {
        rejillaEl = document.createElement('div');
        rejillaEl.className = 'edl__rejilla';
        rejillaEl.style.cssText = 'position:absolute;left:0;top:0;pointer-events:none;z-index:9;overflow:hidden;font:600 10px/1 monospace;';
        edl.appendChild(rejillaEl);
      }
      var celCm = (H / esc > 70 || W / esc > 70) ? 4 : 2, cel = celCm * esc, html = '', i, n;   // celdas de 2 cm (4 en fotos grandes, para poder leerlas)
      rejillaEl.style.width = W + 'px'; rejillaEl.style.height = H + 'px';
      for (i = 0, n = Math.ceil(W / cel); i < n; i++) {
        html += '<div style="position:absolute;top:0;bottom:0;left:' + (i * cel) + 'px;border-left:1px solid rgba(220,0,200,' + (i % 5 === 0 ? '.7' : '.35') + ')"></div>' +
          '<div style="position:absolute;top:0;left:' + (i * cel + 1) + 'px;width:' + (cel - 1) + 'px;text-align:center;color:#a0009a;background:rgba(255,255,255,.75)">H' + (i + 1) + '</div>';
      }
      for (i = 0, n = Math.ceil(H / cel); i < n; i++) {
        html += '<div style="position:absolute;left:0;right:0;top:' + (i * cel) + 'px;border-top:1px solid rgba(220,0,200,' + (i % 5 === 0 ? '.7' : '.35') + ')"></div>' +
          '<div style="position:absolute;left:0;top:' + (i * cel + cel / 2 - 5) + 'px;color:#a0009a;background:rgba(255,255,255,.75);padding:0 1px">V' + (i + 1) + '</div>';
      }
      var L = parseFloat(caja.style.left) || 0, T = parseFloat(caja.style.top) || 0;
      var Wc = parseFloat(caja.style.width) || 0, Hc = parseFloat(caja.style.height) || 0;
      var r1 = function (v) { return (Math.round(v * 10) / 10).toString().replace('.', ','); };
      html += '<div style="position:absolute;right:2px;bottom:2px;background:rgba(0,0,0,.8);color:#fff;padding:4px 6px;border-radius:4px;line-height:1.35">' +
        'Recuadro: H' + (Math.floor(L / cel) + 1) + '–H' + Math.ceil((L + Wc) / cel) + ' · V' + (Math.floor(T / cel) + 1) + '–V' + Math.ceil((T + Hc) / cel) + '<br>' +
        'celda ' + celCm + ' cm · ' + r1(Wc / esc) + '×' + r1(Hc / esc) + ' cm · a ' + r1(L / esc) + ' cm del borde izq. y ' + r1(T / esc) + ' cm del borde de arriba</div>';
      rejillaEl.innerHTML = html;
    }

    function pintarFoto() {
      var alto = ancho * fotoImg.naturalHeight / fotoImg.naturalWidth;
      lienzo.width = ancho; lienzo.height = alto;
      lienzo.style.width = ancho + 'px'; lienzo.style.height = alto + 'px';
      pintarTaza(lienzo.getContext('2d'), ancho, alto, zona.espejo);
      colocarCajaFoto();
    }

    function dibujarFotoFondo() {
      if (fotoImg && fotoImg.naturalWidth) pintarFoto();
      // si no ha cargado aún, pintará al cargar (elegirFotos)
    }

    /* Miniaturas de los botones de vista: el mismo fondo que tendría la
       vista grande (foto, foto en espejo o dibujo plano), a 64 px. */
    function pintarMinis() {
      vistas.forEach(function (z) {
        var mini = minis[z.id];
        if (!mini) return;
        var pid = Col.prendaIdDe(o.prenda, z.cara || '');
        var f = fotoDe(z);
        if (f && f.fondo) {
          // fotoCache (no cacheFotos a secas): con foto por color, la de la otra cara aún puede no estar cargada
          var img = fotoCache(f.fondo, pintarMinis), msk = fotoCache(f.mascara, pintarMinis), bl = fotoCache(f.blanca, pintarMinis);
          if (!img || !img.naturalWidth) return;
          var mw = 64, mh = Math.round(mw * img.naturalHeight / img.naturalWidth);
          mini.width = mw; mini.height = mh;
          pintarPrenda(mini.getContext('2d'), mw, mh, z.espejo, img, msk, bl);
        } else {
          Col.dibujar(mini, pid, null, { ancho: 64, color: color });
        }
      });
    }

    function dibujarFondo() {
      if (usaFoto) { dibujarFotoFondo(); }
      else {
        lienzo.style.width = ''; lienzo.style.height = '';
        Col.dibujar(lienzo, prendaId, null, { ancho: ancho, color: color });
        colocarCaja();
        marcarVentanas();
      }
      pintarMinis();
    }

    /* ---------- una sola superficie, varias ventanas ----------
       Los elementos viven en cm sobre la superficie de impresión entera
       (la panorámica). Cada vista es una ventana [x, y] en cm sobre ella
       (zona.ventana) que se pinta en su recuadro; la escala px/cm sale del
       ancho del recuadro. Al cambiar de vista se recolocan los mismos
       elementos: lo que se pone en un lado aparece en la panorámica en su
       sitio, y lo que cae detrás no se ve en los lados. */
    /* La superficie total llega hasta donde llega la ventana más lejana:
       en la taza, la panorámica (0 + 20); en la camiseta, la espalda
       (30 + 30 = 60), que va al lado del pecho. */
    var anchoTotalCm = Math.max.apply(null, vistas.map(function (z) { return (z.ventana ? z.ventana[0] : 0) + Col.area(z)[0]; }));
    var altoTotalCm = Math.max.apply(null, vistas.map(function (z) { return (z.ventana ? z.ventana[1] : 0) + Col.area(z)[1]; }));
    function ventanaDe(z) { return z.ventana || [0, 0]; }
    function escalaPxCm() { return parseFloat(caja.style.width) / Col.area(zona)[0]; }

    /* El área de seguridad de la vista actual, en px: la ventana de la
       vista con margen por los cuatro lados. En un lado, el objeto se queda
       dentro de lo que se ve de ese lado (Xavi: para envolver la taza
       entera está "Imagen de fondo"); en la panorámica, toda el área. */
    var ultimosPuntos = null; // el polígono del recorte de la vista actual, en px del recuadro
    var visiblePx = null; // [xa, xb] del recuadro que se ve (foto: hasta el corte del asa)
    var caidaPx = [0, 0];  // cuánto bajan la boca (centro) y sube la base (extremos) respecto al recuadro
    function rectBase() {
      var esc = escalaPxCm(), a = Col.area(zona);
      var xa = visiblePx ? visiblePx[0] : 0, xb = visiblePx ? visiblePx[1] : a[0] * esc;
      return { x0: xa + MARGEN_X_CM * esc, y0: MARGEN_Y_CM * esc + caidaPx[0],
               x1: xb - MARGEN_X_CM * esc, y1: (a[1] - MARGEN_Y_CM) * esc - caidaPx[1] };
    }
    /* CAJAS: una zona puede ser varias cajas pequeñas separadas (el pecho de la laboral: una por pecho, 10 × 10 cada una),
       en cm desde la esquina de la zona: [x, y, ancho, alto]. El diseño solo puede estar dentro de una. */
    var cxRef = null;   // centro (px) del elemento que se está acotando: decide en qué caja
    var cajaNueva = null;   // caja en la que se pulsó «+» para añadir imagen
    var subirCajas = [];    // un «+» redondo por caja, que se esconde cuando la caja ya lleva algo
    function asegurarSubirCajas(n) {
      while (subirCajas.length < n) {
        (function (i) {
          var b = boton('edl__subir', '+');
          b.title = 'Añadir imagen'; b.setAttribute('aria-label', 'Añadir imagen');
          b.addEventListener('click', function () { cajaNueva = i; modoFondo = false; huecoPendiente = null; pedirImagen(); });
          capa.appendChild(b); subirCajas.push(b);
        })(subirCajas.length);
      }
    }
    // «Añadir imagen»: el botón único, o con cajas uno por caja vacía
    function refrescarSubir() {
      var cs = cajasDe(zona);
      /* solo cuenta lo que hay en ESTA vista: con un logo delante, la espalda sigue necesitando su «+» */
      if (!cs) {
        // las posiciones son de la vista que se ve: lo de la otra cara cae fuera de [0, ancho] (y un elemento recién creado aún no tiene medidas)
        var wV = parseFloat(caja.style.width);
        subir.hidden = vistas.length < 2 || isNaN(wV) ? elementos.length > 0 : elementos.some(function (e) {
          if (!e.st) return true;
          var cx = e.st.left + e.st.w / 2;
          return !(cx < 0 || cx > wV);
        });
        subirCajas.forEach(function (b) { b.hidden = true; });
        return;
      }
      subir.hidden = true;
      var rs = rectCajas();
      subirCajas.forEach(function (b, i) {
        var r = rs[i];
        b.hidden = !r || elementos.some(function (e) {
          if (!e.visible || e.ejemplo || e.fondo || !e.st) return false;
          var cx = e.st.left + e.st.w / 2;
          return cx >= r.x0 - 1 && cx <= r.x1 + 1;
        });
      });
    }
    function cajasDe(z) { var c = o.cajasPorZona && z && o.cajasPorZona[z.id]; return c && c.length ? c : null; }
    function rectCajas() {
      var esc = escalaPxCm(), cs = cajasDe(zona);
      return cs.map(function (c) {
        return { x0: c[0] * esc, y0: c[1] * esc + caidaPx[0], x1: (c[0] + c[2]) * esc, y1: (c[1] + c[3]) * esc + caidaPx[0] };
      });
    }
    function rectSeguro() {
      if (!cajasDe(zona)) return rectBase();
      var rs = rectCajas(), mejor = rs[rs.length - 1];   // sin referencia, la del pecho izquierdo (derecha en la foto)
      if (cxRef != null) {
        var dm = Infinity;
        rs.forEach(function (r) { var d = Math.abs(cxRef - (r.x0 + r.x1) / 2); if (d < dm) { dm = d; mejor = r; } });
      }
      return mejor;
    }
    var seguro2 = document.createElement('div');
    seguro2.className = 'edl__seguro edl__seguro--2';
    seguro2.style.cssText = seguro.style.cssText;
    seguro2.style.display = 'none';
    caja.appendChild(seguro2);
    function colocarSeguro() {
      var cajasZ = cajasDe(zona), rb = cajasZ ? rectBase() : null;
      if (cajasZ) { cxRef = null; }
      var r = cajasZ ? rectCajas()[0] : rectSeguro();
      if (isNaN(r.x0)) return;
      seguro.style.left = r.x0 + 'px'; seguro.style.top = r.y0 + 'px';
      seguro.style.width = (r.x1 - r.x0) + 'px'; seguro.style.height = (r.y1 - r.y0) + 'px';
      seguro.style.borderRadius = (zona && zona.forma === 'circulo') ? '50%' : '';
      if (cajasZ) {
        asegurarSubirCajas(cajasZ.length);
        var cxC = parseFloat(caja.style.left) || 0, cyC = parseFloat(caja.style.top) || 0;
        rectCajas().forEach(function (rc, i) {
          subirCajas[i].style.cssText = 'inset:auto;margin:0;z-index:7;left:' + (cxC + (rc.x0 + rc.x1) / 2) + 'px;top:' +
            (cyC + (rc.y0 + rc.y1) / 2 - 16) + 'px;width:32px;height:32px;min-width:0;padding:0;border-radius:50%;font-size:2rem;line-height:1;font-weight:700;transform:translateX(-50%);';
        });
      }
      refrescarSubir();
      if (cajasZ && cajasZ.length > 1) {
        var r2 = rectCajas()[1];
        seguro2.style.setProperty('display', 'block', 'important');
        seguro2.style.left = r2.x0 + 'px'; seguro2.style.top = r2.y0 + 'px';
        seguro2.style.width = (r2.x1 - r2.x0) + 'px'; seguro2.style.height = (r2.y1 - r2.y0) + 'px';
      } else seguro2.style.display = 'none';
      if (cajasZ) r = rb;   // el «+» de añadir imagen, centrado entre las cajas
      // el botón "+ Añadir imagen" centrado en el recuadro visible, no en la ventana entera
      // (en un recuadro estrecho, como la tapa del bloc en móvil, el botón puede ser más ancho que el recuadro: que quepa el texto)
      var bw = Math.max((r.x1 - r.x0) * 0.7, Math.min(150, ancho * 0.6));
      // el ancho es un mínimo: el texto nunca se corta ("Añadir image", 29/09); se centra con transform
      var cx0 = parseFloat(caja.style.left) || 0, cy0 = parseFloat(caja.style.top) || 0;
      // en una zona pequeña (pecho 10×10) el botón con texto se sale de la caja y queda feo: solo un «+» redondo (Xavi, 01/10)
      /* zona alargada y fina (bolígrafo: 8 × 0,7 cm): igual de incómoda que una pequeña, con los tiradores más grandes que ella; se acerca sola al abrir
         (Xavi, 25/10/2026: «el bolígrafo se ve como una tira fina»), una sola vez; si no, el primer toque acerca */
      var alargada = (r.y1 - r.y0) < 40 && (r.x1 - r.x0) > (r.y1 - r.y0) * 4;
      var pequena = (r.x1 - r.x0) < 150 || alargada;
      host.classList.toggle('is-zona-chica', pequena);   // CSS: sin tiradores hasta acercar (Xavi, 01/10)
      if (alargada && !zoomInicialAlargada && esMovil() && o.zoomAuto !== false) {
        zoomInicialAlargada = true;
        setTimeout(function () { if (typeof zoom === 'object' && zoom && !zoom.activo) { zoomAuto = true; zoomMas(); } }, 120);
      }
      var botonChico = pequena || !!cajasZ;   // con cajas (dos pechos) el botón es un «+» redondo entre ellas
      var etqSubir = botonChico ? '+' : (esTaza ? '+ Tu foto' : '+ Añadir imagen');
      if (subir.textContent !== etqSubir) subir.textContent = etqSubir;
      subir.title = 'Añadir imagen'; subir.setAttribute('aria-label', 'Añadir imagen');
      if (botonChico) {
        subir.style.cssText = 'inset:auto;margin:0;z-index:7;left:' + (cx0 + (r.x0 + r.x1) / 2) + 'px;top:' +
          (cy0 + (r.y0 + r.y1) / 2 - 16) + 'px;width:32px;height:32px;min-width:0;padding:0;border-radius:50%;font-size:2rem;line-height:1;font-weight:700;transform:translateX(-50%);';
      } else {
        subir.style.cssText = 'inset:auto;margin:0;z-index:7;left:' + (cx0 + (r.x0 + r.x1) / 2) + 'px;top:' +
          (cy0 + (r.y0 + r.y1) / 2 - 18) + 'px;min-width:' + bw + 'px;width:max-content;padding:0 10px;white-space:nowrap;transform:translateX(-50%);height:36px;';
      }
    }
    // mete el estado de un objeto normal dentro del área de seguridad
    function acotar(st) {
      cxRef = st.left + st.w / 2;
      var r = rectSeguro();
      if (isNaN(r.x0)) return;
      /* si cabe, dentro; si es mayor (por redondeo al ir a tope), que la
         cubra sin dejar hueco */
      st.left = st.w <= r.x1 - r.x0 + 0.5 ? limite(st.left, r.x0, r.x1 - st.w) : limite(st.left, r.x1 - st.w, r.x0);
      st.top = st.h <= r.y1 - r.y0 + 0.5 ? limite(st.top, r.y0, r.y1 - st.h) : limite(st.top, r.y1 - st.h, r.y0);
      if (subirCajas.length) setTimeout(refrescarSubir, 0);   // el logo puede haber cambiado de caja
    }

    /* IMÁN DE CENTRADO. Al mover un elemento, su centro se pega al centro de lo que se ve en
       la vista (horizontal y vertical) cuando pasa a menos de IMAN_PX, y sale una línea guía.
       En la panorámica de la taza, además, al centro de cada lado (izquierda y derecha), que
       es donde quedará centrado en esas vistas. */
    var IMAN_PX = 7;
    var guiaV = document.createElement('div'), guiaH = document.createElement('div');
    guiaV.className = 'edl__guia edl__guia--v'; guiaH.className = 'edl__guia edl__guia--h';
    caja.appendChild(guiaV); caja.appendChild(guiaH);
    function ocultarGuias() { guiaV.style.display = 'none'; guiaH.style.display = 'none'; }
    document.addEventListener('pointerup', ocultarGuias, true);
    document.addEventListener('pointercancel', ocultarGuias, true);
    function objetivosImanX() {
      var r = rectSeguro(), esc = escalaPxCm(), v = ventanaDe(zona), a = Col.area(zona), xs = [(r.x0 + r.x1) / 2];
      vistas.forEach(function (z2) {
        if (z2 === zona) return;
        var v2 = ventanaDe(z2), a2 = Col.area(z2);
        // otra vista que cae dentro de esta (los lados dentro de la panorámica): su centro
        if (v2[0] >= v[0] - 0.01 && v2[0] + a2[0] <= v[0] + a[0] + 0.01 && a2[0] < a[0] - 0.01) xs.push((v2[0] + a2[0] / 2 - v[0]) * esc);
      });
      return xs;
    }
    // devuelve st ya pegado a los centros si está cerca, y enseña las guías
    function imanCentro(st) {
      var r = rectSeguro();
      if (isNaN(r.x0)) { ocultarGuias(); return; }
      var cx = st.left + st.w / 2, cy = st.top + st.h / 2, hecho = false;
      var mejor = null;
      objetivosImanX().forEach(function (x) { var d = Math.abs(cx - x); if (d <= IMAN_PX && (!mejor || d < mejor.d)) mejor = { d: d, x: x }; });
      if (mejor) {
        st.left = mejor.x - st.w / 2; hecho = true;
        guiaV.style.cssText = 'display:block;left:' + mejor.x + 'px;top:' + r.y0 + 'px;height:' + (r.y1 - r.y0) + 'px;';
      } else guiaV.style.display = 'none';
      var yc = (r.y0 + r.y1) / 2;
      if (Math.abs(cy - yc) <= IMAN_PX) {
        st.top = yc - st.h / 2; hecho = true;
        guiaH.style.cssText = 'display:block;top:' + yc + 'px;left:' + r.x0 + 'px;width:' + (r.x1 - r.x0) + 'px;';
      } else guiaH.style.display = 'none';
      return hecho;
    }

    // posición en cm (centro y medidas) de cada elemento en la vista actual
    function posicionesCm() {
      var esc = escalaPxCm(), v = ventanaDe(zona);
      return elementos.map(function (e) {
        var s = e.st;
        return { cx: v[0] + (s.left + s.w / 2) / esc, cy: v[1] + (s.top + s.h / 2) / esc,
                 w: s.w / esc, h: s.h / esc, wRef: (s.wRef || s.w) / esc, hRef: (s.hRef || s.h) / esc };
      });
    }
    // y vuelta: de cm a px de la vista actual
    function recolocar(pos) {
      var esc = escalaPxCm(), v = ventanaDe(zona);
      if (!esc || isNaN(esc)) return;
      elementos.forEach(function (e, i) {
        var q = pos[i], s = e.st;
        if (!q) return;
        s.w = q.w * esc; s.h = q.h * esc; s.wRef = q.wRef * esc; s.hRef = q.hRef * esc;
        s.left = (q.cx - v[0]) * esc - s.w / 2;
        s.top = (q.cy - v[1]) * esc - s.h / 2;
        e.aplicar();
      });
      pintarExternos();
    }

    /* ---------- capas externas ----------
       Lo que se ve sobre la prenda pero NO es del diseño: el dorsal (nombre
       y número), que lo pinta dorsales.js y se corta en el plóter aparte.
       Una por vista, en cm sobre la superficie; se enseña encima del
       recuadro sin poder tocarla, no entra en el archivo ni en el tramo,
       pero sí en el mockup. */
    var externos = {}; // vistaId → { src, cx, cy, w, h, img }
    var capaExt = document.createElement('div');
    capaExt.className = 'edl__externos';
    edl.appendChild(capaExt);
    function pintarExternos() {
      capaExt.innerHTML = '';
      var x = externos[zona.id];
      if (!x) return;
      var esc = escalaPxCm(), v = ventanaDe(zona);
      if (!esc || isNaN(esc)) return;
      var L = parseFloat(caja.style.left) || 0, T = parseFloat(caja.style.top) || 0;
      var im = document.createElement('img');
      im.src = x.src; im.alt = ''; im.draggable = false;
      im.style.left = (L + (x.cx - v[0]) * esc - x.w * esc / 2) + 'px';
      im.style.top = (T + (x.cy - v[1]) * esc - x.h * esc / 2) + 'px';
      im.style.width = (x.w * esc) + 'px';
      im.style.height = (x.h * esc) + 'px';
      capaExt.appendChild(im);
    }

    var baseSello = null, colocadoSello = null;   // sellos: composición original y última colocación automática
    function cambiarVista(z) {
      if (z === zona) return;
      seleccionar(null);
      /* Al cambiar de vista con zoom (p. ej. de la manga a la espalda tras añadir un logo) se aleja primero: con el zoom de la vista anterior,
         la nueva salía ampliada y descentrada (Xavi, 22/10: «cuando vuelves de la manga a la espalda no hace zoom out»). */
      if (typeof zoom === 'object' && zoom && zoom.activo && !zoom.foco) zoomMenos();
      var pos = posicionesCm();
      /* sellos: un solo diseño que sigue al modelo. Se guarda dónde cae cada cosa (fracción de la zona y tamaño en cm)
         y, en la zona nueva, se reparte igual y a escala (el diseño es el mismo, solo cambia el tamaño del sello) */
      var antes = null;
      if (o.tintaFija && elementos.length) {
        /* Si nadie ha tocado el diseño desde la última colocación automática, se parte de la composición ORIGINAL (baseSello),
           no de la zona anterior: así al volver de un sello diminuto (8 mm) el diseño recupera su tamaño en vez de quedarse pequeño. */
        var intacto = baseSello && colocadoSello && colocadoSello.length === elementos.length && elementos.every(function (e, i) {
          var q = colocadoSello[i]; return Math.abs(e.st.left - q.l) < 1.5 && Math.abs(e.st.top - q.t) < 1.5 && Math.abs(e.st.w - q.w) < 1.5 && Math.abs(e.st.h - q.h) < 1.5;
        });
        if (!intacto) {
          var escA = escalaPxCm(), rA = rectSeguro(), aA = Col.area(zona);
          var cA = elementos.map(function (e) { var st = e.st; return { l: st.left, t: st.top, r: st.left + st.w, b: st.top + st.h }; });
          var bx0 = Math.min.apply(null, cA.map(function (q) { return q.l; })), bx1 = Math.max.apply(null, cA.map(function (q) { return q.r; }));
          var by0 = Math.min.apply(null, cA.map(function (q) { return q.t; })), by1 = Math.max.apply(null, cA.map(function (q) { return q.b; }));
          var bcx = (bx0 + bx1) / 2, bcy = (by0 + by1) / 2;
          baseSello = { wo: aA[0], ho: aA[1], bw: (bx1 - bx0) / escA, bh: (by1 - by0) / escA,
                    dx: (bcx - (rA.x0 + rA.x1) / 2) / escA, dy: (bcy - (rA.y0 + rA.y1) / 2) / escA,
                    lista: elementos.map(function (e) {
                      var st = e.st;
                      return { ox: ((st.left + st.w / 2) - bcx) / escA, oy: ((st.top + st.h / 2) - bcy) / escA,
                               w: st.w / escA, h: st.h / escA, wRef: (st.wRef || st.w) / escA, hRef: (st.hRef || st.h) / escA };
                    }) };
        }
        antes = baseSello;
      }
      if (tecnicas) tecPorVista[zona.id] = tec;
      fijarVista(z);
      if (tecnicas) tec = tecPorVista[z.id] || tecnicas[0];   // cada zona con su técnica
      dibujarFondo();
      // en una ventana parcial (un lado) lo que cae fuera no se ve
      caja.classList.toggle('is-ventana', Col.area(zona)[0] < anchoTotalCm);
      if (antes && escalaPxCm() && !isNaN(escalaPxCm())) {
        /* El diseño se mueve como UN bloque. Factor: el de la zona (lo que crece o encoge el sello), sin pasarse de lo que
           deja caber el bloque en la zona nueva; en una zona redonda el bloque tiene que caber en el círculo. */
        var escB = escalaPxCm(), rB = rectSeguro(), aB = Col.area(zona), redonda = zona.forma === 'circulo';
        var kRel = Math.min(aB[0] / antes.wo, aB[1] / antes.ho);
        var kFit = redonda ? 0.94 * Math.min(aB[0], aB[1]) / (Math.sqrt(antes.bw * antes.bw + antes.bh * antes.bh) || 1)
                           : 0.97 * Math.min(aB[0] / (antes.bw || 1), aB[1] / (antes.bh || 1));
        var k = Math.min(kRel, kFit);
        var cxB = (rB.x0 + rB.x1) / 2, cyB = (rB.y0 + rB.y1) / 2;
        var bcxB = cxB + (redonda ? 0 : antes.dx * k * escB), bcyB = cyB + (redonda ? 0 : antes.dy * k * escB);
        if (!redonda) {   // que el bloque no se salga de la zona
          var hw = antes.bw * k * escB / 2, hh = antes.bh * k * escB / 2;
          bcxB = Math.max(rB.x0 + hw, Math.min(rB.x1 - hw, bcxB)); bcyB = Math.max(rB.y0 + hh, Math.min(rB.y1 - hh, bcyB));
        }
        elementos.forEach(function (e, i) {
          var q = antes.lista[i], st = e.st; if (!q) return;
          st.w = q.w * k * escB; st.h = q.h * k * escB; st.wRef = q.wRef * k * escB; st.hRef = q.hRef * k * escB;
          st.left = bcxB + q.ox * k * escB - st.w / 2;
          st.top = bcyB + q.oy * k * escB - st.h / 2;
          e.aplicar();
        });
        colocadoSello = elementos.map(function (e) { return { l: e.st.left, t: e.st.top, w: e.st.w, h: e.st.h }; });
        pintarExternos();
      }
      else if (usaFoto && !(fotoImg && fotoImg.naturalWidth)) posPendiente = pos;
      else recolocar(pos);
      refrescarCapas();
      marcarVista();
      // sellos: con una plantilla puesta, el modelo nuevo trae SU versión (más o menos datos) con lo que el cliente ya escribió
      if (o.tintaFija && window.SelloPlantillas && window.SelloPlantillas.alCambiarModelo) { try { window.SelloPlantillas.alCambiarModelo(ctrl, zona); } catch (e) { /* se queda con el escalado */ } }
      if (typeof o.onVista === 'function') o.onVista(zona);   // sellos: la pestaña elige el modelo
    }
    caja.classList.toggle('is-ventana', Col.area(zona)[0] < anchoTotalCm);

    /* En la panorámica, marcas tenues de dónde cae cada lado y el asa. */
    function marcarVentanas() {
      if (Col.area(zona)[0] < anchoTotalCm) return;
      var esc = escalaPxCm();
      var x0 = parseFloat(caja.style.left), y0 = parseFloat(caja.style.top), hpx = parseFloat(caja.style.height);
      var ctx = lienzo.getContext('2d');
      ctx.save();
      /* Col.dibujar deja su transformación (unidades del dibujo) y pinta el
         canvas a la escala de la pantalla (retina, 125 %...): aquí se
         trabaja en px CSS, así que se pone esa escala y nada más. */
      var k = lienzo.width / (parseFloat(lienzo.style.width) || lienzo.getBoundingClientRect().width || lienzo.width);
      ctx.setTransform(k, 0, 0, k, 0, 0);
      ctx.setLineDash([4, 4]);
      ctx.strokeStyle = 'rgba(0,0,0,0.35)';
      ctx.fillStyle = 'rgba(0,0,0,0.45)';
      ctx.font = '11px sans-serif';
      ctx.textAlign = 'center';
      // los rótulos van DENTRO del recuadro, entre su borde y la línea de puntos: encima solo hay ~12 px de lienzo y se cortaban
      var yRot = y0 + 22;
      ctx.font = '10px sans-serif';
      // solo las rayas interiores: las de los extremos coinciden con el borde del área
      vistas.forEach(function (z) {
        if (z === zona) return;
        var v = ventanaDe(z), a = Col.area(z);
        var xa = x0 + v[0] * esc, xb = xa + a[0] * esc;
        [xa, xb].forEach(function (x) {
          if (x <= x0 + 1 || x >= x0 + anchoTotalCm * esc - 1) return;
          ctx.beginPath(); ctx.moveTo(x, y0 - 6); ctx.lineTo(x, y0 + hpx + 6); ctx.stroke();
        });
        ctx.fillText(z.nombre || z.id, (xa + xb) / 2, yRot);
      });
      ctx.fillText('cara opuesta al asa', x0 + (anchoTotalCm / 2) * esc, yRot);
      ctx.restore();
    }
    function marcarVista() {
      refrescarSubir();   // ya recolocado lo de esta vista: el «+» solo si la cara está vacía
      Object.keys(botonesVista).forEach(function (id) {
        botonesVista[id].classList.toggle('is-activa', id === zona.id);
      });
      // móvil: "Dorsales" en la barra de arriba solo en la vista que lo lleva (la espalda), si el producto lo ofrece
      var bDor = document.querySelector('[data-libre-dorsal]');
      if (bDor) bDor.hidden = !(typeof hayDorsal === 'function' && hayDorsal());
    }
    marcarVista();

    /* ---------- elementos ---------- */

    /* En document, no en el tirador: con el tirador capturado, el propio
       navegador reasigna el "target" del pointermove al elemento que hay
       debajo del cursor (el elemento, normalmente), así que un listener
       puesto solo en el tirador nunca lo recibe una vez que el cursor se
       mueve fuera de él. */
    /* Mientras se arrastra o se cambia el tamaño, el precio por tramo tiene
       que ir cambiando al momento (Xavi), no al soltar: se avisa a ropa.js
       como mucho cada 150 ms, que recalcular tramos y previas no es gratis. */
    var ultimoAviso = 0, avisoPendiente = null;
    function avisarCambio() {
      if (typeof o.onCambio !== 'function') return;
      var ahora = Date.now();
      if (ahora - ultimoAviso >= 150) { ultimoAviso = ahora; o.onCambio(); return; }
      if (!avisoPendiente) avisoPendiente = setTimeout(function () { avisoPendiente = null; ultimoAviso = Date.now(); o.onCambio(); }, 150 - (ahora - ultimoAviso));
    }
    function arrastrar(nodo, fn) {
      nodo.addEventListener('pointerdown', function (ev) {
        if (nodo.closest && nodo.closest('.edl__el--fondo')) return; // el fondo es fijo
        if (fn.libre && nodo.closest && nodo.closest('.edl__el--bloq')) return;   // lo que viene de una plantilla no cambia de tamaño ni gira
        ev.preventDefault();
        ev.stopPropagation();
        var inicio = fn.inicio ? fn.inicio(ev) : null;
        // mientras se arrastra (mover, medir, girar) el panel de opciones se aparta: en el móvil tapa la prenda (Xavi)
        host.classList.add('is-arrastrando');
        var x0 = ev.clientX, y0 = ev.clientY, movido = false;
        function mover(ev2) { if (Math.abs(ev2.clientX - x0) + Math.abs(ev2.clientY - y0) > 4) movido = true; fn.mueve(ev2, inicio); avisarCambio(); }
        function suelta() {
          document.removeEventListener('pointermove', mover);
          document.removeEventListener('pointerup', suelta);
          document.removeEventListener('pointercancel', suelta);
          host.classList.remove('is-arrastrando');
          /* Después de arrastrar de verdad, el panel NO vuelve (Xavi): se queda
             la prenda a la vista; un toque en el elemento lo vuelve a abrir. */
          if (movido) host.classList.add('is-sin-panel');
          else if (fn.toque) fn.toque();
          if (fn.fin) fn.fin(movido);
          refrescarOpciones(); // las medidas en cm del panel siguen al tamaño nuevo
        }
        document.addEventListener('pointermove', mover);
        document.addEventListener('pointerup', suelta);
        document.addEventListener('pointercancel', suelta);
      });
    }

    /* Lo común a cualquier elemento (imagen o texto): los 4 tiradores de
       esquina, el estado de posición/tamaño/giro y la selección. `div` ya
       tiene su contenido puesto (la img, o el texto). */
    function crearElemento(tipo, div, wIni, hIni, extra) {
      var el = { id: siguienteId++, tipo: tipo, div: div, visible: true };
      /* Lo propio de cada tipo (la img, el nodo de texto) tiene que estar
         en `el` ANTES de aplicar() y seleccionar(): refrescarOpciones() lee
         el.t al seleccionar un texto, y si aún no estaba, reventaba. */
      Object.keys(extra || {}).forEach(function (k) { el[k] = extra[k]; });
      div.dataset.edlId = el.id;

      ['mover', 'girar', 'medir', 'borrar'].forEach(function (t) {
        var a = document.createElement('button');
        a.type = 'button';
        a.className = 'edl__ti edl__ti--' + t;
        a.setAttribute('aria-label', t);
        a.innerHTML = ICONOS[t];
        div.appendChild(a);
      });
      caja.appendChild(div);
      elementos.push(el);
      refrescarSubir();

      // nace centrado en el recuadro límite (lo visible con margen), no en la ventana entera
      var rs = rectSeguro(), cw = rs.x1 - rs.x0, ch = rs.y1 - rs.y0;
      var w = wIni != null ? wIni : Math.min(cw, ch) * 0.7;
      var h = hIni != null ? hIni : w;
      var st = { left: rs.x0 + (cw - w) / 2, top: rs.y0 + (ch - h) / 2, w: w, h: h, rot: 0, volteado: false };
      el.st = st;

      function aplicar() {
        div.style.left = st.left + 'px';
        div.style.top = st.top + 'px';
        div.style.width = st.w + 'px';
        div.style.height = st.h + 'px';
        var transform = 'rotate(' + st.rot + 'deg)' + (st.volteado ? ' scaleX(-1)' : '');
        var texto = tipo === 'texto' && el.t;
        if (texto) {
          /* Se mide sin girar (el giro se pone al final) para que las
             medidas sean las de la caja de verdad. Varias líneas: el texto
             nunca se parte solo (white-space: pre); las líneas las pone el
             cliente con Intro. */
          div.style.transform = 'none';
          /* La caja de referencia es la que marcó el cliente (al crear o
             al redimensionar); el texto se ajusta a ella y luego la caja
             se pega a las letras. Si se cambia el texto con la caja ya
             pegada, se parte otra vez de la de referencia: si no, cada
             letra o Intro nuevos irían encogiendo el texto. */
          if (!st.wRef) { st.wRef = st.w; st.hRef = st.h; }
          var cx0 = st.left + st.w / 2, cy0 = st.top + st.h / 2;
          st.w = st.wRef; st.h = st.hRef;
          st.left = cx0 - st.w / 2; st.top = cy0 - st.h / 2;
          div.style.left = st.left + 'px'; div.style.top = st.top + 'px';
          div.style.width = st.w + 'px'; div.style.height = st.h + 'px';
          var lineas = (texto.textContent || '').split('\n').length || 1;
          texto.style.fontSize = Math.max(8, st.h / (lineas * 1.2)) + 'px';
          /* Medida real de las letras (no del contenedor, que siempre
             ocupa toda la caja): un Range sobre el contenido. */
          var medir = function () {
            var rg = document.createRange();
            rg.selectNodeContents(texto);
            var a = rg.getBoundingClientRect(), b = texto.getBoundingClientRect();
            return a.width > 0 && a.height > 0 ? { w: a.width, h: a.height, rW: b.width / a.width, rH: b.height / a.height } : null;
          };
          /* La letra escala lineal con su tamaño: multiplicar por la
             relación caja/letras (la más apretada) la deja a tope. Crece
             y encoge; un par de pasadas por el redondeo. */
          var m = null;
          for (var i = 0; i < 3; i++) {
            m = medir();
            if (!m) break;
            var r = Math.min(m.rW, m.rH);
            if (r >= 0.98 && r <= 1.02) break;
            texto.style.fontSize = Math.max(8, parseFloat(texto.style.fontSize) * r * 0.985) + 'px';
          }
          /* seguridad: nunca desborda */
          for (var j = 0; j < 6; j++) {
            m = medir();
            if (!m || (m.rW >= 1 && m.rH >= 1)) break;
            var fs = parseFloat(texto.style.fontSize);
            if (fs <= 8) break;
            texto.style.fontSize = Math.max(8, fs * 0.97) + 'px';
          }
          var bd = el.borde;
          texto.style.webkitTextStroke = (bd && bd.ancho) ? (parseFloat(texto.style.fontSize) * bd.ancho) + 'px ' + bd.color : '';
          /* La caja se pega a las letras: el lado que sobra se encoge,
             manteniendo el centro, para que no quede caja vacía. */
          if (m && m.rW > 1.03) {
            var w2 = Math.ceil(st.w / m.rW) + 2;
            st.left += (st.w - w2) / 2; st.w = w2;
            div.style.left = st.left + 'px'; div.style.width = st.w + 'px';
          }
          if (m && m.rH > 1.03) {
            var h2 = Math.ceil(st.h / m.rH) + 2;
            st.top += (st.h - h2) / 2; st.h = h2;
            div.style.top = st.top + 'px'; div.style.height = st.h + 'px';
          }
        }
        div.style.transform = transform;
      }
      /* Tiradores: en las esquinas del elemento, salvo que se salga del
         recuadro (que recorta): entonces se pegan a las esquinas de la
         parte visible, para que siempre se puedan coger. Solo sin giro;
         girado, las esquinas se quedan donde están. */
      var tiradores = {
        mover: div.querySelector('.edl__ti--mover'), girar: div.querySelector('.edl__ti--girar'),
        medir: div.querySelector('.edl__ti--medir'), borrar: div.querySelector('.edl__ti--borrar')
      };
      function colocarTiradores() {
        var cw = caja.clientWidth, ch = caja.clientHeight;
        // "fuera" incluye tocar el borde: ahí el tirador quedaría medio recortado
        var fuera = st.rot === 0 && (st.left <= 0 || st.top <= 0 || st.left + st.w >= cw || st.top + st.h >= ch);
        if (!fuera) {
          Object.keys(tiradores).forEach(function (k) { var t = tiradores[k].style; t.left = ''; t.top = ''; t.right = ''; t.bottom = ''; });
          return;
        }
        var m = 14; // el tirador entero dentro del recorte
        var x0 = st.left <= 0 ? -st.left + m : 0, y0 = st.top <= 0 ? -st.top + m : 0;
        var x1 = st.left + st.w >= cw ? cw - st.left - m : st.w, y1 = st.top + st.h >= ch ? ch - st.top - m : st.h;
        var pon = function (t, x, y) { t.style.left = x + 'px'; t.style.top = y + 'px'; t.style.right = 'auto'; t.style.bottom = 'auto'; };
        pon(tiradores.mover, x0, y0); pon(tiradores.girar, x1, y0);
        pon(tiradores.medir, x1, y1); pon(tiradores.borrar, x0, y1);
      }
      var aplicarBase = aplicar;
      aplicar = function () { aplicarBase(); colocarTiradores(); if (tipo === 'imagen') comprobarResolucion(el); else if (o.tintaFija && tipo === 'texto') comprobarLegible(el); };
      el.aplicar = aplicar;
      el.aplicarTamaño = function (w2, h2) { st.w = w2; st.h = h2; st.wRef = w2; st.hRef = h2; aplicar(); };

      function centroPantalla() {
        var r = div.getBoundingClientRect();
        return [r.left + r.width / 2, r.top + r.height / 2];
      }

      /* Selección en fase de captura: así se selecciona aunque el hijo
         (el texto editable) pare la propagación para poder escribir. */
      div.addEventListener('pointerdown', function () { el._yaSel = (seleccionado === el); seleccionar(el); }, true);
      /* rueda del ratón sobre una foto de un hueco de plantilla: ampliar o reducir la foto DENTRO del marco (el marco no cambia de tamaño) */
      var ruedaT = null;
      div.addEventListener('wheel', function (ev) {
        if (!(el.bloqueado && el.fuente && el.pan)) return;
        ev.preventDefault();
        var z = el.pan.z || 1;
        z = Math.max(1, Math.min(6, z * (ev.deltaY < 0 ? 1.1 : 1 / 1.1)));
        if (Math.abs(z - (el.pan.z || 1)) < 0.001) return;
        el.pan.z = z;
        recortarHueco(el, false);
        clearTimeout(ruedaT); ruedaT = setTimeout(function () { recortarHueco(el, true); }, 250);
      }, { passive: false });

      // mover: arrastrar el cuerpo o el tirador de arriba-izquierda
      [div, div.querySelector('.edl__ti--mover')].forEach(function (nodo) {
        arrastrar(nodo, {
          // un toque (sin arrastrar) en un hueco de foto vacío abre el selector de imágenes
          /* un toque (sin arrastrar) en un hueco de foto —vacío O YA LLENO— abre el selector: así se puede cambiar la foto una y otra vez
          (Xavi, 14/10: «si vuelvo a picar en esa foto ya no deja cambiarla»). Arrastrar sigue moviendo la foto dentro del marco. */
          /* Xavi, 21/10: «a veces solo hago clic para moverla»: un hueco VACÍO se abre con un toque; una foto YA PUESTA solo se cambia con doble toque */
          toque: function () {
            if (nodo !== div) return;
            var ahora = Date.now(), doble = el._ultToque && ahora - el._ultToque < 450; el._ultToque = ahora;
            var cambiable = el.hueco || el.deHueco || (el.bloqueado && el.fuente && !el.deco);
            if (el.hueco || (cambiable && doble)) { el._ultToque = 0; huecoPendiente = el; modoFondo = false; pedirImagen(); }
            else if (el._yaSel) abrirOpciones();
            else if (esTaza && esMovil() && ((el.tipo === 'texto' && el.bloqueado && !el.dorsal) || (el.tipo === 'imagen' && el.deHueco))) {
              // taza en móvil: un toque en un texto o una foto del montaje abre ya su panel sencillo (el texto, con la caja lista para escribir)
              host.classList.remove('is-sin-panel'); ctrl.cerrarCapas(); refrescarOpciones();
            }
          },
          inicio: function (ev) { return { x: ev.clientX, y: ev.clientY, left: st.left, top: st.top, fx: el.pan ? el.pan.fx : 0.5, fy: el.pan ? el.pan.fy : 0.5 }; },
          fin: function (movido) { if (movido && el.bloqueado && el.fuente) recortarHueco(el, true); },
          mueve: function (ev, ini) {
            /* un elemento de plantilla no se mueve: en una foto, arrastrar desplaza la foto DENTRO de su marco (para centrarla) */
            if (el.bloqueado) { if (el.fuente) panearFoto(el, ev.clientX - ini.x, ev.clientY - ini.y, ini); return; }
            st.left = ini.left + (ev.clientX - ini.x);
            st.top = ini.top + (ev.clientY - ini.y);
            if (!el.fondo) { acotar(st); imanCentro(st); acotar(st); } else ocultarGuias();
            aplicar();
          }
        });
      });

      // redimensionar (uniforme, desde el centro): abajo-derecha
      arrastrar(div.querySelector('.edl__ti--medir'), {
        libre: true,
        inicio: function () {
          var c = centroPantalla();
          return { cx: c[0], cy: c[1], w: st.w, h: st.h, left: st.left, top: st.top, wRef: st.wRef, hRef: st.hRef };
        },
        mueve: function (ev, ini) {
          /* left/top se recalculan siempre desde el estado INICIAL del
             arrastre (ini), no sumando sobre el valor de antes: sumar en
             cada pointermove acumulaba el redondeo y el centro se iba. */
          var dist = Math.hypot(ev.clientX - ini.cx, ev.clientY - ini.cy);
          var distIni = Math.hypot(ini.w / 2, ini.h / 2);
          var esc = limite(dist / distIni, 0.15, 3);
          /* Tope: un objeto normal cabe entero en el área de seguridad
             (para cubrir la taza entera está "Imagen de fondo"). */
          cxRef = st.left + st.w / 2;
          var rs = rectSeguro();
          var escMax = Math.min((rs.x1 - rs.x0) / ini.w, (rs.y1 - rs.y0) / ini.h);
          /* tope por zona (tramos estrictos, p. ej. el pecho de la laboral: 10 × 10) */
          var maxZ = o.maxCmPorZona && zona && o.maxCmPorZona[zona.id], ePxM = maxZ && escalaPxCm();
          if (maxZ && ePxM && !isNaN(ePxM) && !el.fondo) escMax = Math.min(escMax, maxZ[0] * ePxM / ini.w, maxZ[1] * ePxM / ini.h);
          esc = Math.min(esc, escMax);
          st.w = Math.max(12, ini.w * esc);
          st.h = st.w * (ini.h / ini.w);
          /* IMÁN A LOS TAMAÑOS TÍPICOS (Xavi, 14/10): al agrandar o encoger, el diseño se pega a lo que justo cabe en cada tamaño de
             impresión (10×10, 20×25, 30×40…) si pasa cerca: así no se paga un tramo mayor por un par de milímetros. */
          if (o.tamañosTipicosCm && o.tamañosTipicosCm.length && !el.fondo) {
            var ePx = escalaPxCm(), ar = ini.w / ini.h, mejorT = null, tolCm = 0.9;
            if (ePx && !isNaN(ePx)) {
              var wCm = st.w / ePx;
              o.tamañosTipicosCm.forEach(function (t) {
                var ajusta = Math.min(t[0], t[1] * ar), d = Math.abs(wCm - ajusta);
                if (d <= tolCm && (!mejorT || d < mejorT.d)) mejorT = { d: d, w: ajusta };
              });
              if (mejorT) { st.w = mejorT.w * ePx; st.h = st.w / ar; }
              if ((mejorT ? mejorT.w : 0) !== (el._imanTam || 0)) { el._imanTam = mejorT ? mejorT.w : 0; if (mejorT && navigator.vibrate) { try { navigator.vibrate(8); } catch (eV) { /* sin vibración */ } } }
            }
          }
          if (ini.wRef) { var f = st.w / ini.w; st.wRef = ini.wRef * f; st.hRef = ini.hRef * f; }
          st.left = ini.left + (ini.w - st.w) / 2;
          st.top = ini.top + (ini.h - st.h) / 2;
          acotar(st);
          aplicar();
        }
      });

      // girar: arriba-derecha
      arrastrar(div.querySelector('.edl__ti--girar'), {
        libre: true,
        inicio: function () {
          var c = centroPantalla();
          return { cx: c[0], cy: c[1] };
        },
        mueve: function (ev, ini) {
          var ang = Math.atan2(ev.clientY - ini.cy, ev.clientX - ini.cx) * 180 / Math.PI;
          st.rot = ang + 45; // el tirador está a 45º de la horizontal
          aplicar();
        }
      });

      div.querySelector('.edl__ti--borrar').addEventListener('click', function () { borrar(el); });

      aplicar();
      seleccionar(el);
      return el;
    }

    function borrar(el) {
      var i = elementos.indexOf(el);
      if (i >= 0) elementos.splice(i, 1);
      el.div.remove();
      if (seleccionado === el) seleccionar(null);
      refrescarSubir();
      refrescarCapas();
      if (el.tipo === 'imagen' && el.paleta) setTimeout(function () { resincZona(vistaDe(el)); }, 0);   // las que compartían colores con ella se recalculan
    }

    /* Recorta lo transparente o blanco que rodea al dibujo (un PNG con el
       logo en medio de un lienzo vacío o blanco, o lo que deja quitar
       fondo): si no, la
       caja del elemento es la del archivo entero y queda enorme alrededor
       del dibujo. Devuelve { lienzo, x, y, w, h, W, H } o null si no hay
       nada que recortar. El análisis se hace a como mucho 1000 px para no
       recorrer millones de píxeles; el recorte, a resolución completa. */
    function recortarAlfa(fuente) {
      var W = fuente.naturalWidth || fuente.width, H = fuente.naturalHeight || fuente.height;
      if (!W || !H) return null;
      var f = Math.min(1, 1000 / Math.max(W, H));
      var Ws = Math.max(1, Math.round(W * f)), Hs = Math.max(1, Math.round(H * f));
      var c = document.createElement('canvas'); c.width = Ws; c.height = Hs;
      var ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(fuente, 0, 0, Ws, Hs);
      var d;
      try { d = ctx.getImageData(0, 0, Ws, Hs).data; } catch (e) { return null; }
      var x0 = Ws, y0 = Hs, x1 = -1, y1 = -1;
      /* El blanco es aire solo si no se imprime (sublimación) o si la imagen es
         opaca del todo (un JPG o un PNG con el logo sobre un cuadro blanco). En
         un PNG con transparencia el blanco es dibujo: en camiseta se imprime
         (DTF/DTG) y unas letras blancas no se pueden recortar (Xavi, 30/09). */
      var hayTransp = false;
      for (var k = 3; k < d.length; k += 4) { if (d[k] < 250) { hayTransp = true; break; } }
      var blancoAire = !!o.quitarBlanco || !hayTransp;
      for (var y = 0; y < Hs; y++) {
        for (var x = 0; x < Ws; x++) {
          var i = (y * Ws + x) * 4;
          if (d[i + 3] > 30 && !(blancoAire && d[i] > 234 && d[i + 1] > 234 && d[i + 2] > 234)) {
            if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0) return null; // todo transparente: no tocar
      var m = 2 / f; // margen de 2 px de análisis, en px reales
      var rx0 = Math.max(0, Math.floor(x0 / f - m)), ry0 = Math.max(0, Math.floor(y0 / f - m));
      var rx1 = Math.min(W, Math.ceil((x1 + 1) / f + m)), ry1 = Math.min(H, Math.ceil((y1 + 1) / f + m));
      var w = rx1 - rx0, h = ry1 - ry0;
      if (w >= W - 4 && h >= H - 4) return null; // nada que recortar
      var out = document.createElement('canvas'); out.width = w; out.height = h;
      out.getContext('2d').drawImage(fuente, rx0, ry0, w, h, 0, 0, w, h);
      return { lienzo: out, x: rx0, y: ry0, w: w, h: h, W: W, H: H };
    }

    /* Con o.quitarBlanco (sublimación), las imágenes se enseñan ya sin
       blanco: lo que se ve es lo que se imprime. Devuelve un dataURL o
       null si no hay nada que quitar / no se puede leer. */
    function sinBlanco(fuente) {
      if (!o.quitarBlanco) return null;
      var W = fuente.naturalWidth || fuente.width, H = fuente.naturalHeight || fuente.height;
      if (!W || !H) return null;
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      c.getContext('2d').drawImage(fuente, 0, 0);
      try { quitarBlanco(c); } catch (e) { return null; }
      return c.toDataURL('image/png');
    }

    /* Ciñe la caja de un elemento ya colocado a un recorte: el dibujo no
       cambia de tamaño ni de sitio en pantalla, solo se estrecha la caja
       (con el giro y el volteo en cuenta para que el centro caiga bien). */
    function ceñirCaja(el, rec) {
      soltarFuente(el);
      var st = el.st, k = st.w / rec.W; // px de pantalla por px de imagen
      var dx = (rec.x + rec.w / 2 - rec.W / 2) * k * (st.volteado ? -1 : 1);
      var dy = (rec.y + rec.h / 2 - rec.H / 2) * k;
      var a = st.rot * Math.PI / 180, cos = Math.cos(a), sin = Math.sin(a);
      var cx = st.left + st.w / 2 + dx * cos - dy * sin;
      var cy = st.top + st.h / 2 + dx * sin + dy * cos;
      st.w = rec.w * k; st.h = rec.h * k; st.wRef = st.w; st.hRef = st.h;
      st.left = cx - st.w / 2; st.top = cy - st.h / 2;
      el.img.src = rec.lienzo.toDataURL('image/png');
      el.aplicar();
    }

    /* RELOJ DE CARGA: leer y preparar una foto grande tarda; mejor un círculo girando que parecer bloqueado.
       Gira por CSS (transform), que sigue moviéndose aunque el hilo principal esté ocupado. */
    var veloCarga = document.createElement('div');
    veloCarga.className = 'edl__cargando'; veloCarga.hidden = true;
    veloCarga.innerHTML = '<i aria-hidden="true"></i><span>Preparando tu imagen…</span>';
    visor.appendChild(veloCarga);
    var veloTimer = null, veloCuenta = 0;
    /* El velo vive dentro del visor, que con zoom se desplaza: sin esto el velo se movía con el contenido y tapaba solo un trozo del lienzo
       (Xavi, 22/10: «mientras carga en la espalda hace algo raro»). Se mantiene siempre sobre lo que se ve del visor. */
    function ponVelo() {
      veloCarga.style.left = visor.scrollLeft + 'px'; veloCarga.style.top = visor.scrollTop + 'px';
      veloCarga.style.width = visor.clientWidth + 'px'; veloCarga.style.height = visor.clientHeight + 'px';
    }
    visor.addEventListener('scroll', function () { if (!veloCarga.hidden) ponVelo(); });
    function veloImagen(on) {
      veloCuenta = Math.max(0, veloCuenta + (on ? 1 : -1));
      veloCarga.hidden = veloCuenta === 0;
      if (!veloCarga.hidden) ponVelo();
      clearTimeout(veloTimer);
      if (veloCuenta) veloTimer = setTimeout(function () { veloCuenta = 0; veloCarga.hidden = true; }, 25000);
    }
    /* Al subir la PRIMERA imagen de una zona, la técnica se elige sola según sus colores: un solo color → serigrafía de 1 color;
       varios → la primera técnica multicolor (antes toda imagen de color arrancaba en 1 color y salía una mancha). El cliente la cambia
       cuando quiera en «Impresión», y desde entonces no se toca. */
    /* ¿Cuántos colores de verdad lleva la imagen? La misma medida que usa elegirTecAuto: una foto o ilustración tiene decenas
       («ricos» ≥ 13), un logo plano pocos. Sirve para no dejar pasar una foto como serigrafía (Xavi, 06/10). */
    function riquezaColor(el) {
      var im = el && el.img;
      if (!im || !im.naturalWidth) return null;
      var src = (el.srcBase || im.src) + '|' + (el._baseImg ? 1 : 0);
      if (el._riqueza && el._riquezaSrc === src) return el._riqueza;
      // la imagen SIN teñir (la que guarda tintar); si aún no hay, la que se ve (sin teñir todavía)
      var base = el._baseImg && el._baseImg.naturalWidth ? el._baseImg : im;
      var W = 72, H = Math.max(1, Math.round(72 * (base.naturalHeight || 1) / (base.naturalWidth || 1)));
      var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
      var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(base, 0, 0, W, H);
      var dd = cx.getImageData(0, 0, W, H).data, bins64 = {}, total = 0, i2;
      function lum(k) { return (0.299 * dd[k] + 0.587 * dd[k + 1] + 0.114 * dd[k + 2]) / 255; }
      var fondoClaro = [0, W - 1, (H - 1) * W, H * W - 1].filter(function (q) { return dd[q * 4 + 3] >= 128 && lum(q * 4) > 0.9; }).length >= 2;
      for (i2 = 0; i2 < W * H; i2++) {
        var k2 = i2 * 4;
        if (dd[k2 + 3] < 128 || (fondoClaro && lum(k2) > 0.9)) continue;
        total++;
        var k64 = (dd[k2] >> 6) * 16 + (dd[k2 + 1] >> 6) * 4 + (dd[k2 + 2] >> 6); bins64[k64] = (bins64[k64] || 0) + 1;
      }
      var ricos = Object.keys(bins64).filter(function (k) { return bins64[k] >= 0.01 * total; }).length;
      el._riqueza = { ricos: ricos, total: total }; el._riquezaSrc = src;
      return el._riqueza;
    }
    // las zonas (por nombre) que llevan una foto o una imagen de muchos colores con una técnica de serigrafía
    function fotoEnSerigrafia() {
      var malas = [];
      elementos.forEach(function (e) {
        if (!e.visible || e.ejemplo || e.fondo || e.tipo !== 'imagen') return;
        var T = tecDe(e);
        if (!T || !T.colores || !/serigraf/i.test(T.nombre || '')) return;
        var r = riquezaColor(e);
        /* En multicolor, una imagen con muchos tonos (un logo con trama o degradado suave) pasa si al agrupar los colores sale menos del máximo;
           una foto agota los colores permitidos. Con 1 color, o sin paleta aún, vale la medida de siempre. */
        var nPal = T.colores > 1 && e.paleta ? e.paleta.filter(function (q) { return !q.quitado && !q.oculto; }).length : 0;
        if (r && r.ricos >= 13 && !(nPal && nPal < T.colores)) { var z = vistaDe(e); var nm = (z && (z.nombre || z.id)) || 'zona'; if (malas.indexOf(nm) < 0) malas.push(nm); }
      });
      return malas;
    }
    function elegirTecAuto(el) {
      if (el._tecAuto || !tecnicas || tecnicas.length < 2 || el.fondo || el.tipo !== 'imagen') return;
      el._tecAuto = true;
      if (imagenesTec().filter(function (e) { return e !== el; }).length) return;   // la zona ya tenía diseño: se queda como está
      // zona vacía: se elige por el contenido aunque antes se hubiera probado otra técnica (el cliente la cambia en «Impresión»)
      /* Por defecto, a todo color (transfer digital): no cambia colores ni nada de lo que sube el cliente, y es él quien decide
         pasar a serigrafía (Xavi, 07/10). Solo si el producto no tiene esa técnica se elige por el contenido, como antes. */
      var porDefecto = tecnicas.filter(function (x) { return !x.colores; })[0];
      if (porDefecto) { if (porDefecto !== tec) { tec = porDefecto; tecPorVista[zona.id] = porDefecto; setTimeout(function () { if (refrescarImpresion) refrescarImpresion(); avisarCambio(); }, 0); } return; }   // avisar: el bloque «¿Cómo se imprime?» se quedaba marcando la técnica anterior
      try {
        var im = el.img, W = 72, H = Math.max(1, Math.round(72 * (im.naturalHeight || 1) / (im.naturalWidth || 1)));
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var cx = cv.getContext('2d'); cx.drawImage(im, 0, 0, W, H);
        var dd = cx.getImageData(0, 0, W, H).data, bins = {}, total = 0, i2;
        function lum(k) { return (0.299 * dd[k] + 0.587 * dd[k + 1] + 0.114 * dd[k + 2]) / 255; }
        var fondoClaro = [0, W - 1, (H - 1) * W, H * W - 1].filter(function (q) { return dd[q * 4 + 3] >= 128 && lum(q * 4) > 0.9; }).length >= 2;
        // los blancos cuentan como fondo si hay otros colores (un logo con interior blanco), y como tinta si es lo único (letras blancas)
        var opacos = 0, blancos = 0;
        for (i2 = 0; i2 < W * H; i2++) { if (dd[i2 * 4 + 3] >= 128) { opacos++; if (lum(i2 * 4) > 0.9) blancos++; } }
        var sinBlancos = fondoClaro || (opacos - blancos) >= 0.08 * opacos;
        // 1.º pasada: el color más frecuente (la tinta)
        var cuenta1 = {}, suma1 = {}, bins64 = {};
        for (i2 = 0; i2 < W * H; i2++) {
          var k1 = i2 * 4;
          if (dd[k1 + 3] < 128 || (sinBlancos && lum(k1) > 0.9)) continue;
          var q1 = (dd[k1] >> 5) * 64 + (dd[k1 + 1] >> 5) * 8 + (dd[k1 + 2] >> 5);
          cuenta1[q1] = (cuenta1[q1] || 0) + 1;
          var sm = suma1[q1] || (suma1[q1] = [0, 0, 0]); sm[0] += dd[k1]; sm[1] += dd[k1 + 1]; sm[2] += dd[k1 + 2];
        }
        var qMax = Object.keys(cuenta1).sort(function (a1, b1) { return cuenta1[b1] - cuenta1[a1]; })[0];
        var tinta = qMax ? suma1[qMax].map(function (v) { return v / cuenta1[qMax]; }) : [0, 0, 0];
        // distancia de un color al segmento tinta–blanco: los píxeles de borde suavizado de un logo de un solo color caen ahí
        function dSeg(r0, g0, b0) {
          var vx = 255 - tinta[0], vy = 255 - tinta[1], vz = 255 - tinta[2], wx = r0 - tinta[0], wy = g0 - tinta[1], wz = b0 - tinta[2];
          var tt = Math.max(0, Math.min(1, (vx * wx + vy * wy + vz * wz) / (vx * vx + vy * vy + vz * vz || 1)));
          var ex = wx - tt * vx, ey = wy - tt * vy, ez = wz - tt * vz;
          return Math.sqrt(ex * ex + ey * ey + ez * ez);
        }
        for (i2 = 0; i2 < W * H; i2++) {
          var k2 = i2 * 4;
          if (dd[k2 + 3] < 128) continue;
          if (sinBlancos && lum(k2) > 0.9) continue;   // fondo blanco (de un JPG o el interior de un logo): no es tinta
          total++;
          var k64 = (dd[k2] >> 6) * 16 + (dd[k2 + 1] >> 6) * 4 + (dd[k2 + 2] >> 6); bins64[k64] = (bins64[k64] || 0) + 1;
          if (dSeg(dd[k2], dd[k2 + 1], dd[k2 + 2]) < 45) { if (!bins.tinta) bins.tinta = 0; bins.tinta++; continue; }   // la tinta o su borde suavizado
          var key = (dd[k2] >> 5) * 64 + (dd[k2 + 1] >> 5) * 8 + (dd[k2 + 2] >> 5);
          bins[key] = (bins[key] || 0) + 1;
        }
        var signif = Object.keys(bins).filter(function (k) { return bins[k] >= 0.04 * total; }).length;   // «tinta» cuenta como un color si ocupa lo suficiente
        // cuántos colores distintos hay de verdad (cada uno con al menos un 1 % de la imagen): una ilustración o una foto tiene decenas
        var ricos = Object.keys(bins64).filter(function (k) { return bins64[k] >= 0.01 * total; }).length;   // 64 tonos: un logo plano ocupa pocos, una ilustración o foto muchos
        var multi = tecnicas.filter(function (x) { return x.colores > 1; })[0], todoColor = tecnicas.filter(function (x) { return !x.colores; })[0];
        var T = signif <= 1 && ricos <= 5 ? tecnicas[0] : (ricos >= 13 && todoColor ? todoColor : (multi || tecnicas[0]));
        if (T !== tec) { tec = T; tecPorVista[zona.id] = T; setTimeout(function () { if (refrescarImpresion) refrescarImpresion(); avisarCambio(); }, 0); }
      } catch (e3) { /* sin análisis: se queda con la técnica de la zona */ }
    }
    function fijarTinta(el) { elegirTecAuto(el); if (o.tintaFija && !el.mono && !el.fondo) { el.mono = o.tintaFija; tintar(el); } else if (!o.tintaFija && (tecActiva(el) || el.monoTec) && !el.fondo) aplicarTec(el); }   // monoTec: la técnica cambió sola a una a todo color tras teñirse a 1 tinta → se quita la tinta
    function ponerImagen(url, estado) {
      var div = document.createElement('div');
      div.className = 'edl__el edl__el--imagen';
      var img = document.createElement('img');
      img.src = url;
      img.draggable = false;
      div.appendChild(img);

      var el = crearElemento('imagen', div, estado && estado.w, estado && estado.h, { img: img });
      if (estado) {
        el.st.left = estado.left; el.st.top = estado.top;
        el.st.rot = estado.rot; el.st.volteado = estado.volteado;
        el.aplicar();
      } else {
        veloImagen(true);
        el._cargando = true;   // hasta que la imagen esté recortada y lista, nadie la tiñe (un cambio de prenda a mitad dejaba la imagen «pegada» en negro)
        img.addEventListener('error', function () { el._cargando = false; veloImagen(false); }, { once: true });
        img.addEventListener('load', function () {
          // el fondo se mira ANTES del recorte: al cambiar el src la imagen aún no está cargada
          el.fondoDetectado = fondoDe(el);
          el.fondoLiso = !el.fondoDetectado && fondoDe(el, true) === 'liso';   // fondo liso de otro color (azul marino, rojo…): solo consejo, no aviso ni nota de pedido
          setTimeout(function () { consejoImagen(el); }, 900);   // asistente: primeros usos
          // primero, fuera lo transparente de alrededor (PNG con aire)
          var rec = recortarAlfa(img);
          var ratio = (rec ? rec.h / rec.w : img.naturalHeight / img.naturalWidth) || 1;
          /* El recorte se codifica en segundo plano (toBlob): codificar un PNG de varios megapíxeles con toDataURL
             congelaba el móvil unos segundos y la imagen no se podía mover hasta terminar. Mientras tanto la caja
             ya está colocada y se puede arrastrar; la imagen se oculta un instante hasta que llega la recortada. */
          if (rec) {
            if (o.quitarBlanco) quitarBlanco(rec.lienzo);
            img.style.visibility = 'hidden';
            veloImagen(true);
            rec.lienzo.toBlob(function (b) {
              if (!b) { img.style.visibility = ''; veloImagen(false); el._cargando = false; return; }
              img.addEventListener('load', function () { img.style.visibility = ''; comprobarResolucion(el); veloImagen(false); el._cargando = false; el.srcBase = null; fijarTinta(el); }, { once: true });
              img.addEventListener('error', function () { img.style.visibility = ''; veloImagen(false); el._cargando = false; }, { once: true });
              img.src = URL.createObjectURL(b);
            }, 'image/png');
          }
          else { var sb = sinBlanco(img); if (sb) { img.addEventListener('load', function () { el._cargando = false; el.srcBase = null; fijarTinta(el); }, { once: true }); img.src = sb; } else { el._cargando = false; fijarTinta(el); } }
          // imagen nueva: arranca en la caja donde se pulsó «+» (o en la de por defecto)
          var cjN = cajasDe(zona) && cajaNueva != null ? rectCajas()[cajaNueva] : null;
          cxRef = cjN ? (cjN.x0 + cjN.x1) / 2 : null; cajaNueva = null;
          var rs = rectSeguro();
          /* Encaja la imagen en el recuadro respetando su aspecto: una
             apaisada toca el ancho, una vertical toca el alto (antes solo
             se adaptaba el alto y las verticales se salían). Centrada. */
          var maxW = (rs.x1 - rs.x0) * 0.7, maxH = (rs.y1 - rs.y0) * 0.7;
          /* En una superficie grande (camiseta, 30 × 40) la imagen no arranca
             al 70 % (21 × 28, tramo caro): arranca en el tamaño que dice el
             producto (ropa.js: el tramo normal, 20 × 25) y se agranda si se quiere. */
          if (o.tamañoInicialCm && !o.tintaFija) {
            var e0 = escalaPxCm();
            maxW = Math.min(maxW, o.tamañoInicialCm[0] * e0);
            maxH = Math.min(maxH, o.tamañoInicialCm[1] * e0);
          }
          /* Camiseta: arranca al tamaño con el que viene el archivo, contando 300 ppp
             (Xavi: "siempre suponer 300 ppp"), sin pasar del tamaño inicial ni bajar
             de 3 cm: un logo de 1040 px sale de 8,8 cm, no estirado a 20. */
          if (o.tamañoInicialCm && !o.tintaFija) {
            var pxImg = rec ? rec.w : img.naturalWidth;
            if (pxImg > 0) maxW = Math.min(maxW, Math.max(3, pxImg / 300 * 2.54) * escalaPxCm());
          }
          var w = maxW, h = w * ratio;
          if (h > maxH) { h = maxH; w = h / ratio; }
          el.st.left = rs.x0 + (rs.x1 - rs.x0 - w) / 2;
          el.st.top = rs.y0 + (rs.y1 - rs.y0 - h) / 2;
          /* Camiseta: la regla de colocación de siempre (colocacion.js), en
             vez de centrar: 1/4 del alto por encima de la línea de axilas,
             que está a o.axilaCm del borde de arriba del recuadro. */
          if (o.axilaCm && !cajasDe(zona) && !/^manga-/.test(zona.id || '')) {      // las mangas (9,5 × 9,5) no tienen línea de axilas: el logo nace centrado en su recuadro
            var e1 = escalaPxCm();
            el.st.top = Math.max(rs.y0, rs.y0 + (o.axilaCm - (h / e1) / 4) * e1);
          }
          /* Producto que imprime el proveedor (técnica con límite de colores): el logo arranca ENTERO dentro de la zona de
             impresión, con un poco de aire, para que lo que ve el cliente sea lo que se imprime. Luego puede cambiarlo. */
          if (tecActiva()) {
            var tope = Math.min(1, ((rs.x1 - rs.x0) * 0.95) / w, ((rs.y1 - rs.y0) * 0.95) / h);
            if (tope < 1) {
              w *= tope; h *= tope;
              el.st.left = rs.x0 + (rs.x1 - rs.x0 - w) / 2;
              el.st.top = rs.y0 + (rs.y1 - rs.y0 - h) / 2;
            }
          }
          el.aplicarTamaño(w, h);
          refrescarSubir();
          veloImagen(false);
          /* Zona pequeña (pecho 10×10): los cuatro tiradores son casi tan grandes como la imagen y no se entiende nada
             (Xavi, 01/10). Se acerca solo a la zona, y se aleja con 🔍− o tocando fuera. */
          var rz = rectSeguro();
          if ((rz.x1 - rz.x0) < 150 && !zoom.activo && !cajasDe(zona)) setTimeout(function () { if (!zoom.activo) { zoomAuto = true; zoomMas(); } }, 60);
        }, { once: true });
      }
      return el;
    }

    /* ---------- HUECOS DE FOTO de las plantillas (Xavi, 03/10) ----------
       Una plantilla trae huecos con una cámara dibujada; al tocar uno se elige la foto y se recorta (centrada) a la
       forma del hueco. Un hueco vacío es como el texto de ejemplo: se ve, pero no entra en el archivo, ni en el precio,
       ni en el pedido (`ejemplo`). Sí viaja en foto()/cargarEstado() (con `hueco`) para que deshacer no lo pierda. */
    var huecoPendiente = null;
    function placeholderHueco(wcm, hcm) {
      var c = document.createElement('canvas'), W = 900, H = Math.max(40, Math.round(W * hcm / wcm));   // 900 px: con 360 la cámara de un hueco grande salía pixelada
      if (H > 1200) { H = 1200; W = Math.max(40, Math.round(H * wcm / hcm)); }
      c.width = W; c.height = H;
      var g = c.getContext('2d');
      g.fillStyle = '#efede8'; g.fillRect(0, 0, W, H);
      g.strokeStyle = '#b9b4aa'; g.lineWidth = 6; g.setLineDash([20, 16]); g.strokeRect(8, 8, W - 16, H - 16); g.setLineDash([]);
      var u = Math.min(W, H) * 0.34, cx = W / 2, cy = H / 2;
      g.fillStyle = '#8f8a80';
      g.beginPath(); g.moveTo(cx - u, cy - u * 0.55); g.lineTo(cx - u * 0.45, cy - u * 0.55); g.lineTo(cx - u * 0.3, cy - u * 0.85);
      g.lineTo(cx + u * 0.3, cy - u * 0.85); g.lineTo(cx + u * 0.45, cy - u * 0.55); g.lineTo(cx + u, cy - u * 0.55);
      g.lineTo(cx + u, cy + u * 0.75); g.lineTo(cx - u, cy + u * 0.75); g.closePath(); g.fill();
      g.fillStyle = '#efede8'; g.beginPath(); g.arc(cx, cy + u * 0.1, u * 0.42, 0, Math.PI * 2); g.fill();
      g.fillStyle = '#8f8a80'; g.beginPath(); g.arc(cx, cy + u * 0.1, u * 0.26, 0, Math.PI * 2); g.fill();
      return c.toDataURL('image/png');
    }
    function marcarHueco(el) {
      el.hueco = true; el.ejemplo = true; el.deHueco = true;   // deHueco: sigue siendo un hueco de la plantilla aunque ya tenga foto (se puede cambiar)
      el.div.classList.add('edl__el--hueco');
    }
    /* La foto de un hueco se guarda entera (el.fuente) y el recorte al marco se rehace con el desplazamiento (el.pan, 0-1 en cada eje):
       así, en una plantilla, arrastrar la foto la mueve dentro de su marco y se puede centrar. Mientras se arrastra, vista previa
       ligera; al soltar, recorte de calidad. */
    /* dibuja en c el trozo (sx, sy, sw, sh) de la foto, girado rot grados alrededor del centro del trozo (foto girada dentro de su marco) */
    function pintarCorte(c, im, sx, sy, sw, sh, k, rot, espejo) {
      var g = c.getContext('2d');
      if (!rot && !espejo) { g.drawImage(im, sx, sy, sw, sh, 0, 0, c.width, c.height); return; }
      g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
      g.translate(c.width / 2, c.height / 2); g.rotate((rot || 0) * Math.PI / 180); if (espejo) g.scale(-1, 1);
      g.drawImage(im, -(sx + sw / 2) * k, -(sy + sh / 2) * k, im.naturalWidth * k, im.naturalHeight * k);
    }
    function recortarHueco(el, calidad) {
      var f = el.fuente; if (!f) return;
      var r = el.st.w / el.st.h, sw = f.nw, sh = f.nh, sx, sy;
      if (sw / sh > r) sw = sh * r; else sh = sw / r;
      sw /= (el.pan.z || 1); sh /= (el.pan.z || 1);   // zoom con la rueda: se ve una parte más pequeña de la foto, el marco no cambia
      sx = (f.nw - sw) * el.pan.fx; sy = (f.nh - sh) * el.pan.fy;
      var k = Math.min(1, (calidad ? 1800 : 520) / Math.max(sw, sh)), c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(sw * k)); c.height = Math.max(1, Math.round(sh * k));
      pintarCorte(c, f.im, sx, sy, sw, sh, k, el.pan.rot || 0, el.pan.espejo);
      // sellos: PNG (el JPG deja las zonas transparentes en negro) y, al soltar, vuelve a pasarse a tinta
      var png = !!o.tintaFija;
      if (!calidad) { el.img.src = png ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.8); return; }
      c.toBlob(function (b) {
        if (!b) return;
        el.img.addEventListener('load', function () { if (png) { el.mono = null; el.srcBase = null; fijarTinta(el); } avisarCambio(); }, { once: true });
        el.img.src = URL.createObjectURL(b);
      }, png ? 'image/png' : 'image/jpeg', 0.92);
    }
    function panearFoto(el, dx, dy, ini) {
      var f = el.fuente, r = el.st.w / el.st.h, sw = f.nw, sh = f.nh;
      if (sw / sh > r) sw = sh * r; else sh = sw / r;
      sw /= (el.pan.z || 1); sh /= (el.pan.z || 1);
      // arrastrar a la derecha enseña lo de la izquierda: la foto sigue al dedo
      var rx = f.nw - sw, ry = f.nh - sh;
      el.pan.fx = rx > 0 ? Math.max(0, Math.min(1, ini.fx - (dx / el.st.w * sw) / rx)) : 0.5;
      el.pan.fy = ry > 0 ? Math.max(0, Math.min(1, ini.fy - (dy / el.st.h * sh) / ry)) : 0.5;
      recortarHueco(el, false);
    }
    function bloquear(el) { el.bloqueado = true; el.div.classList.add('edl__el--bloq'); }
    function llenarHueco(el, f, pan0) {
      var url = URL.createObjectURL(f), im = new Image();
      im.onload = function () {
        el.fuente = { im: im, nw: im.naturalWidth, nh: im.naturalHeight }; el.pan = pan0 ? { fx: pan0.fx, fy: pan0.fy, z: pan0.z || 1, rot: pan0.rot || 0, espejo: !!pan0.espejo } : { fx: 0.5, fy: 0.5 };
        if (o.tintaFija) {
          /* sello: el logo se ve ENTERO dentro de su hueco (encajado, sin recortar) y con la transparencia de su archivo */
          el.fuente = null;
          var rr = el.st.w / el.st.h, CW = rr >= 1 ? 1200 : Math.round(1200 * rr), CH = rr >= 1 ? Math.round(1200 / rr) : 1200;
          var kk = Math.min(CW / im.naturalWidth, CH / im.naturalHeight), cc = document.createElement('canvas');
          cc.width = Math.max(1, CW); cc.height = Math.max(1, CH);
          cc.getContext('2d').drawImage(im, (CW - im.naturalWidth * kk) / 2, (CH - im.naturalHeight * kk) / 2, im.naturalWidth * kk, im.naturalHeight * kk);
          cc.toBlob(function (bb) {
            if (!bb) return;
            el.img.addEventListener('load', function () { comprobarResolucion(el); el.mono = null; el.srcBase = null; fijarTinta(el); }, { once: true });
            el.img.src = URL.createObjectURL(bb);
            el.original = f; el.hueco = false; el.ejemplo = false;
            el.div.classList.remove('edl__el--hueco');
            refrescarOpciones(); refrescarCapas(); avisarCambio();
          }, 'image/png');
          return;
        }
        var r = el.st.w / el.st.h, sw = im.naturalWidth, sh = im.naturalHeight, sx = 0, sy = 0, zz = el.pan.z || 1;
        if (sw / sh > r) sw = sh * r; else sh = sw / r;
        sw /= zz; sh /= zz; sx = (im.naturalWidth - sw) * el.pan.fx; sy = (im.naturalHeight - sh) * el.pan.fy;   // el encuadre elegido (centrado si no se eligió)
        var k = Math.min(1, 1800 / Math.max(sw, sh)), c = document.createElement('canvas');
        c.width = Math.max(1, Math.round(sw * k)); c.height = Math.max(1, Math.round(sh * k));
        pintarCorte(c, im, sx, sy, sw, sh, k, el.pan.rot || 0, el.pan.espejo);
        c.toBlob(function (b) {
          if (!b) return;
          el.img.addEventListener('load', function () { comprobarResolucion(el); el.mono = null; el.srcBase = null; fijarTinta(el); }, { once: true });
          el.img.src = URL.createObjectURL(b);
          el.original = f; el.hueco = false; el.ejemplo = false;
          el.div.classList.remove('edl__el--hueco');
          refrescarOpciones(); refrescarCapas(); avisarCambio();
        }, o.tintaFija ? 'image/png' : 'image/jpeg', 0.92);
      };
      im.src = url;
    }

    /* El texto se edita escribiendo directamente encima, como en Positivos:
       sin cuadro de diálogo aparte. Un div contenteditable. */
    function ponerTexto(estado) {
      cargarFuentes();
      var div = document.createElement('div');
      div.className = 'edl__el edl__el--texto';
      var t = document.createElement('div');
      t.className = 'edl__texto';
      t.textContent = estado ? estado.texto : 'Tu texto';
      div.appendChild(t);

      var rsT = rectSeguro(), cw = rsT.x1 - rsT.x0, ch = rsT.y1 - rsT.y0;
      // la fuente y el color van antes de crear, para que el primer aplicar() mida bien
      t.style.fontFamily = estado ? estado.fontFamily : FUENTES[0].v;
      if (!estado) t.style.fontWeight = 'bold'; // negrita por defecto
      var el = crearElemento('texto', div, estado ? estado.w : cw * 0.6, estado ? estado.h : ch * 0.3, { t: t });
      if (!estado) abrirOpciones(); // texto nuevo: hay que escribirlo
      t.style.color = estado ? estado.color : '#17171a';
      /* "Tu texto" es un ejemplo, no el diseño (Xavi: "si no escribes nada
         que no ponga nada"): se ve tenue, no entra en el archivo ni en el
         precio, y si se deja vacío desaparece al deseleccionar. */
      if (!estado) { el.ejemplo = true; div.classList.add('edl__el--ejemplo'); }
      if (estado) {
        t.style.fontWeight = estado.fontWeight;
        t.style.fontStyle = estado.fontStyle;
        t.style.textDecoration = estado.textDecoration;
        if (estado.bordeAncho) el.borde = { ancho: estado.bordeAncho, color: estado.bordeColor || '#ffffff' };
        el.st.left = estado.left; el.st.top = estado.top; el.st.rot = estado.rot;
      }
      el.aplicar();
      refrescarOpciones();

      if (!estado) {
        // en una zona pequeña el panel no sale de lejos: se acerca solo para poder escribir
        var rzt = rectSeguro();
        if ((rzt.x1 - rzt.x0) < 150 && !zoom.activo) zoomMas();
        // el foco va al campo "Cambiar texto" del rail, con el ejemplo
        // seleccionado entero, listo para sobreescribir
        setTimeout(function () { inpTexto.focus(); inpTexto.select(); }, 0);
      }
      return el;
    }

    /* ---------- DORSAL como objetos del editor (Xavi, 29/09) ----------
       El nombre y el número son dos textos independientes que se colocan y se miden como
       cualquier elemento, delante y/o detrás, y se pueden ocultar sin borrar. El texto de cada
       uno lo pone ropa.js (setDorsal) con la primera fila de la lista de personas, o un ejemplo.
       Se cobran como una impresión normal: cuentan en la caja envolvente de su cara. No van en
       el archivo del diseño (componer(…, true)): cada prenda lleva el suyo y el taller los saca de
       la lista con la posición y el tamaño de dorsalInfo(). */
    var dor = { nombre: '', numero: '', fontFamily: '', color: '#17171a', peso: 'bold', firma: '' };
    var DOR_MUESTRA = { nombre: 'NOMBRE', numero: '10' };
    function estiloDorsal(el) {
      var t = el.t, txt = dor[el.dorsal] || DOR_MUESTRA[el.dorsal];
      if (t.textContent !== txt) t.textContent = txt;
      t.style.fontFamily = dor.fontFamily || FUENTES[0].v;
      t.style.color = dor.color; t.style.fontWeight = dor.peso; t.style.fontStyle = 'normal'; t.style.textDecoration = 'none';
      el.div.classList.add('edl__el--dorsal');
      el.div.classList.toggle('edl__el--dorsal-muestra', !dor[el.dorsal]);
    }
    function dorsalDeVista(tipo, z) {
      z = z || zona;
      var v = z.ventana || [0, 0], a = Col.area(z), pos = posicionesCm();
      for (var i = 0; i < elementos.length; i++) {
        var e = elementos[i], q = pos[i];
        if (e.dorsal === tipo && q && q.cx >= v[0] && q.cx < v[0] + a[0]) return e;
      }
      return null;
    }
    // dónde está la tinta de las letras dentro de la caja (px de la caja): arriba y abajo
    function tintaDorsal(el) {
      var rg = document.createRange(); rg.selectNodeContents(el.t);
      var a = rg.getBoundingClientRect(), d = el.div.getBoundingClientRect(), k = d.height / el.st.h || 1;
      var cs = getComputedStyle(el.t), c = document.createElement('canvas').getContext('2d');
      c.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + parseFloat(cs.fontSize) + 'px ' + cs.fontFamily;
      var m = c.measureText(el.dorsal === 'numero' ? '0' : 'H');
      var fa = m.fontBoundingBoxAscent || parseFloat(cs.fontSize) * 0.9, cap = m.actualBoundingBoxAscent || parseFloat(cs.fontSize) * 0.7;
      var base = (a.top + fa * k - d.top) / k;
      return { arriba: base - cap, abajo: base };
    }
    function ponerDorsal() {
      var esc = escalaPxCm(), rs = rectSeguro(), cx = (rs.x0 + rs.x1) / 2;
      if (o.dorsalTipo && o.dorsalTipo !== 'camiseta') return ponerDorsalObjeto(rs, cx);   // taza, bidón, bloc…
      var espalda = zona.cara === 'espalda';
      // espalda: nombre arriba (unos 16 × 4 cm) y número debajo (16 × 17), medidas de Xavi; pecho: pequeño, a la izquierda
      var defs = espalda
        ? { nombre: { w: 16, h: 8, y: 1.8 }, numero: { w: 16.5, h: 30, y: 7.5 } }
        : { nombre: { w: 6.7, h: 5, y: 3 }, numero: { w: 7.1, h: 12, y: 6 } };   // medidas de Xavi; manda el ancho
      var dx = espalda ? 0 : 7 * esc, ultimo = null, nuevos = {};
      ['nombre', 'numero'].forEach(function (tipo) {
        var ya = dorsalDeVista(tipo);
        if (ya) { if (!ya.visible) ocultar(ya, false); ultimo = ya; return; }
        var d = defs[tipo], w = d.w * esc, h = d.h * esc;
        var el = ponerTexto({ texto: dor[tipo] || DOR_MUESTRA[tipo], fontFamily: dor.fontFamily || FUENTES[0].v, color: dor.color,
          fontWeight: dor.peso, fontStyle: 'normal', textDecoration: 'none', left: cx + dx - w / 2, top: rs.y0 + d.y * esc, w: w, h: h, rot: 0 });
        el.dorsal = tipo; estiloDorsal(el); reajustarTexto(el);
        // centrado en su sitio por defecto (la caja se pega a las letras y no siempre queda donde nació)
        el.st.left += (cx + dx) - (el.st.left + el.st.w / 2);
        el.aplicar();
        nuevos[tipo] = el;
        ultimo = el;
      });
      /* Nombre y número pegados. Las cajas van pegadas a la línea de texto, no a la tinta: por
         arriba y por abajo queda el aire de la letra (más cuanto más alta la tipografía), y eso
         separaba mucho. Se coloca por la TINTA: la parte alta del nombre a `y` cm y el número
         a `hueco` cm de la base del nombre. Se repite cuando llega la tipografía de verdad. */
      if (nuevos.nombre && nuevos.numero) {
        var yNombre = rs.y0 + (espalda ? 1.8 : 2.9) * esc, hueco = (espalda ? 1.3 : 0.8) * esc;
        var afinar = function () {
          var tn = tintaDorsal(nuevos.nombre), tm = tintaDorsal(nuevos.numero);
          nuevos.nombre.st.top = yNombre - tn.arriba; nuevos.nombre.aplicar();
          tn = tintaDorsal(nuevos.nombre);
          nuevos.numero.st.top = nuevos.nombre.st.top + tn.abajo + hueco - tm.arriba; nuevos.numero.aplicar();
          nuevos.nombre._auto = { cx: nuevos.nombre.st.left + nuevos.nombre.st.w / 2, cy: nuevos.nombre.st.top + nuevos.nombre.st.h / 2 };
        };
        afinar();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
          var n = nuevos.nombre, au = n._auto;
          if (!n.div.isConnected || !au) return;
          var cx = n.st.left + n.st.w / 2, cy = n.st.top + n.st.h / 2;
          if (Math.abs(cx - au.cx) < 2 && Math.abs(cy - au.cy) < 2 * esc + 40) afinar();   // si no lo han movido
        });
      }
      if (ultimo) seleccionar(ultimo);
      refrescarCapas();
    }
    /* En un objeto (taza, bidón…) no hay pecho ni espalda: el NOMBRE nace centrado, grande, en la
       vista que se está viendo, y el número, debajo y oculto (se activa con el ojo de Capas). */
    function ponerDorsalObjeto(rs, cx) {
      var cw = rs.x1 - rs.x0, ch = rs.y1 - rs.y0, ultimo = null;
      var defs = { nombre: { w: cw * 0.7, h: ch * 0.24, y: ch * 0.28, oculto: false }, numero: { w: cw * 0.4, h: ch * 0.3, y: ch * 0.56, oculto: true } };
      ['nombre', 'numero'].forEach(function (tipo) {
        var ya = dorsalDeVista(tipo);
        if (ya) { if (!ya.visible && tipo === 'nombre') ocultar(ya, false); if (tipo === 'nombre') ultimo = ya; return; }
        var d = defs[tipo];
        var el = ponerTexto({ texto: dor[tipo] || DOR_MUESTRA[tipo], fontFamily: dor.fontFamily || FUENTES[0].v, color: dor.color,
          fontWeight: dor.peso, fontStyle: 'normal', textDecoration: 'none', left: cx - d.w / 2, top: rs.y0 + d.y, w: d.w, h: d.h, rot: 0 });
        el.dorsal = tipo; estiloDorsal(el); reajustarTexto(el);
        el.st.left += cx - (el.st.left + el.st.w / 2);
        el.aplicar();
        if (d.oculto) ocultar(el, true);
        else ultimo = el;
      });
      if (ultimo) seleccionar(ultimo);
      refrescarCapas();
    }
    function setDorsal(x) {
      var f = JSON.stringify([x.nombre || '', x.numero || '', x.fontFamily || '', x.color || '', x.peso || '']);
      if (f === dor.firma) return;
      dor.firma = f; dor.nombre = x.nombre || ''; dor.numero = x.numero || '';
      dor.fontFamily = x.fontFamily || dor.fontFamily; dor.color = x.color || dor.color; dor.peso = x.peso || dor.peso;
      elementos.forEach(function (e) { if (e.dorsal) { estiloDorsal(e); reajustarTexto(e); } });
    }
    function hayDorsal() { return elementos.some(function (e) { return e.dorsal && e.visible; }); }
    // los dorsales de cada cara en cm, con el origen en la esquina de arriba a la izquierda de la cara
    function dorsalInfo() {
      var pos = posicionesCm(), sal = [];
      elementos.forEach(function (e, i) {
        if (!e.dorsal || !e.visible || !pos[i]) return;
        var q = pos[i], z = vistas.filter(function (v) { var w = v.ventana || [0, 0], a = Col.area(v); return q.cx >= w[0] && q.cx < w[0] + a[0]; })[0];
        if (!z) return;
        var v0 = z.ventana || [0, 0];
        sal.push({ vista: z.id, cara: z.cara || null, tipo: e.dorsal, x: +(q.cx - v0[0]).toFixed(2), y: +(q.cy - v0[1]).toFixed(2), w: +q.w.toFixed(2), h: +q.h.toFixed(2), rot: e.st.rot || 0 });
      });
      return sal;
    }
    // ¿hay algo del cliente (que no sea dorsal) en esta cara? Si no, no hay archivo de diseño que sacar
    function tieneDiseñoEn(z) {
      var v = z.ventana || [0, 0], a = Col.area(z), pos = posicionesCm();
      return elementos.some(function (e, i) {
        var q = pos[i];
        return e.visible && !e.ejemplo && !e.dorsal && q && q.cx >= v[0] && q.cx < v[0] + a[0];
      });
    }

    // una copia, un poco desplazada para que se vea que hay dos
    function duplicar(el) {
      if (el.dorsal) return null;
      var s = el.st;
      var base = { left: s.left + 12, top: s.top + 12, w: s.w, h: s.h, rot: s.rot, volteado: s.volteado };
      if (el.tipo === 'imagen') {
        var copia = ponerImagen(el.srcBase || el.img.src, base);
        if (el.mono) { copia.mono = el.mono; copia.srcBase = el.srcBase; tintar(copia); }
        if (el.difuminado) { copia.difuminado = el.difuminado; copia.difumEstilo = el.difumEstilo || ''; aplicarDifuminado(copia); }
        return copia;
      }
      var t = el.t;
      base.texto = t.textContent;
      base.fontFamily = t.style.fontFamily; base.color = t.style.color;
      base.fontWeight = t.style.fontWeight; base.fontStyle = t.style.fontStyle;
      base.textDecoration = t.style.textDecoration;
      if (el.borde) { base.bordeAncho = el.borde.ancho; base.bordeColor = el.borde.color; }
      return ponerTexto(base);
    }

    /* LA FOTO SE TRABAJA REDUCIDA. Una foto de móvil (12 MP) se enseñaba en el editor tal cual: el navegador la mantiene descomprimida
       (48 MB) y la pinta cada fotograma con la GPU. En un móvil justo de memoria eso dejaba TODO lento (los fotogramas, el PNG, hasta
       los temporizadores: «Preparando…» más de un minuto). Se descodifica una vez (fuera del hilo principal) y el editor usa una copia
       de como mucho 2.400 px; el ARCHIVO ORIGINAL sigue yendo tal cual al pedido. Devuelve la URL a usar. */
    var LADO_FOTO = 2000;
    function urlReducida(f) {
      var url0 = URL.createObjectURL(f);
      if (!window.createImageBitmap || /svg/i.test(f.type || '')) return Promise.resolve(url0);
      return createImageBitmap(f).then(function (bmp) {
        var w = bmp.width, h = bmp.height, k = LADO_FOTO / Math.max(w, h);
        if (!(k < 1)) { if (bmp.close) bmp.close(); return url0; }
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
        var cx = c.getContext('2d', { willReadFrequently: true }); cx.imageSmoothingQuality = 'medium'; cx.drawImage(bmp, 0, 0, c.width, c.height);
        if (bmp.close) bmp.close();
        var conAlfa = /png|webp|gif/i.test(f.type || '');
        return new Promise(function (ok) {
          c.toBlob(function (bl) {
            c.width = c.height = 1;
            if (!bl) return ok(url0);
            URL.revokeObjectURL(url0);
            ok(URL.createObjectURL(bl));
          }, conAlfa ? 'image/png' : 'image/jpeg', 0.86);
        });
      }, function () { return url0; });
    }
    subir.addEventListener('click', function () { modoFondo = false; huecoPendiente = null; pedirImagenAsis(); });
    var modoFondo = false;
    function esImagenValida(f) {
      var t = (f.type || '').toLowerCase();
      if (t) return t.indexOf('image/') === 0;
      return /\.(png|jpe?g|webp|gif|svg|bmp|avif|heic|heif)$/i.test(f.name || '');   // algunos móviles no dan el tipo
    }
    function avisoNoImagen(f) {
      window.alert('«' + (f.name || 'Ese archivo') + '» no es una imagen.\n\nSube un PNG, JPG, WebP o SVG. Si tu diseño es un PDF, expórtalo a PNG o JPG (o escríbenos y lo preparamos nosotros).');
    }
    entrada.addEventListener('change', function () {
      selectorCerrado();
      var f = entrada.files && entrada.files[0];
      if (!f) return;
      /* un archivo que no es imagen (PDF, Word, zip…) no hacía nada y el cliente no sabía por qué (simulación 04/11/2026) */
      if (!esImagenValida(f)) { entrada.value = ''; huecoPendiente = null; modoFondo = false; avisoNoImagen(f); return; }
      if (huecoPendiente) { var hp = huecoPendiente; huecoPendiente = null; llenarHueco(hp, f); entrada.value = ''; Recientes.guardar(f); return; }
      /* el archivo ORIGINAL se guarda en el elemento: va al pedido tal
         cual lo subió el cliente, además del PNG compuesto (Xavi) */
      var comoFondo = modoFondo;
      modoFondo = false;
      entrada.value = '';
      Recientes.guardar(f);
      urlReducida(f).then(function (u) {
        var el = comoFondo ? ponerFondo(u) : ponerImagen(u);
        if (el) el.original = f;
        else originalPendiente = f; // el fondo se crea al cargar la imagen
      }, function () { avisoNoImagen(f); });
    });

    /* ---------- las últimas imágenes subidas ----------
       Se guardan en el navegador (IndexedDB, las últimas 12) y "Añadir
       imagen" las ofrece antes de abrir el selector (Xavi: "una pantalla
       previa con las últimas subidas"): el logo del club se sube una vez y
       se reutiliza en la siguiente camiseta o en la taza. */
    var Recientes = {
      abrir: function () {
        return new Promise(function (ok, ko) {
          if (!window.indexedDB) return ko(new Error('sin indexedDB'));
          var r = indexedDB.open('imprimirlo-imagenes', 1);
          r.onupgradeneeded = function () { r.result.createObjectStore('imagenes', { keyPath: 'id' }); };
          r.onsuccess = function () { ok(r.result); };
          r.onerror = function () { ko(r.error); };
        });
      },
      lista: function () {
        return Recientes.abrir().then(function (db) {
          return new Promise(function (ok) {
            var r = db.transaction('imagenes').objectStore('imagenes').getAll();
            r.onsuccess = function () { ok((r.result || []).sort(function (a, b) { return b.t - a.t; })); };
            r.onerror = function () { ok([]); };
          });
        }).catch(function () { return []; });
      },
      guardar: function (f) {
        if (!f || f.size > 25 * 1048576) return;
        Recientes.abrir().then(function (db) {
          var t = db.transaction('imagenes', 'readwrite'), st = t.objectStore('imagenes');
          st.put({ id: f.name + '|' + f.size, nombre: f.name, blob: f, t: Date.now() });
          t.oncomplete = function () {
            refrescarRecientes();
            // como mucho doce: fuera las más viejas
            Recientes.lista().then(function (l) {
              if (l.length <= 12) return;
              Recientes.abrir().then(function (db2) {
                var t2 = db2.transaction('imagenes', 'readwrite');
                l.slice(12).forEach(function (x) { t2.objectStore('imagenes').delete(x.id); });
              });
            });
          };
        }).catch(function () { /* sin guardado, sin más */ });
      },
      borrar: function (id) {
        return Recientes.abrir().then(function (db) { var tb = db.transaction('imagenes', 'readwrite'); tb.objectStore('imagenes').delete(id); tb.oncomplete = refrescarRecientes; }).catch(function () {});
      }
    };
    /* «Añadir imagen» NO puede esperar a IndexedDB: en Safari, en los navegadores de dentro de otras apps y en los modos
       privados, indexedDB.open() puede no responder nunca (el botón no hacía nada y sin error), y además Safari solo abre
       el selector de archivos si se pide EN el propio clic, no después de una espera. Por eso las recientes se leen antes y
       se guardan aquí; al pulsar el botón se mira esta copia al instante. Sin recientes -> el selector se abre ya. */
    var recientesCache = [];
    function refrescarRecientes() { Recientes.lista().then(function (l) { recientesCache = l; }); }
    refrescarRecientes();
    var cajaRec = document.createElement('div');
    cajaRec.className = 'edl__recientes'; cajaRec.hidden = true;
    document.body.appendChild(cajaRec);
    function cerrarRecientes() { cajaRec.hidden = true; cajaRec.innerHTML = ''; historialCerrar('recientes'); }
    cajaRec.addEventListener('click', function (ev) { if (ev.target === cajaRec) cerrarRecientes(); });
    // "Añadir imagen": con subidas recientes, se ofrecen primero; si no, al selector
    function pedirImagen() {
      (function (l) {
        if (!l.length) { abrirSelector(); return; }
        var c = document.createElement('div'); c.className = 'edl__recientes__c';
        c.innerHTML = '<p class="edl__recientes__t">Tus últimas imágenes</p>' +
          '<div class="edl__recientes__g"></div>' +
          '<button type="button" class="edl__recientes__b edl__recientes__b--nueva">+ Subir una imagen nueva</button>' +
          '<button type="button" class="edl__recientes__b edl__recientes__b--cerrar">Cancelar</button>';
        var g = c.querySelector('.edl__recientes__g');
        l.forEach(function (x) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'edl__recientes__i'; b.title = x.nombre;
          var im = document.createElement('img'); im.alt = x.nombre; im.src = URL.createObjectURL(x.blob); b.appendChild(im);
          var q = document.createElement('span'); q.className = 'edl__recientes__x'; q.textContent = '×'; q.title = 'Quitar de la lista';
          q.addEventListener('click', function (ev) { ev.stopPropagation(); Recientes.borrar(x.id); b.remove(); if (!g.children.length) cerrarRecientes(); });
          b.appendChild(q);
          b.addEventListener('click', function () {
            var f = new File([x.blob], x.nombre, { type: x.blob.type || 'image/png' });
            if (huecoPendiente) { var hp2 = huecoPendiente; huecoPendiente = null; llenarHueco(hp2, f); cerrarRecientes(); return; }
            var el = modoFondo ? ponerFondo(URL.createObjectURL(f)) : ponerImagen(URL.createObjectURL(f));
            if (el) el.original = f; else originalPendiente = f;
            modoFondo = false;
            cerrarRecientes();
          });
          g.appendChild(b);
        });
        c.querySelector('.edl__recientes__b--nueva').addEventListener('click', function () { cerrarRecientes(); abrirSelector(); });
        c.querySelector('.edl__recientes__b--cerrar').addEventListener('click', cerrarRecientes);
        cajaRec.innerHTML = ''; cajaRec.appendChild(c); cajaRec.hidden = false;
        historialAbrir('recientes', cerrarRecientes);
      })(recientesCache);
    }

    /* ASISTENTE DE «AÑADIR IMAGEN» (Xavi, 04/11/2026). Solo en productos con VARIAS técnicas de impresión (p. ej. serigrafía a 1 color y
       transfer a todo color): el cliente no sabe qué técnica le conviene, así que se lo preguntamos con ejemplos en pantalla.
         Paso 1 · «¿Tu imagen tiene pocos colores o es una foto?» (dos ejemplos lado a lado). Una foto fija la técnica a todo color.
         Paso 2 · sube la imagen (el selector de siempre).
         Paso 3 · si la imagen trae fondo: «¿Quieres quitarlo?» con un antes y un después.
       «No volver a preguntar» y «Saltar» lo apagan; se acuerda en el navegador (imp_asis_img_off). */
    var ASIS_OFF = 'imp_asis_img_off', asisCaja = null;
    function asisOmitido() { try { return localStorage.getItem(ASIS_OFF) === '1'; } catch (e) { return false; } }
    function asisActivo() { return !!(tecnicas && tecnicas.length >= 2 && !o.tintaFija && !asisOmitido()); }
    function asisCerrar() { if (asisCaja && asisCaja.parentNode) asisCaja.parentNode.removeChild(asisCaja); asisCaja = null; }
    function asisHoja(html) {
      asisCerrar();
      var c = document.createElement('div'); c.className = 'edl__asis';
      c.innerHTML = '<div class="edl__asis__c" role="dialog" aria-modal="true">' + html + '</div>';
      c.addEventListener('click', function (ev) { if (ev.target === c) asisCerrar(); });
      document.body.appendChild(c); asisCaja = c;
      return c.firstChild;
    }
    var ASIS_SVG = {
      /* pocos colores: un logo plano de una sola tinta */
      pocos: '<svg viewBox="0 0 160 120" role="img" aria-label="Ejemplo de logo de un solo color"><rect width="160" height="120" fill="#f4f4f6"/>' +
        '<circle cx="80" cy="46" r="26" fill="#1d1d1f"/><path d="M80 28l5.5 11.5 12.5 1.7-9.1 8.7 2.3 12.4L80 56.4 68.8 62.3l2.3-12.4-9.1-8.7 12.5-1.7z" fill="#f4f4f6"/>' +
        '<rect x="42" y="86" width="76" height="9" fill="#1d1d1f"/><rect x="56" y="101" width="48" height="6" fill="#1d1d1f"/></svg>',
      /* foto o muchos colores: paisaje con degradados */
      foto: '<svg viewBox="0 0 160 120" role="img" aria-label="Ejemplo de foto a todo color"><defs><linearGradient id="edlcielo" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3f7fd6"/><stop offset="1" stop-color="#f6c58a"/></linearGradient>' +
        '<linearGradient id="edlmonte" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#4f9a4b"/><stop offset="1" stop-color="#1f5f2a"/></linearGradient></defs>' +
        '<rect width="160" height="120" fill="url(#edlcielo)"/><circle cx="118" cy="36" r="14" fill="#ffe08a"/>' +
        '<path d="M0 84 L38 46 L70 78 L100 54 L160 96 V120 H0z" fill="url(#edlmonte)"/><path d="M0 104 Q40 88 80 102 T160 100 V120 H0z" fill="#2f7d3a"/>' +
        '<circle cx="46" cy="98" r="5" fill="#e0457b"/><circle cx="62" cy="104" r="4" fill="#f2d33b"/><circle cx="30" cy="106" r="4" fill="#fff"/></svg>',
      /* con fondo: el logo dentro de un recuadro blanco */
      conFondo: '<svg viewBox="0 0 160 120" role="img" aria-label="Imagen con fondo blanco"><rect width="160" height="120" fill="#fff" stroke="#c9c9cf"/>' +
        '<circle cx="80" cy="50" r="28" fill="#e2252b"/><path d="M80 30l6 12.5 13.6 1.9-9.9 9.5 2.5 13.5L80 60.4 67.8 67.4l2.5-13.5-9.9-9.5 13.6-1.9z" fill="#fff"/>' +
        '<rect x="44" y="90" width="72" height="10" fill="#1d1d1f"/></svg>',
      /* sin fondo: el mismo logo sobre el cuadrado de «transparente» */
      sinFondo: '<svg viewBox="0 0 160 120" role="img" aria-label="Imagen sin fondo"><defs><pattern id="edlcuadros" width="16" height="16" patternUnits="userSpaceOnUse"><rect width="16" height="16" fill="#f1f1f4"/><rect width="8" height="8" fill="#dcdce2"/><rect x="8" y="8" width="8" height="8" fill="#dcdce2"/></pattern></defs>' +
        '<rect width="160" height="120" fill="url(#edlcuadros)"/><circle cx="80" cy="50" r="28" fill="#e2252b"/><path d="M80 30l6 12.5 13.6 1.9-9.9 9.5 2.5 13.5L80 60.4 67.8 67.4l2.5-13.5-9.9-9.5 13.6-1.9z" fill="#fff"/>' +
        '<rect x="44" y="90" width="72" height="10" fill="#1d1d1f"/></svg>'
    };
    function asisPaso1() {
      var h = asisHoja('<p class="edl__asis__t">¿Cómo es tu imagen?</p>' +
        '<p class="edl__asis__s">Así te proponemos la mejor forma de imprimirla.</p>' +
        '<div class="edl__asis__par">' +
        '<button type="button" class="edl__asis__op" data-asis="pocos">' + ASIS_SVG.pocos + '<b>Pocos colores</b><small>Un logo, un texto o un dibujo plano</small></button>' +
        '<button type="button" class="edl__asis__op" data-asis="foto">' + ASIS_SVG.foto + '<b>Es una foto o lleva muchos colores</b><small>Fotos, degradados, dibujos con muchos colores</small></button></div>' +
        '<button type="button" class="edl__asis__lnk" data-asis="saltar">Saltar, ya sé lo que quiero</button>' +
        '<button type="button" class="edl__asis__lnk edl__asis__lnk--gris" data-asis="nunca">No volver a preguntar</button>');
      h.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('[data-asis]'); if (!b) return;
        var a = b.getAttribute('data-asis');
        if (a === 'nunca') { try { localStorage.setItem(ASIS_OFF, '1'); } catch (e) { /* sin almacenamiento */ } asisCerrar(); pedirImagen(); return; }
        if (a === 'saltar') { asisCerrar(); pedirImagen(); return; }
        asisPaso2(a);
      });
    }
    function asisPaso2(tipo) {
      var foto = tipo === 'foto';
      var h = asisHoja('<p class="edl__asis__t">' + (foto ? 'Perfecto: lo imprimimos a todo color' : 'Perfecto: imprimimos tu logo con el mejor precio') + '</p>' +
        '<div class="edl__asis__uno">' + ASIS_SVG[foto ? 'foto' : 'pocos'] + '</div>' +
        '<p class="edl__asis__s">' + (foto ? 'Verás tu foto con todos sus colores, degradados incluidos.' : 'Si tu logo tiene más de un color, lo pasamos a todo color sin que tengas que hacer nada.') + '</p>' +
        '<button type="button" class="edl__asis__b" data-asis="subir">Subir mi imagen</button>' +
        '<button type="button" class="edl__asis__lnk" data-asis="atras">‹ Cambiar la respuesta</button>');
      h.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('[data-asis]'); if (!b) return;
        var a = b.getAttribute('data-asis');
        if (a === 'atras') { asisPaso1(); return; }
        if (a === 'subir') { asisCerrar(); asisEsperaImagen(tipo); pedirImagen(); }
      });
    }
    /* Tras elegir, espera a que aparezca la imagen nueva (o a que el cliente se arrepienta: 3 min) y entonces aplica la técnica y pregunta por el fondo. */
    var asisReloj = null;
    function asisEsperaImagen(tipo) {
      clearInterval(asisReloj);
      var antes = elementos.filter(function (e) { return e.tipo === 'imagen'; }).length, t0 = Date.now();
      asisReloj = setInterval(function () {
        var imgs = elementos.filter(function (e) { return e.tipo === 'imagen'; });
        if (Date.now() - t0 > 180000) { clearInterval(asisReloj); return; }
        if (imgs.length <= antes) return;
        clearInterval(asisReloj);
        var el = imgs[imgs.length - 1]; el._asis = true;
        if (tipo === 'foto') {
          var todo = tecnicas.filter(function (x) { return !x.colores; })[0];
          if (todo && window.__edl && window.__edl.fijarTecnica) window.__edl.fijarTecnica(todo.id);
        }
        asisEsperaFondo(el, 0);
      }, 400);
    }
    function asisEsperaFondo(el, n) {   // la imagen mira su fondo al cargar: se espera hasta 4 s
      if (!el || !el.div || !el.div.isConnected) return;
      if (el.fondoDetectado && fondoPendiente(el)) { asisPaso3(el); return; }
      if (n < 16 && (el._cargando || !el.fondoDetectado)) setTimeout(function () { asisEsperaFondo(el, n + 1); }, 250);
    }
    function asisPaso3(el) {
      var h = asisHoja('<p class="edl__asis__t">Tu imagen tiene fondo. ¿Quieres quitarlo?</p>' +
        '<div class="edl__asis__par">' +
        '<div class="edl__asis__op edl__asis__op--fijo">' + ASIS_SVG.conFondo + '<b>Con fondo</b><small>Se imprime también el recuadro</small></div>' +
        '<div class="edl__asis__op edl__asis__op--fijo">' + ASIS_SVG.sinFondo + '<b>Sin fondo</b><small>Solo se imprime tu dibujo</small></div></div>' +
        '<button type="button" class="edl__asis__b" data-asis="quitar">Sí, quitar el fondo</button>' +
        '<button type="button" class="edl__asis__lnk" data-asis="dejar">No, dejarla como está</button>');
      h.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('[data-asis]'); if (!b) return;
        var a = b.getAttribute('data-asis');
        asisCerrar();
        if (a === 'quitar' && el.div.isConnected) { seleccionar(el, true); quitarFondoDe(el); }
      });
    }
    // «Añadir imagen» con asistente: lo usan el botón de subir y el de la barra inferior
    function pedirImagenAsis() { if (huecoPendiente || modoFondo || !asisActivo()) { pedirImagen(); return; } asisPaso1(); }

    /* Imagen de fondo: cubre la superficie entera (20 × 9,5), centrada y
       recortada por el lado que sobre; fija (ni se mueve ni se
       redimensiona) y siempre la capa de más atrás. Solo puede haber una:
       subir otra la sustituye. */
    function fondoActual() { return elementos.filter(function (e) { return e.fondo; })[0] || null; }

    /* Color de fondo: un fondo liso de toda la superficie. Por dentro es
       una imagen de fondo más (un lienzo pequeño relleno del color, con
       la proporción 20:9,5), así hereda todo lo del fondo: fija, capa de
       atrás, una sola. el.colorFondo guarda el hex para producción. */
    function lienzoColor(hex) {
      var c = document.createElement('canvas');
      c.width = 200; c.height = Math.round(200 * altoTotalCm / anchoTotalCm);
      var ctx = c.getContext('2d'); ctx.fillStyle = hex; ctx.fillRect(0, 0, c.width, c.height);
      return c.toDataURL('image/png');
    }
    var inpColorFondo = document.createElement('input');
    inpColorFondo.type = 'color'; inpColorFondo.value = '#f4e4c1';
    inpColorFondo.hidden = true;
    host.appendChild(inpColorFondo);
    inpColorFondo.addEventListener('input', function () {
      var hex = inpColorFondo.value, el = fondoActual();
      if (el && el.colorFondo) { el.img.src = lienzoColor(hex); el.colorFondo = hex; return; }
      ponerFondo(lienzoColor(hex), hex);
    });

    var originalPendiente = null;
    function ponerFondo(url, colorHex) {
      var img = new Image();
      img.onload = function () {
        var original = originalPendiente; originalPendiente = null;
        // sublimación: el fondo también se enseña sin blanco (salvo el color liso)
        if (!colorHex) { var sb = sinBlanco(img); if (sb) url = sb; }
        var r = img.naturalHeight / img.naturalWidth || 1;
        var wcm = anchoTotalCm, hcm = wcm * r;
        if (hcm < altoTotalCm) { hcm = altoTotalCm; wcm = hcm / r; }
        var esc = escalaPxCm(), v = ventanaDe(zona);
        var estado = { w: wcm * esc, h: hcm * esc, rot: 0, volteado: false,
                       left: (anchoTotalCm / 2 - v[0]) * esc - wcm * esc / 2,
                       top: (altoTotalCm / 2 - v[1]) * esc - hcm * esc / 2 };
        var el = fondoActual();
        if (el) {
          el.img.src = url;
          el.colorFondo = colorHex || null;
          el.original = original || null;
          el.st.left = estado.left; el.st.top = estado.top; el.st.volteado = false;
          el.aplicarTamaño(estado.w, estado.h);
          seleccionar(el);
          refrescarCapas();
          refrescarOpciones();
          return;
        }
        el = ponerImagen(url, estado);
        el.original = original || null;
        el.fondo = true;
        el.colorFondo = colorHex || null;
        el.div.classList.add('edl__el--fondo');
        // al fondo del todo: primero del array y del DOM
        elementos.splice(elementos.indexOf(el), 1);
        elementos.unshift(el);
        caja.insertBefore(el.div, caja.querySelector('.edl__el'));
        refrescarCapas();
        refrescarOpciones();
      };
      img.src = url;
    }

    /* Reutiliza el quitar-fondo que ya tenemos (arreglo-imagen.js), el mismo
       que usan pegatinas y ropa: no hace falta uno nuevo para el editor
       libre. Actúa sobre la imagen seleccionada. */
    function quitarFondo() {
      var el = imagenSel();
      if (!el || !window.ImgArreglo) return { ok: false, motivo: 'sin-imagen' };
      var img = el.img;
      /* Nunca pasarle el <img> tal cual: su .width/.height en DOM son el
         tamaño en pantalla, no los píxeles reales del archivo — quitarFondo()
         los usa para pintar y analizar, así que devolvía una miniatura. Un
         lienzo aparte, al tamaño natural, se libra del problema. */
      var real = document.createElement('canvas');
      real.width = img.naturalWidth; real.height = img.naturalHeight;
      real.getContext('2d').drawImage(img, 0, 0);
      var res = ImgArreglo.quitarFondo(real);
      if (res.ok) {
        // sin fondo suele quedar aire transparente alrededor: la caja se ciñe al dibujo
        if (o.quitarBlanco) quitarBlanco(res.lienzo);
        var rec = recortarAlfa(res.lienzo);
        if (rec) ceñirCaja(el, rec);
        else img.src = res.lienzo.toDataURL('image/png');
      }
      return res;
    }

    /* ---------- composición para producción ----------
       El diseño entero (toda la superficie, 20 × 9,5) a `ppcm` píxeles por
       cm, en el mismo orden de capas que en pantalla: fondo (color o
       imagen), imágenes con su giro y volteo, textos con su fuente. Lo que
       sale de aquí es lo que se imprime. */
    /* Las imágenes grandes (una foto de 12 MP) se descodifican UNA vez a una copia de como mucho 2.600 px y todas las composiciones
       (previas, archivo del pedido) dibujan desde ella. Dibujar la foto original cada vez obligaba al móvil a volver a descomprimirla
       entera en cada paso —Chrome tira las imágenes descodificadas cuando va justo de memoria—, y eso eran decenas de segundos. */
    var LADO_FUENTE = 2600;
    function fuenteDe(el) {
      var im = el.img;
      if (!im || !im.naturalWidth) return im;
      var nw = im.naturalWidth, nh = im.naturalHeight;
      if (Math.max(nw, nh) <= LADO_FUENTE) return im;
      if (el._fuente && el._fuenteSrc === im.src) return el._fuente;
      var k = LADO_FUENTE / Math.max(nw, nh), c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(nw * k)); c.height = Math.max(1, Math.round(nh * k));
      var cx = c.getContext('2d', { willReadFrequently: true }); cx.imageSmoothingQuality = 'medium'; cx.drawImage(im, 0, 0, c.width, c.height);
      el._fuente = c; el._fuenteSrc = im.src;
      return c;
    }
    function componer(ppcm, recorte, sinDorsal) {
      ppcm = ppcm || 118.11; // 300 ppp
      // recorte: { x, w } en cm, para sacar solo un lado (8 × 9,5) en vez de toda la superficie
      var x0 = recorte ? recorte.x : 0, wcm = recorte ? recorte.w : anchoTotalCm;
      var W = Math.round(wcm * ppcm), H = Math.round(altoTotalCm * ppcm);
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      /* willReadFrequently: el lienzo vive en la CPU, no en la GPU. De estos lienzos se lee todo (quitar blanco, codificar el PNG), y con la GPU de
         algunos móviles cada lectura obligaba a esperar a que dibujara una foto de 12 MP: el navegador se quedaba parado más de un minuto. */
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.translate(-x0 * ppcm, 0);
      var pos = posicionesCm();
      elementos.forEach(function (el, i) {
        if (!el.visible || el.ejemplo) return;
        if (sinDorsal && el.dorsal) return;   // el dorsal es distinto en cada prenda: no va en el archivo del diseño
        var q = pos[i], s = el.st;
        if (!q) return;
        var w = q.w * ppcm, h = q.h * ppcm;
        ctx.save();
        ctx.translate(q.cx * ppcm, q.cy * ppcm);
        ctx.rotate(s.rot * Math.PI / 180);
        if (s.volteado) ctx.scale(-1, 1);
        if (el.tipo === 'imagen') {
          if (el.colorFondo) { ctx.fillStyle = el.colorFondo; ctx.fillRect(-w / 2, -h / 2, w, h); }
          else if (el.img.naturalWidth && el.difuminado && el.difumEstilo) {
            // con el borde difuminado: la imagen y, encima (destination-in), la máscara suave
            var tmp = document.createElement('canvas'); tmp.width = Math.max(1, Math.round(w)); tmp.height = Math.max(1, Math.round(h));
            var tc = tmp.getContext('2d');
            tc.drawImage(fuenteDe(el), 0, 0, tmp.width, tmp.height);
            tc.globalCompositeOperation = 'destination-in';
            tc.imageSmoothingQuality = 'high';
            if (/^(letra|forma):/.test(el.difumEstilo) && !imgsMascara[el.difumEstilo]) construirMascaraLetra(el.difumEstilo);
            tc.drawImage(imgsMascara[el.difumEstilo] && imgsMascara[el.difumEstilo].naturalWidth ? imgsMascara[el.difumEstilo] : mascaraDifuminado(el.difuminado, 256), 0, 0, tmp.width, tmp.height);
            ctx.drawImage(tmp, -w / 2, -h / 2, w, h);
          }
          else if (el.img.naturalWidth) ctx.drawImage(fuenteDe(el), -w / 2, -h / 2, w, h);
        } else {
          componerTexto(ctx, el, ppcm);
        }
        ctx.restore();
      });
      return c;
    }
    function componerTexto(ctx, el, ppcm) {
      var t = el.t, cs = getComputedStyle(t);
      // el tamaño de letra en pantalla, pasado a cm y de ahí a px de impresión
      var fs = parseFloat(t.style.fontSize) / escalaPxCm() * ppcm;
      var lineas = (t.textContent || '').split('\n');
      var lh = fs * 1.2;
      ctx.font = (cs.fontStyle || 'normal') + ' ' + (cs.fontWeight || '400') + ' ' + fs + 'px ' + cs.fontFamily;
      ctx.fillStyle = cs.color;
      ctx.textAlign = 'center';
      /* Misma colocación vertical que en pantalla: en CSS la línea (1,2 de alto) se centra y la
         letra queda sobre su línea base según el ascenso y el descenso de la tipografía. Con
         textBaseline "middle" cada tipografía caía distinta y, con letras grandes (un dorsal de
         25 cm), el hueco entre el nombre y el número de la vista previa no era el del editor. */
      var mt = ctx.measureText('Hg'), asc = mt.fontBoundingBoxAscent, desc = mt.fontBoundingBoxDescent;
      var conMetricas = typeof asc === 'number' && typeof desc === 'number' && (asc + desc) > 0;
      ctx.textBaseline = conMetricas ? 'alphabetic' : 'middle';
      var dyBase = conMetricas ? (asc - desc) / 2 : 0;
      var y0 = -(lineas.length - 1) * lh / 2;
      var subrayado = String(cs.textDecorationLine || cs.textDecoration || '').indexOf('underline') >= 0;
      var bd = el.borde;
      if (bd && bd.ancho) { ctx.strokeStyle = bd.color; ctx.lineWidth = fs * bd.ancho; ctx.lineJoin = 'round'; }
      lineas.forEach(function (ln, i) {
        var y = y0 + i * lh + dyBase;
        if (bd && bd.ancho) ctx.strokeText(ln, 0, y); // primero el borde, encima la letra (como paint-order: stroke)
        ctx.fillText(ln, 0, y);
        if (subrayado) {
          var m = ctx.measureText(ln);
          ctx.fillRect(-m.width / 2, y + (conMetricas ? fs * 0.1 : fs * 0.42), m.width, Math.max(1, fs * 0.06));
        }
      });
    }
    function hayDiseño() { return elementos.some(function (e) { return e.visible && !e.ejemplo; }); }

    /* ---------- guardar y recuperar el diseño ----------
       estado(): todo lo puesto, en cm sobre la superficie, con las imágenes
       como Blob (IndexedDB los guarda tal cual) y el archivo original.
       cargarEstado(): lo vuelve a montar. Es lo que permite "Editar" desde
       el carrito (Xavi: por si se han equivocado). */
    /* La foto del diseño, síncrona: todo lo que hace falta para rehacerlo,
       con las imágenes como src (data: o blob: de esta misma página). Es
       lo que guarda el historial de deshacer. estado() es lo mismo con
       las imágenes como Blob, para guardarlo en IndexedDB. */
    /* Un Blob a partir del src de una imagen SIN pasar por fetch(): en el móvil de Xavi toda la actividad de red/disco del navegador se
       quedaba parada decenas de segundos tras pulsar «Añadir», y fetch(blob:) es una de ellas. data: se decodifica aquí; blob: se
       recupera del registro que se hace al crear la URL (ver blobPorUrl); lo demás sí va por fetch. */
    function leerBlob(src) {
      try {
        var m = /^data:([^;,]*)(;base64)?,(.*)$/.exec(src);
        if (m) {
          var bin = m[2] ? atob(m[3]) : decodeURIComponent(m[3]), u8 = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
          return Promise.resolve(new Blob([u8], { type: m[1] || 'image/png' }));
        }
        if (blobPorUrl.has(src)) return Promise.resolve(blobPorUrl.get(src));
      } catch (e) { /* se prueba con fetch */ }
      return fetch(src).then(function (r) { return r.blob(); });
    }
    function foto() {
      var pos = posicionesCm();
      var tecsGuardadas = null;
      if (tecnicas) {   // la técnica de impresión de cada zona
        tecsGuardadas = {};
        vistas.forEach(function (z) { tecsGuardadas[z.id] = (z === zona ? tec : (tecPorVista[z.id] || tecnicas[0])).id; });
      }
      return { vista: zona.id, tecnicas: tecsGuardadas, elementos: elementos.filter(function (e) { return !e.ejemplo || e.hueco; }).map(function (e) {
        var i = elementos.indexOf(e), q = pos[i], s = e.st;
        var base = { tipo: e.tipo, visible: e.visible, fondo: !!e.fondo, colorFondo: e.colorFondo || null,
          cx: q.cx, cy: q.cy, w: q.w, h: q.h, wRef: q.wRef, hRef: q.hRef, rot: s.rot, volteado: !!s.volteado, original: e.original || null };
        if (e.tipo === 'texto') {
          var t = e.t;
          base.dorsal = e.dorsal || null;
          base.texto = t.textContent; base.fontFamily = t.style.fontFamily; base.color = t.style.color;
          base.fontWeight = t.style.fontWeight; base.fontStyle = t.style.fontStyle; base.textDecoration = t.style.textDecoration;
          if (e.borde && e.borde.ancho) { base.bordeAncho = e.borde.ancho; base.bordeColor = e.borde.color; }
          return base;
        }
        base.mono = e.mono || null;
        // ajustes de la técnica de impresión (colores, tinta, fondo blanco)
        base.semitono = !!e.semitono; base.monoTec = !!e.monoTec; base.tintaElegida = e.tintaElegida || null; base.nCol = e.nCol || null;
        base.colQuita = e.colQuita || null; base.colCambia = e.colCambia || null; base.fondoBlanco = e.fondoBlanco;
        base.difuminado = e.difuminado || 0; base.difumEstilo = e.difumEstilo || '';
        base.src = e.srcBase || e.img.src;
        if (e.hueco) base.hueco = true;
        if (e.bloqueado) base.bloqueado = true;
        if (e.deco) base.deco = true;
        base.arreglos = (e.arreglos || []).slice();
        return base;
      }) };
    }
    function estado() {
      var f = foto();
      return Promise.all(f.elementos.map(function (base) {
        if (base.tipo === 'texto') return Promise.resolve(base);
        var src = base.src; delete base.src;
        return leerBlob(src).then(function (b) { base.imagen = b; return base; });
      })).then(function (lista) { return { vista: f.vista, tecnicas: f.tecnicas, elementos: lista, zonaCm: { v: ventanaDe(zona).slice(0, 2), a: Col.area(zona).slice(0, 2) } }; });
    }

    /* PROYECTO PARA EL TALLER (modo rápido del móvil): todo lo que hace falta para montar el archivo SIN canvas ni codificar nada
       aquí. Cada imagen viaja tal cual se ve (la que tiene el elemento: ya teñida, reducida o con el fondo quitado, como Blob leído
       de su blob:/data:, sin tocar ningún lienzo) y la colocación va en cm sobre la superficie, como en componer(). El panel lo monta
       con Python (pedidosdtf.py). Devuelve { datos, piezas:[{ n, blob }] }. */
    function proyecto() {
      var pos = posicionesCm(), piezas = [], els = [], trabajos = [];
      elementos.forEach(function (el, i) {
        if (!el.visible || el.ejemplo || el.dorsal) return;
        var q = pos[i], s = el.st;
        if (!q) return;
        var b = { tipo: el.tipo, cx: +q.cx.toFixed(3), cy: +q.cy.toFixed(3), w: +q.w.toFixed(3), h: +q.h.toFixed(3), rot: s.rot || 0, volteado: !!s.volteado };
        if (el.tipo === 'imagen') {
          if (el.colorFondo) b.colorFondo = el.colorFondo;
          else if (el.img && el.img.src) {
            b.pieza = piezas.length + 1;
            if (el.difuminado && el.difumEstilo) b.difuminado = el.difumEstilo;
            piezas.push({ n: b.pieza, src: el.img.src, i: els.length });
          } else return;
        } else {
          var t = el.t, cs = getComputedStyle(t);
          b.texto = t.textContent || '';
          b.tam_cm = +(parseFloat(t.style.fontSize) / escalaPxCm()).toFixed(3);   // alto de la letra (em) en cm
          b.fuente = cs.fontFamily; b.peso = cs.fontWeight; b.estilo = cs.fontStyle; b.color = cs.color;
          b.subrayado = String(cs.textDecorationLine || cs.textDecoration || '').indexOf('underline') >= 0;
          if (el.borde && el.borde.ancho) { b.bordeAncho = el.borde.ancho; b.bordeColor = el.borde.color; }
        }
        els.push(b);
      });
      var datos = { v: 1, ancho: anchoTotalCm, alto: altoTotalCm, elementos: els };
      return Promise.all(piezas.map(function (p) {
        return leerBlob(p.src).then(function (bl) { return { n: p.n, blob: bl }; });
      })).then(function (ps) { return { datos: datos, piezas: ps }; });
    }

    /* ---------- deshacer / rehacer ----------
       Cada cambio del diseño (mover, escribir, añadir, borrar, color…)
       deja una foto en el historial; se detecta con un MutationObserver
       sobre el recuadro, así no hay que acordarse en cada sitio. Ctrl+Z
       deshace, Ctrl+Y o Ctrl+Mayús+Z rehace, y hay dos botones sobre la
       taza (Xavi: "Ctrl+Z y de paso un botón de deshacer"). */
    var historia = [], futuro = [], restaurando = false, temporizadorHist = null, HIST_MAX = 60;
    var fuentesHist = [], idxFuenteHist = new Map();   // imágenes grandes del historial, una sola vez cada una
    var barraHist = document.createElement('div');
    barraHist.className = 'edl__historia';
    var btnDeshacer = boton('edl__historia__b', '↶'), btnRehacer = boton('edl__historia__b', '↷');
    btnDeshacer.title = 'Deshacer (Ctrl+Z)'; btnDeshacer.setAttribute('aria-label', 'Deshacer');
    btnRehacer.title = 'Rehacer (Ctrl+Y)'; btnRehacer.setAttribute('aria-label', 'Rehacer');
    barraHist.appendChild(btnDeshacer); barraHist.appendChild(btnRehacer);
    // móvil: deshacer/rehacer van en la barra de arriba del editor (con Editar, Capas y el zoom), no sobre el lienzo
    (esMovil() ? host : edl).appendChild(barraHist);
    /* ---------- zoom ----------
       Zoom+ agranda el lienzo (redimensionar, sin transformaciones CSS: el
       arrastre sigue midiendo en px de verdad) hasta que el recuadro de la
       zona llena el visor, y el visor se desplaza para centrarlo. Zoom−
       vuelve al ancho de antes. Mientras está activo, los reajustes de
       ventana solo actualizan el ancho base. */
    var zoom = { activo: false, base: null, w: 0, h: 0, foco: null };
    var barraZoom = document.createElement('div');
    barraZoom.className = 'edl__zoom';
    var btnZoomMas = boton('edl__zoom__b', '🔍+'), btnZoomMenos = boton('edl__zoom__b', '🔍−');
    btnZoomMas.title = 'Acercar la zona de impresión'; btnZoomMas.setAttribute('aria-label', 'Acercar');
    btnZoomMenos.title = 'Ver el producto entero'; btnZoomMenos.setAttribute('aria-label', 'Alejar');
    barraZoom.appendChild(btnZoomMas); barraZoom.appendChild(btnZoomMenos);
    host.appendChild(barraZoom);
    function redimensionarInterno(nuevo) {
      nuevo = Math.round(nuevo);
      if (!nuevo || Math.abs(nuevo - ancho) < 4) return;
      var pos = posicionesCm();
      ancho = nuevo;
      dibujarFondo();
      if (usaFoto && !(fotoImg && fotoImg.naturalWidth)) posPendiente = pos;
      else recolocar(pos);
      if (zoom.activo) centrarZoom();
    }
    function pintarZoom() {
      btnZoomMas.disabled = zoom.activo; btnZoomMenos.disabled = !zoom.activo;
      if (veloCarga && !veloCarga.hidden) ponVelo();
      host.classList.toggle('is-zoom', zoom.activo);
    }
    function centrarZoom() {
      if (!zoom.activo) return;
      if (zoom.foco) {   // sobre un elemento: por su posición real en pantalla (el lienzo puede ir centrado en el visor)
        var er = zoom.foco.getBoundingClientRect(), vr = visor.getBoundingClientRect();
        visor.scrollLeft = Math.max(0, visor.scrollLeft + (er.left - vr.left) + er.width / 2 - vr.width / 2);
        visor.scrollTop = Math.max(0, visor.scrollTop + (er.top - vr.top) + er.height / 2 - vr.height / 2);
        return;
      }
      var fb = caja;
      var cl = parseFloat(fb.style.left) || 0, ct = parseFloat(fb.style.top) || 0;
      var cw = parseFloat(fb.style.width) || 0, ch = parseFloat(fb.style.height) || 0;
      visor.scrollLeft = Math.max(0, edl.offsetLeft + cl + cw / 2 - zoom.w / 2);
      visor.scrollTop = Math.max(0, edl.offsetTop + ct + ch / 2 - zoom.h / 2);
    }
    function zoomMas() {
      if (zoom.activo) return;
      var r = visor.getBoundingClientRect();
      zoom.w = Math.round(r.width); zoom.h = Math.round(r.height);
      if (zoom.foco && host.classList.contains('is-qfondo')) {   // pantalla de quitar fondo: todo el hueco de la tarjeta
        zoom.w = Math.max(80, host.clientWidth - 12); zoom.h = Math.max(80, host.clientHeight - 12);
      }
      /* Lienzo alto y estrecho (delantal, bloc): el visor del tamaño del lienzo dejaba una
         tira estrecha que cortaba la prenda por los lados (Xavi, 30/09: "si hago zoom se corta
         la imagen"). Con zoom el visor se ensancha hasta el hueco de la columna (sin pasar de 0,9
         veces su alto), y así se ve más prenda a los lados de la zona. */
      if (!zoom.foco && zoom.h > zoom.w * 1.25) {
        zoom.w = Math.max(zoom.w, Math.round(Math.min(host.clientWidth || zoom.w, zoom.h * 0.9)));
      }
      var fb = zoom.foco || caja;
      var cw = parseFloat(fb.style.width) || 0, ch = parseFloat(fb.style.height) || 0;
      if (!zoom.w || !zoom.h || !cw || !ch) return;
      zoom.base = ancho; zoom.activo = true;
      visor.style.width = zoom.w + 'px'; visor.style.height = zoom.h + 'px';
      var k = Math.min((zoom.w - 32) / cw, (zoom.h - 32) / ch);
      k = Math.max(zoom.foco ? 0.5 : 1.1, Math.min(4, k));
      redimensionarInterno(Math.round(ancho * k));
      pintarZoom(); centrarZoom();
    }
    function zoomMenos() {
      if (!zoom.activo) return;
      zoomAuto = false;
      if (host.classList.contains('is-zona-chica')) seleccionar(null);   // de lejos no se edita nada
      zoom.activo = false;
      visor.style.width = ''; visor.style.height = ''; visor.scrollLeft = 0; visor.scrollTop = 0;
      var b = zoom.base; zoom.base = null;
      if (b) redimensionarInterno(b);
      pintarZoom();
    }
    btnZoomMas.addEventListener('click', zoomMas);
    btnZoomMenos.addEventListener('click', zoomMenos);
    /* Con zoom, pulsar FUERA de la zona de impresión (y no sobre un diseño ni sus tiradores) aleja el zoom (Xavi, 01/10).
       No cuenta si se acaba de arrastrar o tocar un elemento, ni en la pantalla de quitar fondo (zoom.foco). */
    /* Zona pequeña vista de lejos: el primer toque SOLO acerca (no selecciona ni mueve nada); las modificaciones
       van en el segundo toque, ya con zoom (Xavi, 01/10). Va en fase de captura para llegar antes que el diseño. */
    visor.addEventListener('pointerdown', function (ev) {
      if (!host.classList.contains('is-zona-chica') || zoom.activo) return;
      if (ev.target.closest('button, .edl__opc, .edl__zoom')) return;
      var rz = caja.getBoundingClientRect();
      var dentro = ev.clientX >= rz.left && ev.clientX <= rz.right && ev.clientY >= rz.top && ev.clientY <= rz.bottom;
      if (!dentro && !ev.target.closest('.edl__el')) return;
      ev.stopPropagation(); ev.preventDefault();
      seleccionar(null);   // sin nada seleccionado: el primer toque solo acerca
      zoomMas();
    }, true);
    var salirZoomPulsado = null;
    visor.addEventListener('pointerdown', function (ev) {
      salirZoomPulsado = (zoom.activo && !zoom.foco && !ev.target.closest('.edl__el, .edl__ti, .edl__opc, button')) ? { x: ev.clientX, y: ev.clientY } : null;
    }, true);
    visor.addEventListener('pointerup', function (ev) {
      var p0 = salirZoomPulsado; salirZoomPulsado = null;
      if (!p0 || !zoom.activo || zoom.foco) return;
      if (Math.abs(ev.clientX - p0.x) > 6 || Math.abs(ev.clientY - p0.y) > 6) return;      // era un desplazamiento del visor
      var r = caja.getBoundingClientRect();
      if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) zoomMenos();
    });
    pintarZoom();
    function pintarHistoria() {
      btnDeshacer.disabled = historia.length < 2;
      btnRehacer.disabled = futuro.length === 0;
    }
    function anotarHistoria() {
      temporizadorHist = null;
      if (restaurando) return;
      /* Las imágenes grandes (data: de varios MB tras quitar fondo o teñir) se guardan UNA vez en `fuentesHist` y cada paso del
         historial solo lleva su número: antes cada paso (hasta 60) copiaba la imagen entera dentro del JSON y en el móvil la
         pestaña se quedaba sin memoria y Chrome la mataba («¡Vaya! Se ha producido un error al mostrar esta página»). */
      var fo = foto();
      fo.elementos.forEach(function (e) {
        if (!e.src || e.src.length < 500) return;
        var k = idxFuenteHist.get(e.src);
        if (k == null) { k = fuentesHist.length; fuentesHist.push(e.src); idxFuenteHist.set(e.src, k); }
        e.srcRef = k; delete e.src;
      });
      var f = JSON.stringify(fo);
      if (historia.length && historia[historia.length - 1] === f) return;
      historia.push(f);
      if (historia.length > HIST_MAX) historia.shift();
      futuro = [];
      pintarHistoria();
    }
    function programarHistoria() {
      if (restaurando) return;
      clearTimeout(temporizadorHist);
      temporizadorHist = setTimeout(anotarHistoria, 350);
    }
    function restaurar(json) {
      restaurando = true;
      clearTimeout(temporizadorHist); temporizadorHist = null;
      var est = JSON.parse(json);
      est.elementos.forEach(function (e) { if (e.srcRef != null) { e.src = fuentesHist[e.srcRef]; delete e.srcRef; } });
      var z = vistas.filter(function (v) { return v.id === est.vista; })[0];
      if (z && z !== zona) cambiarVista(z);
      cargarEstado(est);
      pintarHistoria();
      // las mutaciones del restaurado llegan después, en el siguiente tick: se dejan pasar
      setTimeout(function () { restaurando = false; }, 400);
    }
    function deshacer() {
      if (historia.length < 2) return;
      futuro.push(historia.pop());
      restaurar(historia[historia.length - 1]);
    }
    function rehacer() {
      if (!futuro.length) return;
      var f = futuro.pop();
      historia.push(f);
      restaurar(f);
    }
    btnDeshacer.addEventListener('click', deshacer);
    btnRehacer.addEventListener('click', rehacer);
    if (window.MutationObserver) {
      new MutationObserver(programarHistoria).observe(caja, { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['style', 'src', 'class'] });
    }
    anotarHistoria(); // el punto de partida (vacío)
    pintarHistoria();

    function reajustarFuentes() {
      if (!document.fonts || !document.fonts.load) return;
      var pedir = {};
      elementos.forEach(function (e) { if (e.tipo === 'texto' && e.t) pedir[(e.t.style.fontWeight || 'normal') + ' 1em ' + e.t.style.fontFamily] = 1; });
      function ir() {
        Promise.all(Object.keys(pedir).map(function (f) { return document.fonts.load(f).catch(function () {}); })).then(function () {
          elementos.forEach(function (e) { if (e.tipo === 'texto') e.aplicar(); });
        });
      }
      var lk = document.getElementById('edl-fuentes');
      if (lk && !lk.sheet) lk.addEventListener('load', ir, { once: true });
      ir();
    }
    /* Un diseño guardado en otro producto (o en otra zona de este) cae en otro sitio de la superficie: se recoloca en la zona
       de ahora conservando la composición (misma proporción entre elementos, centrada) y se reduce lo justo para que quepa. */
    function adaptarAZona(est) {
      var z = est.zonaCm;
      if (!z || !z.v || !z.a || !(z.a[0] > 0) || !(z.a[1] > 0)) return est;
      var nv = ventanaDe(zona), na = Col.area(zona);
      var igual = Math.abs(nv[0] - z.v[0]) < 0.05 && Math.abs(nv[1] - z.v[1]) < 0.05 && Math.abs(na[0] - z.a[0]) < 0.05 && Math.abs(na[1] - z.a[1]) < 0.05;
      if (igual) return est;
      var k = Math.min(na[0] / z.a[0], na[1] / z.a[1]);
      var ocx = z.v[0] + z.a[0] / 2, ocy = z.v[1] + z.a[1] / 2, ncx = nv[0] + na[0] / 2, ncy = nv[1] + na[1] / 2;
      est.elementos.forEach(function (d) {
        if (d.fondo) { d.cx = ncx; d.cy = ncy; d.w = na[0]; d.h = na[1]; d.wRef = na[0]; d.hRef = na[1]; return; }   // un fondo llena la zona de ahora
        d.cx = ncx + (d.cx - ocx) * k; d.cy = ncy + (d.cy - ocy) * k;
        d.w *= k; d.h *= k; d.wRef = (d.wRef || d.w / k) * k; d.hRef = (d.hRef || d.h / k) * k;
      });
      return est;
    }
    function cargarEstado(est) {
      if (!est || !est.elementos) return;
      est = adaptarAZona(est);
      elementos.slice().forEach(function (e) { borrar(e); });
      var pos = [], conTec = [];
      if (tecnicas && est.tecnicas) {   // la técnica de cada zona, antes de montar nada
        tecPorVista = {};
        vistas.forEach(function (z) {
          var t = tecnicas.filter(function (x) { return x.id === est.tecnicas[z.id]; })[0];
          if (t) tecPorVista[z.id] = t;
        });
        tec = tecPorVista[zona.id] || tecnicas[0];
        vistas.forEach(function (z) { tecElegida[z.id] = true; });
      }
      est.elementos.forEach(function (d) {
        var dummy = { left: 0, top: 0, w: 10, h: 10, rot: d.rot || 0, volteado: !!d.volteado };
        var el;
        if (d.tipo === 'texto') {
          el = ponerTexto({ texto: d.texto, fontFamily: d.fontFamily, color: d.color, fontWeight: d.fontWeight,
            fontStyle: d.fontStyle, textDecoration: d.textDecoration, bordeAncho: d.bordeAncho || 0, bordeColor: d.bordeColor,
            left: 0, top: 0, w: 10, h: 10, rot: d.rot || 0 });
          if (d.dorsal) { el.dorsal = d.dorsal; estiloDorsal(el); }
          if (d.bloqueado) bloquear(el);
        } else {
          el = ponerImagen(d.src || (d.hueco ? placeholderHueco(d.w, d.h) : URL.createObjectURL(d.imagen)), dummy);
          el._tecAuto = true;   // viene guardada: su técnica no se elige sola
          if (d.hueco) marcarHueco(el);
          if (d.deco) { el.deco = true; el.div.classList.add('edl__el--deco'); }   // marco de una plantilla: adorno, no se toca
          if (d.bloqueado) bloquear(el);
          el.original = d.original || null;
          if (d.arreglos && d.arreglos.length) { el.arreglos = d.arreglos.slice(); el.srcOriginal = el.srcOriginal || null; }
          if (d.mono) { el.mono = d.mono; tintar(el); }
          if (tecnicas && !d.fondo) conTec.push({ el: el, d: d });
          if (d.difuminado) { el.difuminado = d.difuminado; el.difumEstilo = d.difumEstilo || ''; aplicarDifuminado(el); }
          if (d.fondo) {
            el.fondo = true; el.colorFondo = d.colorFondo || null;
            el.div.classList.add('edl__el--fondo');
            elementos.splice(elementos.indexOf(el), 1); elementos.unshift(el);
            caja.insertBefore(el.div, caja.querySelector('.edl__el'));
            pos.unshift({ cx: d.cx, cy: d.cy, w: d.w, h: d.h, wRef: d.wRef || d.w, hRef: d.hRef || d.h });
            if (d.visible === false) ocultar(el, true);
            return;
          }
        }
        pos.push({ cx: d.cx, cy: d.cy, w: d.w, h: d.h, wRef: d.wRef || d.w, hRef: d.hRef || d.h });
        if (d.visible === false) ocultar(el, true);
      });
      recolocar(pos);
      // con las imágenes ya en su zona, cada una recupera sus ajustes y la técnica de SU zona
      conTec.forEach(function (x) {
        var e = x.el, d = x.d;
        e.nCol = d.nCol || null; e.colQuita = d.colQuita || null; e.colCambia = d.colCambia || null;
        e.tintaElegida = d.tintaElegida || null; e.monoTec = !!d.monoTec; e.semitono = !!d.semitono;
        if (d.fondoBlanco !== undefined) e.fondoBlanco = d.fondoBlanco;
        e.mono = d.mono || null;
        if (e.mono || tecActiva(e)) tintar(e);
      });
      refrescarSubir();
      seleccionar(null);
      refrescarCapas();
      // las fuentes de Google pueden llegar después: se piden una a una y, cuando están, se reajustan los textos
      // (con solo fonts.ready, un texto medido con la letra de reserva se quedaba ancho al cargar la buena)
      reajustarFuentes();
    }

    /* Mockup para el pedido: la foto de la taza (teñida del color) con el
       diseño montado encima, recortado con la forma de la taza: lo mismo
       que ve el cliente en pantalla. Solo en una vista con foto. */
    function mockup(w) {
      if (!usaFoto || !fotoImg || !fotoImg.naturalWidth) return null;
      w = w || 800;
      var k = w / ancho, h = Math.round(ancho * fotoImg.naturalHeight / fotoImg.naturalWidth * k);
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
      pintarTaza(ctx, w, h, zona.espejo);
      var ppcm = 40, comp = componer(ppcm);
      var L = parseFloat(caja.style.left) * k, T = parseFloat(caja.style.top) * k;
      var W = parseFloat(caja.style.width) * k, H = parseFloat(caja.style.height) * k;
      ctx.save();
      if (ultimosPuntos && ultimosPuntos.length) {
        ctx.beginPath();
        ultimosPuntos.forEach(function (p, i) { if (i) ctx.lineTo(L + p[0] * k, T + p[1] * k); else ctx.moveTo(L + p[0] * k, T + p[1] * k); });
        ctx.closePath(); ctx.clip();
      }
      var v = ventanaDe(zona), a = Col.area(zona);
      ctx.drawImage(comp, v[0] * ppcm, v[1] * ppcm, a[0] * ppcm, a[1] * ppcm, L, T, W, H);
      var x = externos[zona.id];
      if (x && x.img && x.img.naturalWidth) {
        var esc = escalaPxCm();
        ctx.drawImage(x.img, L + ((x.cx - v[0]) * esc - x.w * esc / 2) * k, T + ((x.cy - v[1]) * esc - x.h * esc / 2) * k,
          x.w * esc * k, x.h * esc * k);
      }
      ctx.restore();
      return c;
    }

    /* Sublimación: el blanco no lleva tinta, así que en el archivo de
       producción se quita (Xavi). A partir de 248 en los tres canales es
       transparente del todo; entre 236 y 248 se desvanece, para no dejar
       bordes duros en degradados y sombras claras. Solo el archivo: la
       vista previa no cambia (blanco sobre taza blanca se ve igual). */
    /* Deja transparente el blanco. `umbral`: a partir de qué valor mínimo
       de canal es blanco (248 por defecto, sublimación: solo el blanco
       puro); con 236 entra también el "casi blanco" de los JPG con fondo
       blanco (camiseta blanca, Xavi: "si va en prenda blanca quitaría el
       blanco"). Los 12 valores por debajo se difuminan. */
    function quitarBlanco(c, umbral) {
      umbral = umbral || 248;
      var ctx = c.getContext('2d');
      // por franjas de 256 filas: un getImageData de todo el lienzo (4 bytes por píxel, de golpe) tumba la pestaña en el móvil
      for (var y0 = 0; y0 < c.height; y0 += 256) {
        var d = ctx.getImageData(0, y0, c.width, Math.min(256, c.height - y0)), p = d.data;
        for (var i = 0; i < p.length; i += 4) {
          var mn = Math.min(p[i], p[i + 1], p[i + 2]);
          if (mn >= umbral) p[i + 3] = 0;
          else if (mn > umbral - 12) p[i + 3] = Math.round(p[i + 3] * (umbral - mn) / 12);
        }
        ctx.putImageData(d, 0, y0);
      }
      return c;
    }
    /* Lo mismo con el negro, para la prenda negra (Xavi: "y lo mismo el
       negro"): transparente lo que tiene los tres canales por debajo de
       `umbral` (24 por defecto), con 12 valores de difuminado por encima. */
    function quitarNegro(c, umbral) {
      umbral = umbral || 24;
      var ctx = c.getContext('2d');
      for (var y0 = 0; y0 < c.height; y0 += 256) {
        var d = ctx.getImageData(0, y0, c.width, Math.min(256, c.height - y0)), p = d.data;
        for (var i = 0; i < p.length; i += 4) {
          var mx = Math.max(p[i], p[i + 1], p[i + 2]);
          if (mx <= umbral) p[i + 3] = 0;
          else if (mx < umbral + 12) p[i + 3] = Math.round(p[i + 3] * (mx - umbral) / 12);
        }
        ctx.putImageData(d, 0, y0);
      }
      return c;
    }

    dibujarFondo();

    /* En el móvil, "atrás" cierra lo que esté abierto (panel de compra,
       capas) en vez de irse de la web (Xavi). Al abrir se apunta un paso en
       el historial; al volver atrás se cierra; al cerrar con el botón se
       retira ese paso para que "atrás" no tenga que pulsarse dos veces. */
    var abiertos = {}; // nombre → función que cierra
    /* Cada paso que se apunta lleva su profundidad (i) sobre la ficha del
       producto (i = 0): así "Salir" sabe cuántos pasos hay que deshacer para
       salir de verdad, aunque hubiera algún panel abierto de por medio. */
    function empujar(nombre) {
      var i = (history.state && history.state.i != null ? history.state.i : 0) + 1;
      history.pushState({ edl: nombre, i: i }, '');
    }
    function historialAbrir(nombre, cerrarFn) {
      if (!esMovil() || abiertos[nombre]) return;
      abiertos[nombre] = cerrarFn;
      try { empujar(nombre); } catch (e) { /* sin historial, sin más */ }
    }
    function historialCerrar(nombre) {
      if (!abiertos[nombre]) return;
      delete abiertos[nombre];
      // el popstate que provoca este back es nuestro: no es "salir"
      if (history.state && history.state.edl === nombre) {
        retirando++; clearTimeout(retirandoT); retirandoT = setTimeout(function () { retirando = 0; }, 2000);
        try { history.back(); } catch (e) { retirando = Math.max(0, retirando - 1); }
      }
    }
    /* cuántos «atrás» propios hay en marcha: si se encadenan dos (cerrar un panel y volver a abrirlo al cargar una composición), cada
       popstate se tiene que reconocer como nuestro; con un solo true/false el segundo saltaba la pregunta de salir (probado con la taza en móvil) */
    var retirando = 0, retirandoT = 0;
    /* Y con algo diseñado, "atrás" no se va sin preguntar (Xavi): se apunta
       un paso de guardia; al volver atrás sobre él se vuelve a apuntar y se
       enseña la pregunta; "Salir" retrocede de verdad. */
    var guardia = false, saliendo = false;
    function ponerGuardia() {
      if (guardia || !esMovil()) return;
      guardia = true;
      try { empujar('guardia'); } catch (e) { guardia = false; }
    }
    var cajaSalir = document.createElement('div');
    cajaSalir.className = 'edl__salir'; cajaSalir.hidden = true;
    cajaSalir.innerHTML = '<div class="edl__salir__c" role="dialog" aria-modal="true">' +
      '<p class="edl__salir__t">¿Salir sin añadir al carrito?</p>' +
      '<p class="edl__salir__p">Tu diseño se perderá.</p>' +
      '<button type="button" class="edl__salir__b edl__salir__b--seguir">Seguir diseñando</button>' +
      '<button type="button" class="edl__salir__b edl__salir__b--salir">Salir</button></div>';
    document.body.appendChild(cajaSalir);
    cajaSalir.querySelector('.edl__salir__b--seguir').addEventListener('click', function () { cajaSalir.hidden = true; });
    cajaSalir.querySelector('.edl__salir__b--salir').addEventListener('click', function () {
      cajaSalir.hidden = true; saliendo = true; guardia = false;
      var pasos = (history.state && history.state.i != null ? history.state.i : 1) + 1;
      var url0 = location.href;
      try { history.go(-pasos); } catch (e) { /* nada */ }
      /* Si no había a dónde volver (se abrió la ficha en una pestaña nueva o desde un enlace), el
         historial no se mueve: entonces a la colección del producto, o al inicio. */
      setTimeout(function () {
        if (location.href !== url0 || document.hidden) return;
        var a = document.querySelector('.breadcrumb a, [data-coleccion-url]');
        location.href = (a && a.getAttribute('href')) || '/';
      }, 700);
    });
    window.addEventListener('popstate', function () {
      if (retirando > 0) { retirando--; return; }
      if (Date.now() < selectorHasta) {
        // "atrás" del selector de archivos: se repone lo que haya saltado y ni caso
        selectorHasta = 0;
        if (guardia) { try { empujar('guardia'); } catch (e) { /* nada */ } }
        return;
      }
      var habia = Object.keys(abiertos);
      habia.forEach(function (n) { var f = abiertos[n]; delete abiertos[n]; f(); });
      if (habia.length || saliendo || !guardia) return;
      // se ha retrocedido sobre la guardia: se repone y se pregunta
      if (hayDiseño()) {
        try { empujar('guardia'); } catch (e) { guardia = false; }
        cajaSalir.hidden = false;
      } else guardia = false;
    });

    var ctrl = {
      componer: componer,
      /* Cuántos píxeles por cm tiene de verdad lo puesto en una cara (la mayor resolución de sus imágenes): componer el archivo por
         encima de eso solo agranda el peso y el tiempo sin ganar nitidez. Infinity si hay texto (es vector: se compone a máxima). */
      /* El rectángulo (en cm de la superficie) que ocupan, con su giro, los elementos de una cara: los pasos que recorren todos los
         píxeles del archivo (quitar blanco o negro) solo hacen falta ahí; el resto de la ventana (28 × 40 cm) está vacío. */
      cajaContenido: function (recorte) {
        var pos = posicionesCm(), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        elementos.forEach(function (e, i) {
          if (!e.visible || e.ejemplo) return;
          var q = pos[i]; if (!q) return;
          if (recorte && !(q.cx >= recorte.x && q.cx < recorte.x + recorte.w)) return;
          var a = (e.st && e.st.rot ? e.st.rot : 0) * Math.PI / 180, co = Math.abs(Math.cos(a)), si = Math.abs(Math.sin(a));
          var hw = (q.w * co + q.h * si) / 2, hh = (q.w * si + q.h * co) / 2;
          x0 = Math.min(x0, q.cx - hw); x1 = Math.max(x1, q.cx + hw); y0 = Math.min(y0, q.cy - hh); y1 = Math.max(y1, q.cy + hh);
        });
        return x0 === Infinity ? null : { x0: x0, y0: y0, x1: x1, y1: y1 };
      },
      /* Una firma de TODO lo que cambia el archivo que se manda (qué hay, dónde, a qué tamaño, con qué colores y técnica). Sirve para
         saber si el archivo preparado antes de pulsar «Añadir» sigue valiendo. No lleva las imágenes enteras: su tamaño y su final. */
      firma: function () {
        var pos = posicionesCm(), partes = [];
        elementos.forEach(function (e, i) {
          if (e.ejemplo && !e.hueco) return;
          var q = pos[i] || {}, st = e.st || {};
          var im = e.tipo === 'imagen' ? (e.img && e.img.src) || '' : '';
          partes.push([e.tipo, e.visible ? 1 : 0, e.fondo ? 1 : 0, e.colorFondo || '', Math.round((q.cx || 0) * 100), Math.round((q.cy || 0) * 100), Math.round((q.w || 0) * 100), Math.round((q.h || 0) * 100),
            Math.round(st.rot || 0), st.volteado ? 1 : 0, e.mono || '', e.nCol || '', JSON.stringify(e.colQuita || null), JSON.stringify(e.colCambia || null), e.semitono ? 1 : 0,
            e.tintaElegida || '', e.difuminado || 0, e.dorsal ? 1 : 0, im.length, im.slice(-48), (e.srcBase || '').length,
            e.tipo === 'texto' ? [e.t.textContent, e.t.style.fontFamily, e.t.style.color, e.t.style.fontWeight, e.t.style.fontStyle, e.bordeAncho || '', e.borde ? e.borde.ancho + e.borde.color : ''].join('~') : ''].join('|'));
        });
        var t = vistas.map(function (z) { var T = z === zona ? tec : (tecPorVista[z.id] || (tecnicas && tecnicas[0])); return z.id + ':' + (T ? T.id : ''); }).join(',');
        return partes.join('\n') + '\n#' + t;
      },
      ppcmFuente: function (recorte) {
        var pos = posicionesCm(), tope = 0, texto = false;
        elementos.forEach(function (e, i) {
          if (!e.visible || e.ejemplo) return;
          var q = pos[i]; if (!q) return;
          if (recorte && !(q.cx >= recorte.x && q.cx < recorte.x + recorte.w)) return;
          if (e.tipo === 'imagen') { var nw = e.img && e.img.naturalWidth; if (nw && q.w > 0) tope = Math.max(tope, nw / q.w); }
          else texto = true;
        });
        return (texto || !tope) ? Infinity : tope;
      },
      mockup: mockup,
      esSello: function () { return !!o.tintaFija; },
      abrirImpresion: abrirImpresion,
      // la ✕ de la barra de arriba (móvil): igual que «atrás»: con algo diseñado pregunta, y si no, sale
      pedirSalir: function () { if (hayDiseño()) { cajaSalir.hidden = false; } else { cajaSalir.querySelector('.edl__salir__b--salir').click(); } },
      historialAbrir: function (n, f) { historialAbrir(n, f); },
      historialCerrar: function (n) { historialCerrar(n); },
      hayDiseno: function () { return elementos.some(function (e) { return !e.ejemplo; }); },
      /* Para el bloque «¿Cómo se imprime?» de la columna derecha (ropa.js): las técnicas, la de la zona que se ve, y cambiarla
         igual que en el panel «Impresión». */
      /* Colores de la zona que se ve (serigrafía multicolor): los que lleva el diseño ahora y el máximo; y si lo que hay es una foto. */
      coloresZona: function () {
        if (!tecnicas || !tec || !(tec.colores > 1)) return null;
        var ims = imagenesTec(), foto = false;
        ims.forEach(function (e) { var r = riquezaColor(e); if (r && r.ricos >= 13) foto = true; });
        var n = coloresUnion(zona, tec);   // todo lo de la zona se imprime a la vez: cuentan los colores distintos entre todos los diseños
        return ims.length ? { n: Math.max(1, Math.min(tec.colores, n)), max: tec.colores, rec: 4, foto: foto, negro: ims.some(function (e) { return e.negroOculto; }), compartido: ims.length > 1 && ims.some(function (e) { return e.colCompartidos; }) } : null;
      },
      fijarColores: function (n) {
        if (!tecnicas || !tec || !(tec.colores > 1)) return;
        n = Math.max(2, Math.min(tec.colores, n));
        imagenesTec().forEach(function (e) { e.nCol = n; e.colQuita = null; e.colCambia = null; tintar(e); });
        if (refrescarImpresion) refrescarImpresion();
        avisarCambio();
      },
      hayFotoSerigrafia: function () {
        if (!tecnicas || !tec || !/serigraf/i.test(tec.nombre || '')) return false;
        return imagenesTec().some(function (e) { var r = riquezaColor(e); return r && r.ricos >= 13; });
      },
      tecnicasLista: function () {
        if (!tecnicas || !tec) return null;
        return { zona: vistas.length > 1 ? (zona.nombre || zona.id) : '', actual: tec.id, lista: tecnicas.map(function (t) { return { id: t.id, nombre: t.nombre, desc: t.desc || '', colores: t.colores }; }) };
      },
      fijarTecnica: function (id) {
        var t = tecnicas && tecnicas.filter(function (x) { return x.id === id; })[0];
        if (!t || t === tec) return;
        tec = t; tecPorVista[zona.id] = t; tecElegida[zona.id] = true;
        imagenesTec().forEach(function (e) { reiniciarColores(e); aplicarTec(e); });
        if (refrescarImpresion) refrescarImpresion();
        avisarCambio();
      },
      tecnicaInfo: function () { return tec ? { id: tec.id, nombre: tec.nombre, colores: tec.colores } : null; },
      // la técnica de cada zona que lleva diseño: [{ vista, nombre de la zona, id, nombre, colores }]
      /* Antes de cobrar: espera a que todas las imágenes de serigrafía multicolor tengan ya su paleta (los colores de verdad que llevan);
         si alguna no ha arrancado la reducción, la lanza. Sin esto, un diseño sin paleta contaba como «el máximo de colores». */
      esperarPaletas: function (ms) {
        return new Promise(function (ok) {
          var t0 = Date.now(), lanzadas = false;
          (function paso() {
            var falta = imagenesTec(true).filter(function (e) { var T = tecDe(e); return T && T.colores > 1 && !e.mono && !e.fondo && !e.paleta; });
            if (!falta.length || Date.now() - t0 > ms) { ok(!falta.length); return; }
            // solo se lanza (una vez) la reducción de la que no ha arrancado; las demás se esperan sin repetir trabajo
            if (!lanzadas) { lanzadas = true; falta.forEach(function (e) { if (!e._reduciendo) tintar(e); }); }
            setTimeout(paso, 200);
          })();
        });
      },
      tecnicasPorZona: function () {
        if (!tecnicas) return [];
        return vistas.filter(function (z) { return tieneDiseñoEn(z); }).map(function (z) {
          var T = z === zona ? tec : (tecPorVista[z.id] || tecnicas[0]);
          // colores que de verdad lleva el diseño en esta zona (cada uno es una pantalla): el mayor de sus imágenes (paleta tras reducir/quitar) o 1 si es texto
          var usados = 1;
          if (T.colores > 1) {
            usados = coloresUnion(z, T);   // colores distintos entre TODAS las imágenes de la zona (comparten pantallas)
            elementos.forEach(function (e) {
              if (!e.visible || e.ejemplo || e.dorsal || e.fondo || vistaDe(e) !== z || e.tipo === 'imagen') return;
              var n = 1;   // sin paleta aún (la reducción es asíncrona): un valor bajo, no el máximo; al pedir se espera a que esté
              if (n > usados) usados = n;
            });
            usados = Math.max(1, Math.min(T.colores, usados));
          }
          return { vista: z.id, zona: z.nombre || z.id, id: T.id, nombre: T.nombre, colores: T.colores, usados: usados, pantallas: T.pantallas || usados };
        });
      },
      /* sellos: el diseño de la zona actual sola (tinta sobre transparente) a `ppcm` px/cm, para la vista previa a tamaño real */
      disenoZona: function (ppcm) {
        var comp = componer(ppcm), v = ventanaDe(zona), a = Col.area(zona);
        var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(a[0] * ppcm)); c.height = Math.max(1, Math.round(a[1] * ppcm));
        var cx = c.getContext('2d');
        if (zona.forma === 'circulo') { cx.beginPath(); cx.ellipse(c.width / 2, c.height / 2, c.width / 2, c.height / 2, 0, 0, Math.PI * 2); cx.clip(); }
        cx.drawImage(comp, v[0] * ppcm, v[1] * ppcm, a[0] * ppcm, a[1] * ppcm, 0, 0, c.width, c.height);
        return { canvas: c, wMm: a[0] * 10, hMm: a[1] * 10, circulo: zona.forma === 'circulo', nombre: zona.nombre || '' };
      },
      estado: estado,
      proyecto: proyecto,
      fotoEnSerigrafia: fotoEnSerigrafia,
      riquezaImagenes: function () { return imagenesTec(true).map(function (e) { return riquezaColor(e); }); },
      cargarEstado: cargarEstado,
      /* Aplica una plantilla (mismo formato que foto(): elementos en cm sobre la superficie) y vuelve a la vista que pida. */
      plantilla: function (est) {
        cargarEstado(est);
        elementos.forEach(bloquear);   // lo que trae una plantilla no se mueve ni cambia de tamaño: se cambian sus textos y fotos
        if (est.vista) ctrl.cambiarVista(est.vista);
        avisarCambio();
      },
      /* Composición hecha con piezas de la biblioteca: igual que una plantilla, pero SIN bloquear nada (el cliente mueve, gira y cambia el tamaño de todo) */
      composicion: function (est) {
        cargarEstado(est);
        if (est.vista) ctrl.cambiarVista(est.vista);
        avisarCambio();
      },
      huecosVacios: function () { return elementos.filter(function (e) { return e.hueco; }).length; },
      /* asistente de montaje de la taza: rellena los huecos de foto (en el orden del montaje) con las fotos que eligió el cliente; null = lo deja vacío */
      /* panel «Personaliza» de PC: cambia la foto del hueco número i (los huecos de un montaje, llenos o vacíos, en orden) */
      rellenarHueco: function (i, f) { var hs = elementos.filter(function (e) { return e.hueco || e.deHueco; }); if (f && hs[i]) llenarHueco(hs[i], f); },
      huecosMontaje: function () { return elementos.filter(function (e) { return e.hueco || e.deHueco; }).length; },
      rellenarHuecos: function (archivos, pans) { var hs = elementos.filter(function (e) { return e.hueco; }); (archivos || []).forEach(function (f, i) { if (f && hs[i]) llenarHueco(hs[i], f, pans && pans[i]); }); },
      quitarBlanco: quitarBlanco,
      quitarNegro: quitarNegro,
      // los archivos originales de las imágenes visibles (sin repetidos)
      // los fondos blancos o negros que el cliente ha dejado sobre una prenda de otro color (para el albarán)
      fondosPendientes: function () {
        var out = [];
        elementos.forEach(function (e) { if (e.visible && fondoPendiente(e) && out.indexOf(e.fondoDetectado) === -1) out.push(e.fondoDetectado); });
        return out;
      },
      // los arreglos hechos a las imágenes visibles (para la nota del pedido)
      arreglos: function () {
        var out = [];
        elementos.forEach(function (e) { if (e.visible && e.arreglos) e.arreglos.forEach(function (a) { if (out.indexOf(a) === -1) out.push(a); }); });
        return out;
      },
      originales: function () {
        var out = [];
        elementos.forEach(function (e) { if (e.visible && e.original && out.indexOf(e.original) === -1) out.push(e.original); });
        return out;
      },
      hayDiseño: hayDiseño,
      pppMinimo: pppMinimo,
      setPppMin: setPppMin,
      setColor: function (hex, nombre) {
        var antes = usaBlanca(), pos = posicionesCm(), neg0 = prendaNegra();
        setTimeout(function () { comprobarFondos(); refrescarOpciones(); }, 0);
        color = hex || color;
        // con foto por color, al cambiar de color cambia la foto de la vista
        if (nombre !== undefined && nombre !== o.colorNombre) { o.colorNombre = nombre; fijarVista(zona); }
        dibujarFondo();
        if (usaBlanca() !== antes) recolocar(pos);
        // pasar a o desde una prenda negra cambia qué cuenta como tinta (el negro): se vuelve a calcular la paleta
        if (prendaNegra() !== neg0) imagenesTec(true).forEach(function (e) { var T = tecActiva(e); if (T && T.colores > 1 && !e.mono && !e.fondo) tintar(e); });
        // serigrafía con tinta por defecto: al cambiar el color de la prenda, la tinta se vuelve a elegir (blanca/negra)
        imagenesTec(true).forEach(function (e) { var T = tecActiva(e); if (T && T.tintaLibre && T.colores === 1 && !e.tintaElegida) aplicarTec(e); });
      },
      añadirImagen: function () { modoFondo = false; huecoPendiente = null; pedirImagenAsis(); },
      añadirFondo: function () { modoFondo = true; huecoPendiente = null; pedirImagen(); },
      /* Pone una imagen que ya tenemos (p. ej. de la biblioteca de dibujos), igual que si el cliente la hubiera subido */
      ponerPieza: function (file, esFondo) {
        modoFondo = false; huecoPendiente = null;
        var url = URL.createObjectURL(file), el = esFondo ? ponerFondo(url) : ponerImagen(url);
        if (el) el.original = file; else originalPendiente = file;
      },
      imagenSeleccionada: function () { return imagenSel(); },
      sustituirImagen: function (el, url, tipo) { sustituirImagen(el, url, tipo); },
      /* Guarda un archivo en «Tus últimas imágenes» (lo usa foto-ia.js con cada dibujo o fondo quitado por la IA, para poder reutilizarlo sin gastar otro intento) */
      guardarReciente: function (f) { Recientes.guardar(f); },
      colorFondo: function () { inpColorFondo.click(); },
      /* Fondo de la taza como en las banderas: color liso, degradado y/o textura (fondos-lienzo.js). spec = { c: [hex, hex…], t: 'v|d|r', tx: 'puntos', f: 1 }.
         Un color liso sin textura sigue siendo «Color de fondo» (lleva el hex para producción); lo demás, una imagen a 100 px/cm como blob. */
      fondoSpec: function (spec) {
        if (!spec || !spec.c) return;
        var liso = spec.c.length < 2 || spec.c[0] === spec.c[1];
        if (liso && !spec.tx) {
          var url = lienzoColor(spec.c[0]), act = fondoActual();
          if (act && act.colorFondo) { act.img.src = url; act.colorFondo = spec.c[0]; avisarCambio(); }
          else ponerFondo(url, spec.c[0]);
          return;
        }
        if (!window.FondosLienzo) return;
        var cv = document.createElement('canvas');
        cv.width = Math.round(anchoTotalCm * 100); cv.height = Math.round(altoTotalCm * 100);
        window.FondosLienzo.pintar(cv, anchoTotalCm, altoTotalCm, { c: liso ? [spec.c[0], spec.c[0]] : spec.c, t: spec.t || 'v', tx: spec.tx || '', f: spec.f || 1, e: spec.e || 0.5 });
        cv.toBlob(function (b) { if (b) ponerFondo(URL.createObjectURL(b), null); }, 'image/jpeg', 0.92);
      },
      hayFondo: function () { return !!fondoActual(); },
      sinFondo: function () { var act = fondoActual(); if (act) { borrar(act); avisarCambio(); } },
      añadirTexto: function () { ponerTexto(); },
      quitarFondo: quitarFondo,
      hayImagen: function () { return elementos.some(function (e) { return e.tipo === 'imagen'; }); },
      seleccionado: function () { return seleccionado; },
      elementos: function () { return elementos.slice(); },
      vista: function () { return zona; },
      vistas: function () { return vistas.slice(); },
      // móvil: el panel de capas se abre/cierra desde la barra superior
      alternarCapas: function () {
        var abre = !cajaCapas.classList.contains('is-abierto');
        cajaCapas.classList.toggle('is-abierto', abre);
        if (abre) historialAbrir('capas', function () { cajaCapas.classList.remove('is-abierto'); });
        else historialCerrar('capas');
      },
      deshacer: deshacer, rehacer: rehacer,
      /* Qué ocupa el diseño dentro de la ventana de una vista, en cm: la
         caja envolvente de los elementos visibles que caen en ella (recortada
         a la ventana) y si hay fondo. Para el precio por tramo de tamaño. */
      ocupadoEn: function (z) {
        var v = z.ventana || [0, 0], a = Col.area(z), pos = posicionesCm();
        var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, fondo = false, n = 0;
        /* zona de cajas (los dos pechos): se mide cada caja por separado, que es lo que se imprime; cuenta cuántas llevan algo */
        var cs = cajasDe(z), grupos = {};
        elementos.forEach(function (e, i) {
          if (!e.visible || e.ejemplo) return;
          if (e.fondo) { fondo = true; return; }
          var q = pos[i]; if (!q) return;
          var ex0 = Math.max(q.cx - q.w / 2, v[0]), ex1 = Math.min(q.cx + q.w / 2, v[0] + a[0]);
          var ey0 = Math.max(q.cy - q.h / 2, v[1]), ey1 = Math.min(q.cy + q.h / 2, v[1] + a[1]);
          if (ex1 - ex0 < 0.05 || ey1 - ey0 < 0.05) return;
          n++; x0 = Math.min(x0, ex0); y0 = Math.min(y0, ey0); x1 = Math.max(x1, ex1); y1 = Math.max(y1, ey1);
          if (cs) {
            var k = 0, dm = Infinity;
            cs.forEach(function (c, j) { var d = Math.abs((q.cx - v[0]) - (c[0] + c[2] / 2)); if (d < dm) { dm = d; k = j; } });
            var g = grupos[k] = grupos[k] || { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };
            g.x0 = Math.min(g.x0, ex0); g.y0 = Math.min(g.y0, ey0); g.x1 = Math.max(g.x1, ex1); g.y1 = Math.max(g.y1, ey1);
          }
        });
        if (fondo) return { fondo: true, w: a[0], h: a[1], n: n, x: 0, y: 0 };
        if (!n) return null;
        if (cs) {
          var gs = Object.keys(grupos).map(function (k) { return grupos[k]; });
          return { fondo: false, w: Math.max.apply(null, gs.map(function (g) { return g.x1 - g.x0; })),
                   h: Math.max.apply(null, gs.map(function (g) { return g.y1 - g.y0; })), n: n, cajas: gs.length, x: x0 - v[0], y: y0 - v[1] };
        }
        return { fondo: false, w: x1 - x0, h: y1 - y0, n: n, x: x0 - v[0], y: y0 - v[1] };
      },
      cerrarCapas: function () { cajaCapas.classList.remove('is-abierto'); historialCerrar('capas'); },
      historialAbrir: historialAbrir, historialCerrar: historialCerrar,
      abrirOpciones: abrirOpciones,
      pedirDorsal: function () { if (typeof o.onDorsal === 'function') o.onDorsal(); },
      añadirDorsal: function () { ponerDorsal(); },
      tieneDiseño: function () { return elementos.some(function (e) { return e.visible && !e.ejemplo && !e.dorsal; }); },
      setDorsal: setDorsal, hayDorsal: hayDorsal, dorsalInfo: dorsalInfo, tieneDiseñoEn: tieneDiseñoEn,
      /* Firma barata del diseño (posiciones, ajustes y técnicas, sin las imágenes): sirve para saber si ha cambiado algo de verdad.
         No cambia al cambiar de vista, que es justo lo que hace la vista previa de la compra. */
      firma: function () {
        var f = foto();
        return JSON.stringify({ e: f.elementos.map(function (b) { var c = {}; Object.keys(b).forEach(function (k) { if (k !== 'src') c[k] = b[k]; }); c.sl = (b.src || '').length; return c; }), t: f.tecnicas });
      },
      alComprar: function () { return typeof o.alComprar === 'function' ? o.alComprar() : null; },
      hayCantidad: function () { return typeof o.hayCantidad === 'function' ? !!o.hayCantidad() : true; },
      pedirPrevia: function () { if (typeof o.onCompra === 'function') o.onCompra(); },
      /* Cambiar el ancho del lienzo sin perder nada: los elementos pasan a
         cm, se repinta el fondo al ancho nuevo y se recolocan. Lo usa
         ropa.js al terminar de cargar la página y al cambiar la ventana. */
      redimensionar: function (nuevo) {
        // con zoom activo, el nuevo ancho es el de "ver entero": se aplica al salir del zoom
        if (zoom.activo) { zoom.base = Math.round(nuevo); return; }
        redimensionarInterno(nuevo);
      },
      zoomMas: zoomMas, zoomMenos: zoomMenos,
      ancho: function () { return ancho; },
      /* Poner o quitar la capa externa de una vista: { src, cx, cy, w, h } en
         cm sobre la superficie (null la quita). */
      capaExterna: function (vistaId, x) {
        if (!x) { delete externos[vistaId]; pintarExternos(); return; }
        var img = new Image(); img.src = x.src;
        externos[vistaId] = { src: x.src, cx: x.cx, cy: x.cy, w: x.w, h: x.h, img: img };
        pintarExternos();
      },
      /* Las vistas en las que hay algo puesto (imagen, texto o dorsal visible
         cuyo centro cae en su ventana): para la vista previa ampliada. */
      vistasConDiseño: function () {
        var pos = posicionesCm();
        return vistas.filter(function (z) {
          var v = z.ventana || [0, 0], a = Col.area(z);
          return elementos.some(function (e, i) {
            var q = pos[i];
            return e.visible && !e.ejemplo && q && q.cx >= v[0] && q.cx < v[0] + a[0];
          });
        }).map(function (z) { return z.id; });
      },
      cambiarVista: function (id) {
        var z = vistas.filter(function (v) { return v.id === id; })[0];
        if (z) cambiarVista(z);
      },
      // los elementos de cualquier vista (la actual o una guardada)
      // misma lista en todas las vistas (una sola superficie)
      elementosDe: function () { return elementos.slice(); },
      posicionesCm: posicionesCm
    };
    cablearRail(host, ctrl);

    /* Diagnóstico sin consola: con #edl-debug en la URL, un aviso con dónde
       ha quedado el recuadro límite y cómo se está pintando. */
    if (location.hash === '#edl-debug') {
      setTimeout(function () {
        var r = seguro.getBoundingClientRect(), cs = getComputedStyle(seguro);
        alert('edl__seguro\nstyle: ' + seguro.getAttribute('style') + '\ndisplay: ' + cs.display + ' · visibility: ' + cs.visibility + ' · opacity: ' + cs.opacity +
          '\nborde: ' + cs.borderTopWidth + ' ' + cs.borderTopStyle + ' ' + cs.borderTopColor +
          '\nrect: ' + Math.round(r.left) + ',' + Math.round(r.top) + ' ' + Math.round(r.width) + 'x' + Math.round(r.height) +
          '\ncaja: ' + caja.getAttribute('style') + '\nlienzo: ' + lienzo.width + 'x' + lienzo.height + ' · zoom(dpr): ' + window.devicePixelRatio);
      }, 1500);
    }
    if (o.tintaFija) botonPKPrint(ctrl);
    /* El diseño que viene del carrito («Así quedaría tu diseño en…», Xavi 19/10): al pulsar un producto de esa tira, carrito-mockups.js lo deja
       en sessionStorage y aquí se pone solo, como si el cliente lo acabara de subir. Se usa una sola vez y solo si es reciente. */
    try {
      var pend = sessionStorage.getItem('imp_diseno_carrito');
      if (pend) {
        sessionStorage.removeItem('imp_diseno_carrito');
        var po = JSON.parse(pend);
        if (po && po.src && Date.now() - po.t < 30 * 60 * 1000 && window.DataTransfer && window.File) {
          fetch(po.src).then(function (r) { return r.blob(); }).then(function (b) {
            if (!b || !b.size || elementos.length) return;       // si ya hay algo puesto, no se pisa
            var f = new File([b], 'tu-diseno.png', { type: b.type || 'image/png' });
            var dt = new DataTransfer(); dt.items.add(f);
            entrada.files = dt.files;
            entrada.dispatchEvent(new Event('change'));
          }).catch(function () { /* sin diseño: queda el editor vacío, como siempre */ });
        }
      }
    } catch (e0) { /* sin sessionStorage */ }

    return ctrl;
  }

  /* Los botones fijos del rail (Añadir imagen/texto) viven en el HTML fuera
     del host —es hermano suyo, en product-media-gallery.liquid—, así que
     quien lo llama (ropa.js) no tiene que saber nada de ellos. Las cajas de
     opciones por tipo las crea montar() y las mete en el mismo rail. */
  /* SELLOS: la vista previa enseña la tinta tal como sale en el papel y a TAMAÑO REAL. Una pantalla no sabe cuánto mide un milímetro
     (en el móvil el «mm» de CSS sale más pequeño que el de verdad), así que la primera vez se calibra con algo que todos tienen: una
     tarjeta de banco (85,6 mm). La escala se recuerda en el navegador. */
  function abrirVistaSello(ctrl) {
    var d = ctrl.disenoZona(120), clave = 'edl-pxmm', def = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ? 6.3 : 3.78, f = def;
    var calibrada = false;
    try { var g = parseFloat(localStorage.getItem(clave)); if (g > 1 && g < 20) { f = g; calibrada = true; } } catch (e) { /* sin almacenamiento */ }
    var v = document.createElement('div'); v.className = 'edl__ver edl__ver--real'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-label', 'Vista previa a tamaño real');
    v.innerHTML = '<button type="button" class="edl__ver__x" aria-label="Cerrar la vista previa">×</button>' +
      '<div class="edl__real"><p class="edl__real__t">Tu sello a tamaño real (aproximado)</p><p class="edl__real__s"></p>' +
      '<div class="edl__real__papel"><div class="edl__real__zona" data-zona></div></div>' +
      '<p class="edl__real__n">Es la tinta tal como saldrá en el papel. El texto muy fino puede perder detalle si el sello es pequeño.</p>' +
      '<details class="edl__real__cal"><summary>Ajusta el tamaño a tu pantalla con una tarjeta</summary>' +
      '<p>Cada pantalla tiene su resolución y el navegador no sabe cuánto mide un milímetro. Pon una tarjeta de banco sobre la pantalla y mueve el control hasta que el rectángulo mida lo mismo (85,6 mm de ancho).</p>' +
      '<div class="edl__real__tarjeta" data-tarjeta></div><input type="range" min="2" max="12" step="0.02" data-escala aria-label="Escala de la pantalla"></details></div>';
    var zona = v.querySelector('[data-zona]'), tarjeta = v.querySelector('[data-tarjeta]'), rango = v.querySelector('[data-escala]');
    v.querySelector('.edl__real__s').textContent = d.nombre + ' · ' + (Math.round(d.wMm * 10) / 10) + ' × ' + (Math.round(d.hMm * 10) / 10) + ' mm';
    d.canvas.style.cssText = 'display:block;width:100%;height:100%'; zona.appendChild(d.canvas);
    if (d.circulo) zona.style.borderRadius = '50%';
    function aplicar() {
      zona.style.width = (d.wMm * f) + 'px'; zona.style.height = (d.hMm * f) + 'px';
      tarjeta.style.width = (85.6 * f) + 'px'; tarjeta.style.height = (54 * f) + 'px'; rango.value = f;
    }
    rango.addEventListener('input', function () { f = parseFloat(rango.value) || f; aplicar(); try { localStorage.setItem(clave, String(f)); } catch (e) { /* nada */ } });
    var cerrar = function () { if (v.parentNode) v.parentNode.removeChild(v); document.removeEventListener('keydown', tecla); };
    var tecla = function (e) { if (e.key === 'Escape') cerrar(); };
    v.querySelector('.edl__ver__x').addEventListener('click', cerrar);
    v.addEventListener('click', function (e) { if (e.target === v) cerrar(); });
    document.addEventListener('keydown', tecla);
    document.body.appendChild(v); aplicar();
    if (!calibrada) v.querySelector('.edl__real__cal').open = true;   // la primera vez se ofrece el ajuste con la tarjeta
  }


  /* TEMPORAL (Xavi, 04/10): botón «A6 PKPrint» que, con el sello ya diseñado, descarga la hoja de producción de PKPrint en PDF (A6: título del
     modelo, el diseño en positivo en la zona y, debajo, el bloque negro con el diseño en negativo). Mismas medidas que .taller/sellos/hoja_sello.py.
     Solo se ve en el navegador de quien abre la ficha con ?pk=1 (queda recordado); el cliente no lo ve. Cuando sobre, se borra esta función. */
  var HOJAS_PK = {
    M2: ['MODICO 2', [36.4, 52.8, 37.0, 11.0], [34.5, 73.7, 43.0, 16.0]],
    M3: ['MODICO 3', [23.4, 64.0, 49.0, 15.0], [23.0, 109.7, 53.0, 20.0]],
    M5: ['MODICO 5', [29.4, 34.9, 63.0, 24.0], [22.0, 77.1, 70.0, 32.0]],
    I8: ['i8', [48.5, 70.0, 8.0, 8.0], null]
  };
  function hojaPK(ctrl) {
    var z = ctrl.vista(), w = ((z.cajas && z.cajas[0]) || [5, 2])[0];
    var k = w >= 6 ? 'M5' : (w >= 4.5 ? 'M3' : (w >= 2 ? 'M2' : 'I8')), H = HOJAS_PK[k], MMPX = 47.24;   // 1200 ppp
    var d = ctrl.disenoZona(300), W = Math.round(105 * MMPX), Hh = Math.round(148 * MMPX);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = Hh;
    var g = cv.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, W, Hh);
    function tinta(color) {   // el diseño a una sola tinta, conservando la transparencia
      var c = document.createElement('canvas'); c.width = d.canvas.width; c.height = d.canvas.height;
      var x = c.getContext('2d'); x.drawImage(d.canvas, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, c.width, c.height); return c;
    }
    function poner(c, zx, zy, zw, zh) { g.imageSmoothingQuality = 'high'; g.drawImage(c, zx * MMPX, zy * MMPX, zw * MMPX, zh * MMPX); }
    g.fillStyle = '#000'; g.textAlign = 'center'; g.font = 'bold ' + (24 / 72 * 25.4 * MMPX) + 'px Helvetica, Arial, sans-serif'; g.fillText(H[0], 52.5 * MMPX, 22 * MMPX);
    poner(tinta('#000'), H[1][0], H[1][1], H[1][2], H[1][3]);
    if (H[2]) {
      var b = H[2]; g.fillStyle = '#000'; g.fillRect(b[0] * MMPX, b[1] * MMPX, b[2] * MMPX, b[3] * MMPX);
      poner(tinta('#fff'), b[0] + b[2] / 2 - H[1][2] / 2, b[1] + b[3] / 2 - H[1][3] / 2, H[1][2], H[1][3]);
    }
    // a 1 bit (negro puro o blanco) y empaquetado en un PDF A6
    var px = g.getImageData(0, 0, W, Hh).data, fila = (W + 7) >> 3, bits = new Uint8Array(fila * Hh), i, x2, y2;
    for (y2 = 0; y2 < Hh; y2++) for (x2 = 0; x2 < W; x2++) { if (px[(y2 * W + x2) * 4] >= 128) bits[y2 * fila + (x2 >> 3)] |= 0x80 >> (x2 & 7); }
    var nombre = 'sello-' + k.toLowerCase() + '-A6-pkprint';
    function bajar(blob, ext) { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = nombre + ext; document.body.appendChild(a); a.click(); setTimeout(function () { a.remove(); URL.revokeObjectURL(a.href); }, 4000); }
    if (typeof CompressionStream !== 'function') { cv.toBlob(function (bl) { bajar(bl, '.png'); }, 'image/png'); return; }
    new Response(new Blob([bits]).stream().pipeThrough(new CompressionStream('deflate'))).arrayBuffer().then(function (buf) {
      var datos = new Uint8Array(buf), partes = [], largo = 0, offs = [];
      function t(txt) { var u = new Uint8Array(txt.length); for (var j = 0; j < txt.length; j++) u[j] = txt.charCodeAt(j) & 255; partes.push(u); largo += u.length; }
      function obj(n, cuerpo) { offs[n] = largo; t(n + ' 0 obj\n' + cuerpo + '\nendobj\n'); }
      var pw = (105 * 72 / 25.4).toFixed(3), ph = (148 * 72 / 25.4).toFixed(3), cont = 'q ' + pw + ' 0 0 ' + ph + ' 0 0 cm /Im0 Do Q';
      t('%PDF-1.4\n');
      obj(1, '<< /Type /Catalog /Pages 2 0 R >>');
      obj(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
      obj(3, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + pw + ' ' + ph + '] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>');
      obj(4, '<< /Length ' + cont.length + ' >>\nstream\n' + cont + '\nendstream');
      offs[5] = largo; t('5 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + W + ' /Height ' + Hh + ' /ColorSpace /DeviceGray /BitsPerComponent 1 /Filter /FlateDecode /Length ' + datos.length + ' >>\nstream\n');
      partes.push(datos); largo += datos.length; t('\nendstream\nendobj\n');
      var xr = largo; t('xref\n0 6\n0000000000 65535 f \n');
      for (i = 1; i <= 5; i++) t(('0000000000' + offs[i]).slice(-10) + ' 00000 n \n');
      t('trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xr + '\n%%EOF');
      bajar(new Blob(partes, { type: 'application/pdf' }), '.pdf');
    });
  }
  function botonPKPrint(ctrl) {
    var on = false;
    try { if (/[?&]pk=1\b/.test(location.search)) localStorage.setItem('edl-pk', '1'); if (/[?&]pk=0\b/.test(location.search)) localStorage.removeItem('edl-pk'); on = localStorage.getItem('edl-pk') === '1'; } catch (e) { on = /[?&]pk=1\b/.test(location.search); }
    if (!on || document.querySelector('.edl__pk')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'edl__pk'; b.textContent = 'A6 PKPrint (temporal)';
    b.addEventListener('click', function () { try { hojaPK(ctrl); } catch (e) { window.alert('No he podido generar la hoja: ' + e.message); } });
    document.body.appendChild(b);
  }

  function abrirVistaPrevia(ctrl) {
    if (ctrl.esSello && ctrl.esSello()) { abrirVistaSello(ctrl); return; }
    var actual = ctrl.vista().id, ids = [], cs = [];
    try { ids = ctrl.vistasConDiseño(); } catch (e) { ids = []; }
    if (!ids.length) ids = [actual];
    try {
      ids.forEach(function (id) {
        if (id !== ctrl.vista().id) ctrl.cambiarVista(id);
        var m = ctrl.mockup(ids.length > 1 ? 900 : 1400);
        if (m) cs.push(m);
      });
    } catch (e) { /* se queda con lo que haya salido */ }
    if (ctrl.vista().id !== actual) ctrl.cambiarVista(actual);
    // todas las vistas en una sola imagen: en vertical si la pantalla es alta
    var c = null;
    if (cs.length === 1) c = cs[0];
    else if (cs.length > 1) {
      var vertical = window.innerHeight > window.innerWidth;
      c = document.createElement('canvas');
      c.width = vertical ? Math.max.apply(null, cs.map(function (m) { return m.width; })) : cs.reduce(function (n, m) { return n + m.width; }, 0);
      c.height = vertical ? cs.reduce(function (n, m) { return n + m.height; }, 0) : Math.max.apply(null, cs.map(function (m) { return m.height; }));
      var cx = c.getContext('2d'), pos = 0;
      cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);
      cs.forEach(function (m) { if (vertical) { cx.drawImage(m, 0, pos); pos += m.height; } else { cx.drawImage(m, pos, 0); pos += m.width; } });
    }
    var v = document.createElement('div');
    v.className = 'edl__ver';
    v.setAttribute('role', 'dialog'); v.setAttribute('aria-label', 'Vista previa');
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'edl__ver__x'; x.setAttribute('aria-label', 'Cerrar la vista previa'); x.textContent = '×';
    v.appendChild(x);
    var cerrar = function () { if (v.parentNode) v.parentNode.removeChild(v); document.removeEventListener('keydown', tecla); };
    var tecla = function (e) { if (e.key === 'Escape') cerrar(); };
    x.addEventListener('click', cerrar);
    if (c) {
      c.className = 'edl__ver__c'; v.appendChild(c);
      var wa = document.createElement('button');
      wa.type = 'button'; wa.className = 'edl__ver__wa';
      wa.innerHTML = '<svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2a9.9 9.9 0 0 0-8.46 15.02L2 22l5.12-1.34A9.9 9.9 0 1 0 12.04 2zm0 1.8a8.1 8.1 0 1 1-4.13 15.06l-.3-.18-3.04.8.81-2.96-.2-.31A8.1 8.1 0 0 1 12.04 3.8zm-3.3 4.1c-.17 0-.45.06-.69.32-.24.26-.9.88-.9 2.15s.92 2.5 1.05 2.67c.13.17 1.8 2.86 4.44 3.9 2.2.87 2.65.7 3.13.65.48-.04 1.54-.63 1.76-1.24.22-.6.22-1.13.15-1.24-.06-.1-.24-.17-.5-.3-.27-.13-1.54-.76-1.78-.85-.24-.09-.41-.13-.59.13-.17.26-.68.85-.83 1.02-.15.17-.3.2-.56.07-.26-.13-1.1-.4-2.1-1.3-.77-.69-1.3-1.54-1.45-1.8-.15-.26-.02-.4.11-.53.12-.12.26-.3.4-.46.13-.15.17-.26.26-.44.09-.17.04-.33-.02-.46-.07-.13-.59-1.42-.81-1.95-.21-.5-.43-.44-.59-.45h-.5z"/></svg><span>Enviar por WhatsApp</span>';
      wa.addEventListener('click', function (e) {
        e.stopPropagation();
        var titulo = (document.title || '').split('|')[0].trim();
        var texto = 'Mira cómo me queda: ' + titulo + ' ' + location.href.split('#')[0].split('?')[0];
        c.toBlob(function (blob) {
          var file = blob && new File([blob], 'mi-diseno-imprimirlo.jpg', { type: 'image/jpeg' });
          if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
            // móvil: hoja de compartir con la imagen, y ahí WhatsApp
            navigator.share({ files: [file], text: texto }).catch(function () {});
          } else {
            // PC: se baja la imagen y se abre WhatsApp con el texto, para adjuntarla
            if (blob) {
              var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'mi-diseno-imprimirlo.jpg';
              document.body.appendChild(a); a.click(); a.remove();
            }
            window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
          }
        }, 'image/jpeg', 0.9);
      });
      v.appendChild(wa);
    } else {
      var n = document.createElement('p'); n.className = 'edl__ver__n';
      n.textContent = 'Esta vista no tiene vista previa ampliada.'; v.appendChild(n);
    }
    v.addEventListener('click', cerrar);
    document.addEventListener('keydown', tecla);
    document.body.appendChild(v);
  }

  function cablearRail(host, ctrl) {
    window.__edl = ctrl;           // para módulos que se enganchan al editor (foto-ia.js)
    var raiz = host.closest('.rop-libre-wrap') || document;
    /* móvil: la página queda fija mientras se edita, igual que el editor de las tarjetas (Xavi, 21/10); la página de compra (?comprar=) sí se mueve */
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches && !/[?&](completo|comprar)=/.test(location.search)) {
      document.documentElement.classList.add('edl-fijo');
      /* sin zoom de pellizco en el editor del móvil (Xavi, 25/10/2026): la página va fija y el zoom del propio editor es la lupa; Chrome obedece al meta viewport,
         iOS Safari lo ignora y hace falta frenar el gesto */
      try {
        var mv = document.querySelector('meta[name="viewport"]');
        if (mv && !/user-scalable/.test(mv.content)) mv.content += ',maximum-scale=1,user-scalable=no';
        document.addEventListener('gesturestart', function (ev) { ev.preventDefault(); }, { passive: false });
        document.addEventListener('touchmove', function (ev) { if (ev.touches && ev.touches.length > 1) ev.preventDefault(); }, { passive: false });
      } catch (e) { /* sin bloqueo */ }
    }
    var botonImg = raiz.querySelector('[data-libre-subir]');
    if (botonImg) botonImg.addEventListener('click', function () { if (window.TazaPlantillas) window.TazaPlantillas.cerrar(); ctrl.añadirImagen(); });
    var botonTxt = raiz.querySelector('[data-libre-texto]');
    if (botonTxt) botonTxt.addEventListener('click', function () { if (window.TazaPlantillas) window.TazaPlantillas.cerrar(); ctrl.añadirTexto(); });
    // taza: plantillas de ejemplo (taza-plantillas.js se carga solo en esa ficha)
    raiz.querySelectorAll('[data-libre-plantillas]').forEach(function (bp) {
      bp.addEventListener('click', function () { ctrl.cerrarCapas(); var pl = window.SelloPlantillas || window.CojinPlantillas || window.TazaPlantillas; if (pl) pl.abrir(ctrl); });
    });
    /* taza en móvil: al entrar ya sale Plantillas debajo (como las tarjetas), sin hueco vacío bajo la taza */
    if (raiz.classList.contains('rop-libre-wrap--fondos-ventana') && !/[?&](completo|comprar)=/.test(location.search)) {
      var intentos = 0, esperaPl = setInterval(function () {
        intentos++;
        if (window.TazaPlantillas && window.TazaPlantillas.abrir) {
          clearInterval(esperaPl);
          var tematica = window.IMP_TAZA_TEMA && window.IMP_TAZA_TEMA !== 'fotos';   // tazas por tema: «Elige tu estilo» a pantalla completa también en PC
          if (tematica || (window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) window.TazaPlantillas.abrir(ctrl);
        }
        else if (intentos > 20) clearInterval(esperaPl);
      }, 250);
    }
    /* camiseta con tema (Xavi, 25/10/2026): al entrar sale «Elige tu camiseta de …» a pantalla completa, también en PC */
    if (window.IMP_CAMISETA_TEMA && !/[?&](completo|comprar)=/.test(location.search)) {
      var intentosCam = 0, esperaCam = setInterval(function () {
        intentosCam++;
        if (window.TazaPlantillas && window.TazaPlantillas.abrir) { clearInterval(esperaCam); window.TazaPlantillas.abrir(ctrl); }
        else if (intentosCam > 30) clearInterval(esperaCam);
      }, 250);
    }
    raiz.querySelectorAll('[data-libre-sorpresa]').forEach(function (bs) {
      bs.addEventListener('click', function () { ctrl.cerrarCapas(); if (window.TazaPlantillas && window.TazaPlantillas.sorpresa) window.TazaPlantillas.sorpresa(ctrl); });
    });
    raiz.querySelectorAll('[data-libre-salir]').forEach(function (bx) { bx.addEventListener('click', function () { ctrl.pedirSalir(); }); });
    raiz.querySelectorAll('[data-libre-biblio]').forEach(function (bb) {
      bb.addEventListener('click', function () { ctrl.cerrarCapas(); if (window.TazaPlantillas && window.TazaPlantillas.abrirBiblio) window.TazaPlantillas.abrirBiblio(ctrl); });
    });
    raiz.querySelectorAll('[data-libre-impresion]').forEach(function (bi) { bi.addEventListener('click', function () { ctrl.cerrarCapas(); ctrl.abrirImpresion(); }); });
    var botonDorNuevo = raiz.querySelector('[data-libre-dorsal-nuevo]');
    if (botonDorNuevo) botonDorNuevo.addEventListener('click', function () { ctrl.añadirDorsal(); });
    raiz.querySelectorAll('[data-libre-fondos-abrir]').forEach(function (bf) {
      bf.addEventListener('click', function () { ctrl.cerrarCapas(); if (window.TazaPlantillas) window.TazaPlantillas.abrirFondos(ctrl); });
    });
    var botonFondo = raiz.querySelector('[data-libre-fondo]');
    if (botonFondo) botonFondo.addEventListener('click', function () { ctrl.añadirFondo(); });
    var botonColor = raiz.querySelector('[data-libre-color-fondo]');
    if (botonColor) botonColor.addEventListener('click', function () { ctrl.colorFondo(); });

    /* ---------- móvil: modo "app" ----------
       Barra inferior fija (Imagen · Texto · Fondo · Comprar); "Fondo" abre
       un mini-menú con los dos botones de fondo; "Comprar" sube el panel
       de compra (la columna de la derecha en PC) sobre la taza; "Capas"
       en la barra superior abre el panel de capas. Todo con clases; el
       CSS decide cuándo se ve cada cosa. */
    var menuFondo = raiz.querySelector('[data-libre-fondo-menu]'), fondos = raiz.querySelector('[data-libre-fondos]');
    if (menuFondo && fondos) {
      menuFondo.addEventListener('click', function (ev) {
        ev.stopPropagation();
        // taza: el botón «Fondo» abre la ventana de fondos (color, degradado, textura), no el mini-menú
        if (window.TazaPlantillas && raiz.querySelector('[data-libre-fondos-abrir]')) { ctrl.cerrarCapas(); window.TazaPlantillas.abrirFondos(ctrl); return; }
        ctrl.cerrarCapas(); // el mini-menú no debe quedar detrás del panel de capas
        fondos.classList.toggle('is-abierto');
      });
      fondos.addEventListener('click', function () { fondos.classList.remove('is-abierto'); });
      document.addEventListener('click', function (ev) { if (!fondos.contains(ev.target) && ev.target !== menuFondo) fondos.classList.remove('is-abierto'); });
    }
    /* Vista previa (Xavi, 01/10): el montaje grande y limpio, sin recuadros
       ni asas ni bolitas; lo mismo que se guarda como mockup del pedido. */
    raiz.querySelectorAll('[data-libre-ver]').forEach(function (bv) {
      bv.addEventListener('click', function () { ctrl.cerrarCapas(); abrirVistaPrevia(ctrl); });
    });
    var botonCapas = raiz.querySelector('[data-libre-capas]');
    if (botonCapas) botonCapas.addEventListener('click', function () { ctrl.alternarCapas(); });
    var botonOpciones = raiz.querySelector('[data-libre-opciones]');
    if (botonOpciones) botonOpciones.addEventListener('click', function () { ctrl.abrirOpciones(); });

    // móvil: el panel de opciones (texto/imagen) se cierra al tocar fuera de él o en la barra de abajo
    document.addEventListener('pointerdown', function (ev) {
      if (host.classList.contains('is-sin-panel') || !(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) return;
      var t = ev.target;
      if (!t.closest || t.closest('.edl__opc, .edl__el, .edl__ti, .edl__zoom, .edl__historia, .edl__recientes, .edl__salir')) return;
      if (t.closest('.rop-libre-rail, .rop-libre-top, .edl')) host.classList.add('is-sin-panel');
    }, true);

    var comprar = raiz.querySelector('[data-libre-comprar]');
    var prod = host.closest('.product'), info = prod && prod.querySelector('.product__info-wrapper');
    if (comprar && info) {
      var velo = document.createElement('div');
      velo.className = 'rop-libre-velo'; velo.hidden = true;
      document.body.appendChild(velo);
      var cerrar = document.createElement('button');
      cerrar.type = 'button'; cerrar.className = 'rop-libre-cerrar'; cerrar.textContent = '‹ Seguir editando';
      info.insertBefore(cerrar, info.firstChild);
      var abrir = function (si, soloTallas, conDorsal, soloDorsal) {
        prod.classList.toggle('is-compra', si);
        prod.classList.toggle('is-solo-tallas', !!(si && soloTallas));
        prod.classList.toggle('is-con-dorsal', !!(si && conDorsal));
        prod.classList.toggle('is-solo-dorsal', !!(si && soloDorsal));
        velo.hidden = !si;
        if (si) ctrl.historialAbrir('compra', function () { abrir(false); });
        else ctrl.historialCerrar('compra');
      };
      // "Dorsales" (barra de arriba, vista de espalda): tallas + la tabla del dorsal
      var botonDorsal = raiz.querySelector('[data-libre-dorsal]');
      if (botonDorsal) botonDorsal.addEventListener('click', function () {
        ctrl.pedirDorsal();
        // su propia ventana, solo la tabla de dorsales (Xavi); sin cantidades, la tabla lo dice y manda a tallas
        abrir(true, true, true, true);
        info.scrollTop = 0;
      });
      // desde la ventana de dorsales sin cantidades: "Elegir tallas" abre la de tallas
      info.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-libre-ir-tallas]')) { abrir(true, true, false, false); info.scrollTop = 0; }
      });
      /* "Comprar" abre el panel entero, por el botón de añadir; "Color y
         talla" (camiseta) abre solo el paso 1 (color y cantidades), que
         es otra cosa (Xavi: "dos botones haciendo lo mismo"). */
      var abrirCompra = function () {
        /* "Comprar" abre el panel entero por arriba: la vista previa de lo
           que compra (ropa.js la pinta), las tallas, el precio y el botón
           (Xavi: "una especie de vista previa de lo que compras con las
           tallas y colores debajo, precio unitario y precio final"). */
        ctrl.pedirPrevia();
        abrir(true, false);
        info.scrollTop = 0;
      };
      ctrl.abrirCompra = abrirCompra;
      /* «Cantidad» = elegir; «Comprar» = resumen. Con el botón verde y sin cantidades no hay nada que resumir: se abre «Cantidad» */
      var abrirCantidad = function () { abrir(true, true); info.scrollTop = 0; };
      ctrl.abrirCantidad = abrirCantidad;
      info.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-ir-comprar]')) { e.preventDefault(); abrirCompra(); }
      });
      comprar.addEventListener('click', function () {
        /* Página de compra aparte (Xavi, 07/10: «al acabar el diseño y dar a comprar vamos a otra URL con colores y tallas y botón
           comprar, así añadimos al carro desde una página sin cargas»): ropa.js guarda el diseño y recarga la ficha con ?comprar=id.
           Si no puede (o no toca), se abre el panel aquí como siempre. */
        if (typeof ctrl.hayCantidad === 'function' && !ctrl.hayCantidad()) { abrirCantidad(); return; }
        var r = null;
        try { r = ctrl.alComprar ? ctrl.alComprar() : null; } catch (e0) { r = null; }
        if (r && typeof r.then === 'function') { r.then(function (ok) { if (!ok) abrirCompra(); }, function () { abrirCompra(); }); return; }
        if (r) return;
        abrirCompra();
      });
      var tallas = raiz.querySelector('[data-libre-tallas]');
      if (tallas) tallas.addEventListener('click', function () {
        abrir(true, true);
        info.scrollTop = 0;
      });
      velo.addEventListener('click', function () { abrir(false); });
      cerrar.addEventListener('click', function () { abrir(false); });
      // el precio dentro del botón, siempre a la vista
      var precio = prod.querySelector('.price-item'), etiqueta = comprar.querySelector('[data-libre-comprar-texto]');
      if (precio && etiqueta) etiqueta.textContent = precio.textContent.trim();
    }
  }

  /* En la ficha con editor no hay burbuja de WhatsApp (Xavi): tapaba el
     botón de comprar en el móvil. La app la inyecta con su propio código,
     así que se busca por el enlace a WhatsApp y se esconde el bloque
     flotante que lo contiene; se vigila un rato por si aparece tarde. */
  function sinWhatsapp() {
    var vistos = [];
    var barrer = function () {
      var enlaces = document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"], [class*="whatsapp" i], [id*="whatsapp" i], [class*="chatme" i], [id*="chatme" i]');
      Array.prototype.forEach.call(enlaces, function (a) {
        // el presupuesto por WhatsApp de la propia ficha (dentro del panel de compra) no es la burbuja de la app:
        // sin esto se escondía el panel entero (en móvil es position:fixed) y fallaban Cantidad y Comprar
        if (a.closest && a.closest('.product__info-wrapper, .rop-libre-rail, [data-libre-info]')) return;
        var n = a;
        for (var i = 0; i < 5 && n && n !== document.body; i++) {
          if (getComputedStyle(n).position === 'fixed') {
            if (vistos.indexOf(n) === -1) { vistos.push(n); n.style.setProperty('display', 'none', 'important'); }
            return;
          }
          n = n.parentElement;
        }
        // sin bloque fijo: se esconde el propio enlace
        if (vistos.indexOf(a) === -1) { vistos.push(a); a.style.setProperty('display', 'none', 'important'); }
      });
    };
    barrer();
    var obs = new MutationObserver(barrer);
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  window.EditorLibre = { montar: montar, sinWhatsapp: sinWhatsapp };
})();
